import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Dropdown from 'react-bootstrap/Dropdown';
import Header from '../../components/Header';
import { ventrisConfig } from '../../ventris.config';

type TestALLProps = {
};

const subtests: any = {
  'Caregiver Questionnaire': {
    fallGrades: ['PK', 'K', '1st'],
    springGrades: ['PK', 'K', '1st'],
    basalRule: null,
    discontinueRule: null,
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: false,
    scaledScoreKey: null
  },
  'Blending': {
    fallGrades: ['PK', 'K', '1st'],
    springGrades: ['PK', 'K', '1st'],
    basalRule: null,
    discontinueRule: {
      consecutiveScores: 4,
      maxScore: 0,
      perTask: false
    },
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: false,
    scaledScoreKey: null
  },
  'Word Reading': {
    fallGrades: ['K', '1st'],
    springGrades: ['PK', 'K', '1st'],
    basalRule: null,
    discontinueRule: {
      consecutiveScores: 6,
      maxScore: 0,
      perTask: false
    },
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: false,
    scaledScoreKey: null
  },
  'Nonsense Word Reading': {
    fallGrades: ['K', '1st'],
    springGrades: ['K', '1st'],
    basalRule: null,
    discontinueRule: {
      consecutiveScores: 6,
      maxScore: 0,
      perTask: false
    },
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: false,
    scaledScoreKey: null
  },
  'Emergent Writing': {
    fallGrades: ['PK', 'K', '1st'],
    springGrades: ['PK', 'K', '1st'],
    basalRule: null,
    discontinueRule: null,
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: false,
    scaledScoreKey: null
  },
  'Picture Description': {
    fallGrades: ['1st'],
    springGrades: ['1st'],
    basalRule: null,
    discontinueRule: null,
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: false,
    scaledScoreKey: null
  },
  'Letter Knowledge': {
    fallGrades: ['PK', 'K', '1st'],
    springGrades: ['PK', 'K', '1st'],
    basalRule: 2,
    discontinueRule: {
      consecutiveScores: 6,
      maxScore: 0,
      perTask: true
    },
    startingPoints: [
      {
        'PK': 1,
        'K': 1,
        '1st': 9
      },
      {
        'PK': 1,
        'K': 1,
        '1st': 7
      },
      {
        'PK': 1,
        'K': 1,
        '1st': 1
      }
    ],
    sectionVisibility: null,
    isCriterion: false,
    scaledScoreKey: 'lk',
    maxScore: 30
  },
  'Rhyme Knowledge': {
    fallGrades: ['PK', 'K', '1st'],
    springGrades: ['PK', 'K', '1st'],
    basalRule: null,
    discontinueRule: {
      consecutiveScores: 6,
      maxScore: 0,
      perTask: false
    },
    startingPoints: null,
    sectionVisibility: [
      {
        'PK': true,
        'K': true,
        '1st': true
      },
      {
        'PK': true,
        'K': true,
        '1st': true
      },
      {
        'PK': true,
        'K': true,
        '1st': true
      },
      {
        'PK': true,
        'K': true,
        '1st': false
      },
      {
        'PK': false,
        'K': false,
        '1st': true
      }
    ],
    isCriterion: false,
    scaledScoreKey: 'rk',
    maxScores: {
      'PK': 20,
      'K': 20,
      '1st': 22
    }
  },
  'Basic Concepts': {
    fallGrades: ['PK', 'K', '1st'],
    springGrades: ['PK', 'K', '1st'],
    basalRule: 2,
    discontinueRule: {
      consecutiveScores: 6,
      maxScore: 0,
      perTask: false
    },
    startingPoints: [
      {
        'PK': 1,
        'K': 7,
        '1st': 7
      }
    ],
    sectionVisibility: null,
    isCriterion: false,
    scaledScoreKey: 'bc',
    maxScore: 28
  },
  'Receptive Vocabulary': {
    fallGrades: ['PK', 'K', '1st'],
    springGrades: ['PK', 'K', '1st'],
    basalRule: 2,
    discontinueRule: {
      consecutiveScores: 6,
      maxScore: 0,
      perTask: false
    },
    startingPoints: [
      {
        'PK': 1,
        'K': 3,
        '1st': 3
      }
    ],
    sectionVisibility: null,
    isCriterion: false,
    scaledScoreKey: 'rv',
    maxScore: 20
  },
  'Parallel Sentence Production': {
    fallGrades: ['PK', 'K', '1st'],
    springGrades: ['PK', 'K', '1st'],
    basalRule: 2,
    discontinueRule: {
      consecutiveScores: 6,
      maxScore: 0,
      perTask: false
    },
    startingPoints: [
      {
        'PK': 1,
        'K': 1,
        '1st': 5
      }
    ],
    sectionVisibility: null,
    isCriterion: false,
    scaledScoreKey: 'psp',
    maxScore: 30
  },
  'Elision': {
    fallGrades: ['K', '1st'],
    springGrades: ['K', '1st'],
    basalRule: null,
    discontinueRule: {
      consecutiveScores: 6,
      maxScore: 0,
      perTask: false
    },
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: false,
    scaledScoreKey: 'el',
    maxScore: 20
  },
  'Word Relationships': {
    fallGrades: ['K', '1st'],
    springGrades: ['K', '1st'],
    basalRule: null,
    discontinueRule: {
      consecutiveScores: 6,
      maxScore: 0,
      perTask: false
    },
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: false,
    scaledScoreKey: 'wr',
    maxScore: 25
  },
  'Phonics Knowledge': {
    fallGrades: ['1st'],
    springGrades: ['K', '1st'],
    basalRule: 2,
    discontinueRule: {
      consecutiveScores: 6,
      maxScore: 0,
      perTask: false
    },
    startingPoints: [
      {
        'K': 1,
        '1st': 7
      },
      {
        'K': 1,
        '1st': 1
      },
      {
        'K': 1,
        '1st': 1
      }
    ],
    sectionVisibility: null,
    isCriterion: false,
    scaledScoreKey: 'pk',
    maxScore: 35
  },
  'Sound Categorization': {
    fallGrades: ['1st'],
    springGrades: ['K', '1st'],
    basalRule: null,
    discontinueRule: {
      consecutiveScores: 6,
      maxScore: 0,
      perTask: false
    },
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: false,
    scaledScoreKey: 'sc',
    maxScore: 16
  },
  'Sight Word Recognition': {
    fallGrades: ['1st'],
    springGrades: ['K', '1st'],
    basalRule: null,
    discontinueRule: {
      consecutiveScores: 6,
      maxScore: 0,
      perTask: false
    },
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: false,
    scaledScoreKey: 'swr',
    maxScore: 20
  },
  'Listening Comprehension': {
    fallGrades: ['PK', 'K', '1st'],
    springGrades: ['PK', 'K', '1st'],
    basalRule: null,
    discontinueRule: null,
    startingPoints: null,
    sectionVisibility: [
      {
        'PK': true,
        'K': true,
        '1st': true
      },
      {
        'PK': true,
        'K': false,
        '1st': true
      },
      {
        'PK': true,
        'K': true,
        '1st': false
      },
      {
        'PK': false,
        'K': true,
        '1st': true
      }
    ],
    isCriterion: false,
    scaledScoreKey: 'lc',
    maxScore: 21
  },
  'Book Handling': {
    fallGrades: ['PK', 'K', '1st'],
    springGrades: ['PK', 'K', '1st'],
    basalRule: null,
    discontinueRule: null,
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: true,
    scaledScoreKey: null,
    maxScore: 8
  },
  'Concept of Word': {
    fallGrades: ['1st'],
    springGrades: ['1st'],
    basalRule: null,
    discontinueRule: null,
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: true,
    scaledScoreKey: null,
    maxScore: 8
  },
  'Matching Symbols': {
    fallGrades: ['PK', 'K', '1st'],
    springGrades: ['PK', 'K', '1st'],
    basalRule: null,
    discontinueRule: null,
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: true,
    scaledScoreKey: null,
    maxScore: 9
  },
  'Word Retrieval': {
    fallGrades: ['PK', 'K', '1st'],
    springGrades: ['PK', 'K', '1st'],
    basalRule: null,
    discontinueRule: null,
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: true,
    scaledScoreKey: null,
    maxScore: 50
  },
  'Rapid Automatic Naming': {
    fallGrades: ['PK', 'K', '1st'],
    springGrades: ['PK', 'K', '1st'],
    basalRule: null,
    discontinueRule: null,
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: true,
    scaledScoreKey: null,
    maxScore: 600
  },
  'Invented Spelling': {
    fallGrades: ['1st'],
    springGrades: ['1st'],
    basalRule: null,
    discontinueRule: null,
    startingPoints: null,
    sectionVisibility: null,
    isCriterion: true,
    scaledScoreKey: null,
    maxScore: 60
  },
}

const percentileRanks: any = [
  {
    "subtest_scaled_score": "",
    "index_score": 160,
    "percentile_rank": ">99.9",
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 159,
    "percentile_rank": ">99.9",
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 158,
    "percentile_rank": ">99.9",
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 157,
    "percentile_rank": ">99.9",
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 156,
    "percentile_rank": ">99.9",
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 155,
    "percentile_rank": ">99.9",
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 154,
    "percentile_rank": ">99.9",
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 153,
    "percentile_rank": ">99.9",
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 152,
    "percentile_rank": ">99.9",
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 151,
    "percentile_rank": ">99.9",
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 150,
    "percentile_rank": ">99.9",
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 149,
    "percentile_rank": 99.9,
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 148,
    "percentile_rank": 99.9,
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 147,
    "percentile_rank": 99.9,
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 146,
    "percentile_rank": 99.9,
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": 19,
    "index_score": 145,
    "percentile_rank": 99.9,
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 144,
    "percentile_rank": 99.8,
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 143,
    "percentile_rank": 99.8,
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 142,
    "percentile_rank": 99.7,
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 141,
    "percentile_rank": 99.7,
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": 18,
    "index_score": 140,
    "percentile_rank": 99.6,
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 139,
    "percentile_rank": 99.5,
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 138,
    "percentile_rank": 99,
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 137,
    "percentile_rank": 99,
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 136,
    "percentile_rank": 99,
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": 17,
    "index_score": 135,
    "percentile_rank": 99,
    "normal_curve_equivalent": 99,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 134,
    "percentile_rank": 99,
    "normal_curve_equivalent": 98,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 133,
    "percentile_rank": 99,
    "normal_curve_equivalent": 96,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 132,
    "percentile_rank": 98,
    "normal_curve_equivalent": 95,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 131,
    "percentile_rank": 98,
    "normal_curve_equivalent": 94,
    "stanine": 9
  },
  {
    "subtest_scaled_score": 16,
    "index_score": 130,
    "percentile_rank": 98,
    "normal_curve_equivalent": 92,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 129,
    "percentile_rank": 97,
    "normal_curve_equivalent": 91,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 128,
    "percentile_rank": 97,
    "normal_curve_equivalent": 89,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 127,
    "percentile_rank": 96,
    "normal_curve_equivalent": 88,
    "stanine": 9
  },
  {
    "subtest_scaled_score": "",
    "index_score": 126,
    "percentile_rank": 96,
    "normal_curve_equivalent": 87,
    "stanine": 9
  },
  {
    "subtest_scaled_score": 15,
    "index_score": 125,
    "percentile_rank": 95,
    "normal_curve_equivalent": 85,
    "stanine": 8
  },
  {
    "subtest_scaled_score": "",
    "index_score": 124,
    "percentile_rank": 95,
    "normal_curve_equivalent": 84,
    "stanine": 8
  },
  {
    "subtest_scaled_score": "",
    "index_score": 123,
    "percentile_rank": 94,
    "normal_curve_equivalent": 82,
    "stanine": 8
  },
  {
    "subtest_scaled_score": "",
    "index_score": 122,
    "percentile_rank": 93,
    "normal_curve_equivalent": 81,
    "stanine": 8
  },
  {
    "subtest_scaled_score": "",
    "index_score": 121,
    "percentile_rank": 92,
    "normal_curve_equivalent": 79,
    "stanine": 8
  },
  {
    "subtest_scaled_score": 14,
    "index_score": 120,
    "percentile_rank": 91,
    "normal_curve_equivalent": 78,
    "stanine": 8
  },
  {
    "subtest_scaled_score": "",
    "index_score": 119,
    "percentile_rank": 90,
    "normal_curve_equivalent": 77,
    "stanine": 8
  },
  {
    "subtest_scaled_score": "",
    "index_score": 118,
    "percentile_rank": 88,
    "normal_curve_equivalent": 75,
    "stanine": 7
  },
  {
    "subtest_scaled_score": "",
    "index_score": 117,
    "percentile_rank": 87,
    "normal_curve_equivalent": 74,
    "stanine": 7
  },
  {
    "subtest_scaled_score": "",
    "index_score": 116,
    "percentile_rank": 86,
    "normal_curve_equivalent": 72,
    "stanine": 7
  },
  {
    "subtest_scaled_score": 13,
    "index_score": 115,
    "percentile_rank": 84,
    "normal_curve_equivalent": 71,
    "stanine": 7
  },
  {
    "subtest_scaled_score": "",
    "index_score": 114,
    "percentile_rank": 82,
    "normal_curve_equivalent": 70,
    "stanine": 7
  },
  {
    "subtest_scaled_score": "",
    "index_score": 113,
    "percentile_rank": 81,
    "normal_curve_equivalent": 68,
    "stanine": 7
  },
  {
    "subtest_scaled_score": "",
    "index_score": 112,
    "percentile_rank": 79,
    "normal_curve_equivalent": 67,
    "stanine": 7
  },
  {
    "subtest_scaled_score": "",
    "index_score": 111,
    "percentile_rank": 77,
    "normal_curve_equivalent": 65,
    "stanine": 7
  },
  {
    "subtest_scaled_score": 12,
    "index_score": 110,
    "percentile_rank": 75,
    "normal_curve_equivalent": 64,
    "stanine": 6
  },
  {
    "subtest_scaled_score": "",
    "index_score": 109,
    "percentile_rank": 73,
    "normal_curve_equivalent": 63,
    "stanine": 6
  },
  {
    "subtest_scaled_score": "",
    "index_score": 108,
    "percentile_rank": 70,
    "normal_curve_equivalent": 61,
    "stanine": 6
  },
  {
    "subtest_scaled_score": "",
    "index_score": 107,
    "percentile_rank": 68,
    "normal_curve_equivalent": 60,
    "stanine": 6
  },
  {
    "subtest_scaled_score": "",
    "index_score": 106,
    "percentile_rank": 66,
    "normal_curve_equivalent": 58,
    "stanine": 6
  },
  {
    "subtest_scaled_score": 11,
    "index_score": 105,
    "percentile_rank": 63,
    "normal_curve_equivalent": 57,
    "stanine": 6
  },
  {
    "subtest_scaled_score": "",
    "index_score": 104,
    "percentile_rank": 61,
    "normal_curve_equivalent": 56,
    "stanine": 6
  },
  {
    "subtest_scaled_score": "",
    "index_score": 103,
    "percentile_rank": 58,
    "normal_curve_equivalent": 54,
    "stanine": 5
  },
  {
    "subtest_scaled_score": "",
    "index_score": 102,
    "percentile_rank": 55,
    "normal_curve_equivalent": 53,
    "stanine": 5
  },
  {
    "subtest_scaled_score": "",
    "index_score": 101,
    "percentile_rank": 53,
    "normal_curve_equivalent": 51,
    "stanine": 5
  },
  {
    "subtest_scaled_score": 10,
    "index_score": 100,
    "percentile_rank": 50,
    "normal_curve_equivalent": 50,
    "stanine": 5
  },
  {
    "subtest_scaled_score": "",
    "index_score": 99,
    "percentile_rank": 47,
    "normal_curve_equivalent": 49,
    "stanine": 5
  },
  {
    "subtest_scaled_score": "",
    "index_score": 98,
    "percentile_rank": 45,
    "normal_curve_equivalent": 47,
    "stanine": 5
  },
  {
    "subtest_scaled_score": "",
    "index_score": 97,
    "percentile_rank": 42,
    "normal_curve_equivalent": 46,
    "stanine": 5
  },
  {
    "subtest_scaled_score": "",
    "index_score": 96,
    "percentile_rank": 39,
    "normal_curve_equivalent": 44,
    "stanine": 4
  },
  {
    "subtest_scaled_score": 9,
    "index_score": 95,
    "percentile_rank": 37,
    "normal_curve_equivalent": 43,
    "stanine": 4
  },
  {
    "subtest_scaled_score": "",
    "index_score": 94,
    "percentile_rank": 34,
    "normal_curve_equivalent": 42,
    "stanine": 4
  },
  {
    "subtest_scaled_score": "",
    "index_score": 93,
    "percentile_rank": 32,
    "normal_curve_equivalent": 40,
    "stanine": 4
  },
  {
    "subtest_scaled_score": "",
    "index_score": 92,
    "percentile_rank": 30,
    "normal_curve_equivalent": 39,
    "stanine": 4
  },
  {
    "subtest_scaled_score": "",
    "index_score": 91,
    "percentile_rank": 27,
    "normal_curve_equivalent": 37,
    "stanine": 4
  },
  {
    "subtest_scaled_score": 8,
    "index_score": 90,
    "percentile_rank": 25,
    "normal_curve_equivalent": 36,
    "stanine": 4
  },
  {
    "subtest_scaled_score": "",
    "index_score": 89,
    "percentile_rank": 23,
    "normal_curve_equivalent": 35,
    "stanine": 4
  },
  {
    "subtest_scaled_score": "",
    "index_score": 88,
    "percentile_rank": 21,
    "normal_curve_equivalent": 33,
    "stanine": 3
  },
  {
    "subtest_scaled_score": "",
    "index_score": 87,
    "percentile_rank": 19,
    "normal_curve_equivalent": 32,
    "stanine": 3
  },
  {
    "subtest_scaled_score": "",
    "index_score": 86,
    "percentile_rank": 18,
    "normal_curve_equivalent": 30,
    "stanine": 3
  },
  {
    "subtest_scaled_score": 7,
    "index_score": 85,
    "percentile_rank": 16,
    "normal_curve_equivalent": 29,
    "stanine": 3
  },
  {
    "subtest_scaled_score": "",
    "index_score": 84,
    "percentile_rank": 14,
    "normal_curve_equivalent": 28,
    "stanine": 3
  },
  {
    "subtest_scaled_score": "",
    "index_score": 83,
    "percentile_rank": 13,
    "normal_curve_equivalent": 26,
    "stanine": 3
  },
  {
    "subtest_scaled_score": "",
    "index_score": 82,
    "percentile_rank": 12,
    "normal_curve_equivalent": 25,
    "stanine": 3
  },
  {
    "subtest_scaled_score": "",
    "index_score": 81,
    "percentile_rank": 10,
    "normal_curve_equivalent": 23,
    "stanine": 2
  },
  {
    "subtest_scaled_score": 6,
    "index_score": 80,
    "percentile_rank": 9,
    "normal_curve_equivalent": 22,
    "stanine": 2
  },
  {
    "subtest_scaled_score": "",
    "index_score": 79,
    "percentile_rank": 8,
    "normal_curve_equivalent": 21,
    "stanine": 2
  },
  {
    "subtest_scaled_score": "",
    "index_score": 78,
    "percentile_rank": 7,
    "normal_curve_equivalent": 19,
    "stanine": 2
  },
  {
    "subtest_scaled_score": "",
    "index_score": 77,
    "percentile_rank": 6,
    "normal_curve_equivalent": 18,
    "stanine": 2
  },
  {
    "subtest_scaled_score": "",
    "index_score": 76,
    "percentile_rank": 5,
    "normal_curve_equivalent": 16,
    "stanine": 2
  },
  {
    "subtest_scaled_score": 5,
    "index_score": 75,
    "percentile_rank": 5,
    "normal_curve_equivalent": 15,
    "stanine": 2
  },
  {
    "subtest_scaled_score": "",
    "index_score": 74,
    "percentile_rank": 4,
    "normal_curve_equivalent": 13,
    "stanine": 2
  },
  {
    "subtest_scaled_score": "",
    "index_score": 73,
    "percentile_rank": 4,
    "normal_curve_equivalent": 12,
    "stanine": 2
  },
  {
    "subtest_scaled_score": "",
    "index_score": 72,
    "percentile_rank": 3,
    "normal_curve_equivalent": 11,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 71,
    "percentile_rank": 3,
    "normal_curve_equivalent": 9,
    "stanine": 1
  },
  {
    "subtest_scaled_score": 4,
    "index_score": 70,
    "percentile_rank": 2,
    "normal_curve_equivalent": 8,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 69,
    "percentile_rank": 2,
    "normal_curve_equivalent": 6,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 68,
    "percentile_rank": 2,
    "normal_curve_equivalent": 5,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 67,
    "percentile_rank": 1,
    "normal_curve_equivalent": 4,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 66,
    "percentile_rank": 1,
    "normal_curve_equivalent": 2,
    "stanine": 1
  },
  {
    "subtest_scaled_score": 3,
    "index_score": 65,
    "percentile_rank": 1,
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 64,
    "percentile_rank": 1,
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 63,
    "percentile_rank": 1,
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 62,
    "percentile_rank": 1,
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 61,
    "percentile_rank": 0.5,
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": 2,
    "index_score": 60,
    "percentile_rank": 0.4,
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 59,
    "percentile_rank": 0.3,
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 58,
    "percentile_rank": 0.3,
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 57,
    "percentile_rank": 0.2,
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 56,
    "percentile_rank": 0.2,
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": 1,
    "index_score": 55,
    "percentile_rank": 0.1,
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 54,
    "percentile_rank": 0.1,
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 53,
    "percentile_rank": 0.1,
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 52,
    "percentile_rank": 0.1,
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 51,
    "percentile_rank": 0.1,
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 50,
    "percentile_rank": "<0.1",
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 49,
    "percentile_rank": "<0.1",
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 48,
    "percentile_rank": "<0.1",
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 47,
    "percentile_rank": "<0.1",
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 46,
    "percentile_rank": "<0.1",
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 45,
    "percentile_rank": "<0.1",
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 44,
    "percentile_rank": "<0.1",
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 43,
    "percentile_rank": "<0.1",
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 42,
    "percentile_rank": "<0.1",
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 41,
    "percentile_rank": "<0.1",
    "normal_curve_equivalent": 1,
    "stanine": 1
  },
  {
    "subtest_scaled_score": "",
    "index_score": 40,
    "percentile_rank": "<0.1",
    "normal_curve_equivalent": 1,
    "stanine": 1
  }
];

const pkFall: any = [
  {
    "scaled_score": 19,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 28,
    "bc_high": 28,
    "rv_low": 19,
    "rv_high": 20,
    "psp_low": 28,
    "psp_high": 30,
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 18,
    "lk_low": 30,
    "lk_high": 30,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 27,
    "bc_high": 27,
    "rv_low": 18,
    "rv_high": 18,
    "psp_low": 26,
    "psp_high": 27,
    "lc_low": 21,
    "lc_high": 21
  },
  {
    "scaled_score": 17,
    "lk_low": 29,
    "lk_high": 29,
    "rk_low": 20,
    "rk_high": 20,
    "bc_low": 26,
    "bc_high": 26,
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 25,
    "psp_high": 25,
    "lc_low": 20,
    "lc_high": 20
  },
  {
    "scaled_score": 16,
    "lk_low": 28,
    "lk_high": 28,
    "rk_low": 19,
    "rk_high": 19,
    "bc_low": 25,
    "bc_high": 25,
    "rv_low": 17,
    "rv_high": 17,
    "psp_low": 23,
    "psp_high": 24,
    "lc_low": 18,
    "lc_high": 19
  },
  {
    "scaled_score": 15,
    "lk_low": 27,
    "lk_high": 27,
    "rk_low": 17,
    "rk_high": 18,
    "bc_low": 24,
    "bc_high": 24,
    "rv_low": 16,
    "rv_high": 16,
    "psp_low": 21,
    "psp_high": 22,
    "lc_low": 16,
    "lc_high": 17
  },
  {
    "scaled_score": 14,
    "lk_low": 25,
    "lk_high": 26,
    "rk_low": 15,
    "rk_high": 16,
    "bc_low": 22,
    "bc_high": 23,
    "rv_low": 15,
    "rv_high": 15,
    "psp_low": 20,
    "psp_high": 20,
    "lc_low": 15,
    "lc_high": 15
  },
  {
    "scaled_score": 13,
    "lk_low": 22,
    "lk_high": 24,
    "rk_low": 13,
    "rk_high": 14,
    "bc_low": 21,
    "bc_high": 21,
    "rv_low": 14,
    "rv_high": 14,
    "psp_low": 18,
    "psp_high": 19,
    "lc_low": 13,
    "lc_high": 14
  },
  {
    "scaled_score": 12,
    "lk_low": 19,
    "lk_high": 21,
    "rk_low": 10,
    "rk_high": 12,
    "bc_low": 19,
    "bc_high": 20,
    "rv_low": 13,
    "rv_high": 13,
    "psp_low": 16,
    "psp_high": 17,
    "lc_low": 12,
    "lc_high": 12
  },
  {
    "scaled_score": 11,
    "lk_low": 16,
    "lk_high": 18,
    "rk_low": 8,
    "rk_high": 9,
    "bc_low": 17,
    "bc_high": 18,
    "rv_low": 12,
    "rv_high": 12,
    "psp_low": 14,
    "psp_high": 15,
    "lc_low": 10,
    "lc_high": 11
  },
  {
    "scaled_score": 10,
    "lk_low": 12,
    "lk_high": 15,
    "rk_low": 6,
    "rk_high": 7,
    "bc_low": 15,
    "bc_high": 16,
    "rv_low": 11,
    "rv_high": 11,
    "psp_low": 12,
    "psp_high": 13,
    "lc_low": 9,
    "lc_high": 9
  },
  {
    "scaled_score": 9,
    "lk_low": 8,
    "lk_high": 11,
    "rk_low": 4,
    "rk_high": 5,
    "bc_low": 13,
    "bc_high": 14,
    "rv_low": 9,
    "rv_high": 10,
    "psp_low": 10,
    "psp_high": 11,
    "lc_low": 7,
    "lc_high": 8
  },
  {
    "scaled_score": 8,
    "lk_low": 5,
    "lk_high": 7,
    "rk_low": 3,
    "rk_high": 3,
    "bc_low": 11,
    "bc_high": 12,
    "rv_low": 8,
    "rv_high": 8,
    "psp_low": 9,
    "psp_high": 9,
    "lc_low": 6,
    "lc_high": 6
  },
  {
    "scaled_score": 7,
    "lk_low": 3,
    "lk_high": 4,
    "rk_low": 2,
    "rk_high": 2,
    "bc_low": 9,
    "bc_high": 10,
    "rv_low": 7,
    "rv_high": 7,
    "psp_low": 7,
    "psp_high": 8,
    "lc_low": 4,
    "lc_high": 5
  },
  {
    "scaled_score": 6,
    "lk_low": 2,
    "lk_high": 2,
    "rk_low": 1,
    "rk_high": 1,
    "bc_low": 7,
    "bc_high": 8,
    "rv_low": 5,
    "rv_high": 6,
    "psp_low": 5,
    "psp_high": 6,
    "lc_low": 3,
    "lc_high": 3
  },
  {
    "scaled_score": 5,
    "lk_low": 1,
    "lk_high": 1,
    "rk_low": 0,
    "rk_high": 0,
    "bc_low": 5,
    "bc_high": 6,
    "rv_low": 4,
    "rv_high": 4,
    "psp_low": 3,
    "psp_high": 4,
    "lc_low": 2,
    "lc_high": 2
  },
  {
    "scaled_score": 4,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 3,
    "bc_high": 4,
    "rv_low": 2,
    "rv_high": 3,
    "psp_low": 2,
    "psp_high": 2,
    "lc_low": 1,
    "lc_high": 1
  },
  {
    "scaled_score": 3,
    "lk_low": 0,
    "lk_high": 0,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 1,
    "bc_high": 2,
    "rv_low": 1,
    "rv_high": 1,
    "psp_low": 1,
    "psp_high": 1,
    "lc_low": 0,
    "lc_high": 0
  },
  {
    "scaled_score": 2,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 0,
    "bc_high": 0,
    "rv_low": 0,
    "rv_high": 0,
    "psp_low": 0,
    "psp_high": 0,
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 1,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": "–",
    "psp_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  }
];

const pkFallConfidence: any = [
  {
    "confidence_interval": "90%",
    "lk": 2,
    "rk": 2,
    "bc": 2,
    "rv": 3,
    "psp": 2,
    "lc": 2
  },
  {
    "confidence_interval": "95%",
    "lk": 2,
    "rk": 2,
    "bc": 3,
    "rv": 3,
    "psp": 2,
    "lc": 3
  }
];

const pkSpring: any = [
  {
    "scaled_score": 19,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": 20,
    "rv_high": 20,
    "psp_low": 29,
    "psp_high": 30,
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 18,
    "lk_low": 30,
    "lk_high": 30,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 28,
    "bc_high": 28,
    "rv_low": 19,
    "rv_high": 19,
    "psp_low": 28,
    "psp_high": 28,
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 17,
    "lk_low": 29,
    "lk_high": 29,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 26,
    "psp_high": 27,
    "lc_low": 21,
    "lc_high": 21
  },
  {
    "scaled_score": 16,
    "lk_low": 28,
    "lk_high": 28,
    "rk_low": 20,
    "rk_high": 20,
    "bc_low": 27,
    "bc_high": 27,
    "rv_low": 18,
    "rv_high": 18,
    "psp_low": 25,
    "psp_high": 25,
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 15,
    "lk_low": 27,
    "lk_high": 27,
    "rk_low": 19,
    "rk_high": 19,
    "bc_low": 25,
    "bc_high": 26,
    "rv_low": 17,
    "rv_high": 17,
    "psp_low": 23,
    "psp_high": 24,
    "lc_low": 20,
    "lc_high": 20
  },
  {
    "scaled_score": 14,
    "lk_low": 26,
    "lk_high": 26,
    "rk_low": 17,
    "rk_high": 18,
    "bc_low": 24,
    "bc_high": 24,
    "rv_low": 16,
    "rv_high": 16,
    "psp_low": 21,
    "psp_high": 22,
    "lc_low": 18,
    "lc_high": 19
  },
  {
    "scaled_score": 13,
    "lk_low": 24,
    "lk_high": 25,
    "rk_low": 15,
    "rk_high": 16,
    "bc_low": 23,
    "bc_high": 23,
    "rv_low": 15,
    "rv_high": 15,
    "psp_low": 20,
    "psp_high": 20,
    "lc_low": 17,
    "lc_high": 17
  },
  {
    "scaled_score": 12,
    "lk_low": 22,
    "lk_high": 23,
    "rk_low": 12,
    "rk_high": 14,
    "bc_low": 21,
    "bc_high": 22,
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 18,
    "psp_high": 19,
    "lc_low": 15,
    "lc_high": 16
  },
  {
    "scaled_score": 11,
    "lk_low": 19,
    "lk_high": 21,
    "rk_low": 10,
    "rk_high": 11,
    "bc_low": 20,
    "bc_high": 20,
    "rv_low": 14,
    "rv_high": 14,
    "psp_low": 16,
    "psp_high": 17,
    "lc_low": 14,
    "lc_high": 14
  },
  {
    "scaled_score": 10,
    "lk_low": 15,
    "lk_high": 18,
    "rk_low": 8,
    "rk_high": 9,
    "bc_low": 18,
    "bc_high": 19,
    "rv_low": 13,
    "rv_high": 13,
    "psp_low": 14,
    "psp_high": 15,
    "lc_low": 12,
    "lc_high": 13
  },
  {
    "scaled_score": 9,
    "lk_low": 11,
    "lk_high": 14,
    "rk_low": 6,
    "rk_high": 7,
    "bc_low": 16,
    "bc_high": 17,
    "rv_low": 11,
    "rv_high": 12,
    "psp_low": 12,
    "psp_high": 13,
    "lc_low": 10,
    "lc_high": 11
  },
  {
    "scaled_score": 8,
    "lk_low": 8,
    "lk_high": 10,
    "rk_low": 4,
    "rk_high": 5,
    "bc_low": 14,
    "bc_high": 15,
    "rv_low": 9,
    "rv_high": 10,
    "psp_low": 11,
    "psp_high": 11,
    "lc_low": 9,
    "lc_high": 9
  },
  {
    "scaled_score": 7,
    "lk_low": 5,
    "lk_high": 7,
    "rk_low": 2,
    "rk_high": 3,
    "bc_low": 13,
    "bc_high": 13,
    "rv_low": 8,
    "rv_high": 8,
    "psp_low": 9,
    "psp_high": 10,
    "lc_low": 7,
    "lc_high": 8
  },
  {
    "scaled_score": 6,
    "lk_low": 3,
    "lk_high": 4,
    "rk_low": 1,
    "rk_high": 1,
    "bc_low": 11,
    "bc_high": 12,
    "rv_low": 6,
    "rv_high": 7,
    "psp_low": 7,
    "psp_high": 8,
    "lc_low": 5,
    "lc_high": 6
  },
  {
    "scaled_score": 5,
    "lk_low": 2,
    "lk_high": 2,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 9,
    "bc_high": 10,
    "rv_low": 5,
    "rv_high": 5,
    "psp_low": 5,
    "psp_high": 6,
    "lc_low": 3,
    "lc_high": 4
  },
  {
    "scaled_score": 4,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": 0,
    "rk_high": 0,
    "bc_low": 7,
    "bc_high": 8,
    "rv_low": 4,
    "rv_high": 4,
    "psp_low": 3,
    "psp_high": 4,
    "lc_low": 2,
    "lc_high": 2
  },
  {
    "scaled_score": 3,
    "lk_low": 1,
    "lk_high": 1,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 5,
    "bc_high": 6,
    "rv_low": 3,
    "rv_high": 3,
    "psp_low": 1,
    "psp_high": 2,
    "lc_low": 1,
    "lc_high": 1
  },
  {
    "scaled_score": 2,
    "lk_low": 0,
    "lk_high": 0,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 2,
    "bc_high": 4,
    "rv_low": 2,
    "rv_high": 2,
    "psp_low": 0,
    "psp_high": 0,
    "lc_low": 0,
    "lc_high": 0
  },
  {
    "scaled_score": 1,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 0,
    "bc_high": 1,
    "rv_low": 0,
    "rv_high": 1,
    "psp_low": "–",
    "psp_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  }
];

const pkSpringConfidence: any = [
  {
    "confidence_level": "90%",
    "lk": 2,
    "rk": 2,
    "bc": 2,
    "rv": 2,
    "psp": 2,
    "lc": 2
  },
  {
    "confidence_level": "95%",
    "lk": 2,
    "rk": 2,
    "bc": 3,
    "rv": 3,
    "psp": 2,
    "lc": 3
  }
];

const kFall: any = [
  {
    "scaled_score": 19,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 29,
    "psp_high": 30,
    "el_low": 17,
    "el_high": 20,
    "wr_low": "–",
    "wr_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 18,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 28,
    "psp_high": 28,
    "el_low": 16,
    "el_high": 16,
    "wr_low": "–",
    "wr_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 17,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 28,
    "bc_high": 28,
    "rv_low": 20,
    "rv_high": 20,
    "psp_low": 27,
    "psp_high": 27,
    "el_low": 15,
    "el_high": 15,
    "wr_low": "–",
    "wr_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 16,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": 20,
    "rk_high": 20,
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 26,
    "psp_high": 26,
    "el_low": 14,
    "el_high": 14,
    "wr_low": 25,
    "wr_high": 25,
    "lc_low": 21,
    "lc_high": 21
  },
  {
    "scaled_score": 15,
    "lk_low": 30,
    "lk_high": 30,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 27,
    "bc_high": 27,
    "rv_low": 19,
    "rv_high": 19,
    "psp_low": 25,
    "psp_high": 25,
    "el_low": 13,
    "el_high": 13,
    "wr_low": "–",
    "wr_high": "–",
    "lc_low": 20,
    "lc_high": 20
  },
  {
    "scaled_score": 14,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": 19,
    "rk_high": 19,
    "bc_low": 26,
    "bc_high": 26,
    "rv_low": 18,
    "rv_high": 18,
    "psp_low": 23,
    "psp_high": 24,
    "el_low": 11,
    "el_high": 12,
    "wr_low": 24,
    "wr_high": 24,
    "lc_low": 19,
    "lc_high": 19
  },
  {
    "scaled_score": 13,
    "lk_low": 29,
    "lk_high": 29,
    "rk_low": 18,
    "rk_high": 18,
    "bc_low": 24,
    "bc_high": 25,
    "rv_low": 17,
    "rv_high": 17,
    "psp_low": 22,
    "psp_high": 22,
    "el_low": 10,
    "el_high": 10,
    "wr_low": 22,
    "wr_high": 23,
    "lc_low": 18,
    "lc_high": 18
  },
  {
    "scaled_score": 12,
    "lk_low": 27,
    "lk_high": 28,
    "rk_low": 16,
    "rk_high": 17,
    "bc_low": 23,
    "bc_high": 23,
    "rv_low": 16,
    "rv_high": 16,
    "psp_low": 20,
    "psp_high": 21,
    "el_low": 9,
    "el_high": 9,
    "wr_low": 20,
    "wr_high": 21,
    "lc_low": 16,
    "lc_high": 17
  },
  {
    "scaled_score": 11,
    "lk_low": 25,
    "lk_high": 26,
    "rk_low": 13,
    "rk_high": 15,
    "bc_low": 22,
    "bc_high": 22,
    "rv_low": 15,
    "rv_high": 15,
    "psp_low": 18,
    "psp_high": 19,
    "el_low": 8,
    "el_high": 8,
    "wr_low": 17,
    "wr_high": 19,
    "lc_low": 15,
    "lc_high": 15
  },
  {
    "scaled_score": 10,
    "lk_low": 22,
    "lk_high": 24,
    "rk_low": 11,
    "rk_high": 12,
    "bc_low": 21,
    "bc_high": 21,
    "rv_low": 14,
    "rv_high": 14,
    "psp_low": 17,
    "psp_high": 17,
    "el_low": 7,
    "el_high": 7,
    "wr_low": 14,
    "wr_high": 16,
    "lc_low": 13,
    "lc_high": 14
  },
  {
    "scaled_score": 9,
    "lk_low": 20,
    "lk_high": 21,
    "rk_low": 9,
    "rk_high": 10,
    "bc_low": 19,
    "bc_high": 20,
    "rv_low": 13,
    "rv_high": 13,
    "psp_low": 15,
    "psp_high": 16,
    "el_low": 6,
    "el_high": 6,
    "wr_low": 11,
    "wr_high": 13,
    "lc_low": 11,
    "lc_high": 12
  },
  {
    "scaled_score": 8,
    "lk_low": 17,
    "lk_high": 19,
    "rk_low": 7,
    "rk_high": 8,
    "bc_low": 18,
    "bc_high": 18,
    "rv_low": 12,
    "rv_high": 12,
    "psp_low": 13,
    "psp_high": 14,
    "el_low": 5,
    "el_high": 5,
    "wr_low": 8,
    "wr_high": 10,
    "lc_low": 9,
    "lc_high": 10
  },
  {
    "scaled_score": 7,
    "lk_low": 15,
    "lk_high": 16,
    "rk_low": 5,
    "rk_high": 6,
    "bc_low": 16,
    "bc_high": 17,
    "rv_low": 10,
    "rv_high": 11,
    "psp_low": 11,
    "psp_high": 12,
    "el_low": 3,
    "el_high": 4,
    "wr_low": 5,
    "wr_high": 7,
    "lc_low": 7,
    "lc_high": 8
  },
  {
    "scaled_score": 6,
    "lk_low": 12,
    "lk_high": 14,
    "rk_low": 3,
    "rk_high": 4,
    "bc_low": 15,
    "bc_high": 15,
    "rv_low": 9,
    "rv_high": 9,
    "psp_low": 9,
    "psp_high": 10,
    "el_low": 2,
    "el_high": 2,
    "wr_low": 3,
    "wr_high": 4,
    "lc_low": 5,
    "lc_high": 6
  },
  {
    "scaled_score": 5,
    "lk_low": 10,
    "lk_high": 11,
    "rk_low": 2,
    "rk_high": 2,
    "bc_low": 13,
    "bc_high": 14,
    "rv_low": 8,
    "rv_high": 8,
    "psp_low": 7,
    "psp_high": 8,
    "el_low": "–",
    "el_high": "–",
    "wr_low": 2,
    "wr_high": 2,
    "lc_low": 4,
    "lc_high": 4
  },
  {
    "scaled_score": 4,
    "lk_low": 7,
    "lk_high": 9,
    "rk_low": 1,
    "rk_high": 1,
    "bc_low": 12,
    "bc_high": 12,
    "rv_low": 6,
    "rv_high": 7,
    "psp_low": 5,
    "psp_high": 6,
    "el_low": 1,
    "el_high": 1,
    "wr_low": 1,
    "wr_high": 1,
    "lc_low": 2,
    "lc_high": 3
  },
  {
    "scaled_score": 3,
    "lk_low": 4,
    "lk_high": 6,
    "rk_low": 0,
    "rk_high": 0,
    "bc_low": 10,
    "bc_high": 11,
    "rv_low": 4,
    "rv_high": 5,
    "psp_low": 3,
    "psp_high": 4,
    "el_low": 0,
    "el_high": 0,
    "wr_low": 0,
    "wr_high": 0,
    "lc_low": 1,
    "lc_high": 1
  },
  {
    "scaled_score": 2,
    "lk_low": 1,
    "lk_high": 3,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 8,
    "bc_high": 9,
    "rv_low": 3,
    "rv_high": 3,
    "psp_low": 1,
    "psp_high": 2,
    "el_low": "–",
    "el_high": "–",
    "wr_low": "–",
    "wr_high": "–",
    "lc_low": 0,
    "lc_high": 0
  },
  {
    "scaled_score": 1,
    "lk_low": 0,
    "lk_high": 0,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 0,
    "bc_high": 7,
    "rv_low": 0,
    "rv_high": 2,
    "psp_low": 0,
    "psp_high": 0,
    "el_low": "–",
    "el_high": "–",
    "wr_low": "–",
    "wr_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  }
];

const kFallConfidence: any = [
  {
    "confidence_interval": "90%",
    "lk": 2,
    "rk": 2,
    "bc": 3,
    "rv": 2,
    "psp": 2,
    "el": 2,
    "wr": 2,
    "lc": 2
  },
  {
    "confidence_interval": "95%",
    "lk": 2,
    "rk": 2,
    "bc": 3,
    "rv": 3,
    "psp": 3,
    "el": 3,
    "wr": 2,
    "lc": 3
  }
];

const kSpring: any = [
  {
    "scaled_score": 19,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 30,
    "psp_high": 30,
    "el_low": 20,
    "el_high": 20,
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": 35,
    "pk_high": 35,
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 18,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 29,
    "psp_high": 29,
    "el_low": 19,
    "el_high": 19,
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": 34,
    "pk_high": 34,
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 17,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 28,
    "bc_high": 28,
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 28,
    "psp_high": 28,
    "el_low": 18,
    "el_high": 18,
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": 33,
    "pk_high": 33,
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": 20,
    "swr_high": 20,
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 16,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": 20,
    "rv_high": 20,
    "psp_low": 27,
    "psp_high": 27,
    "el_low": 17,
    "el_high": 17,
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": "–",
    "pk_high": "–",
    "sc_low": 16,
    "sc_high": 16,
    "swr_low": 19,
    "swr_high": 19,
    "lc_low": 21,
    "lc_high": 21
  },
  {
    "scaled_score": 15,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 27,
    "bc_high": 27,
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 26,
    "psp_high": 26,
    "el_low": 16,
    "el_high": 16,
    "wr_low": 25,
    "wr_high": 25,
    "pk_low": 32,
    "pk_high": 32,
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": 18,
    "swr_high": 18,
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 14,
    "lk_low": "–",
    "lk_high": "–",
    "rk_low": 20,
    "rk_high": 20,
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": 19,
    "rv_high": 19,
    "psp_low": 24,
    "psp_high": 25,
    "el_low": 15,
    "el_high": 15,
    "wr_low": 24,
    "wr_high": 24,
    "pk_low": 30,
    "pk_high": 31,
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": 17,
    "swr_high": 17,
    "lc_low": 20,
    "lc_high": 20
  },
  {
    "scaled_score": 13,
    "lk_low": 30,
    "lk_high": 30,
    "rk_low": 19,
    "rk_high": 19,
    "bc_low": 26,
    "bc_high": 26,
    "rv_low": 18,
    "rv_high": 18,
    "psp_low": 23,
    "psp_high": 23,
    "el_low": 14,
    "el_high": 14,
    "wr_low": 22,
    "wr_high": 23,
    "pk_low": 29,
    "pk_high": 29,
    "sc_low": 15,
    "sc_high": 15,
    "swr_low": 15,
    "swr_high": 16,
    "lc_low": 19,
    "lc_high": 19
  },
  {
    "scaled_score": 12,
    "lk_low": 29,
    "lk_high": 29,
    "rk_low": 18,
    "rk_high": 18,
    "bc_low": 25,
    "bc_high": 25,
    "rv_low": 17,
    "rv_high": 17,
    "psp_low": 21,
    "psp_high": 22,
    "el_low": 13,
    "el_high": 13,
    "wr_low": 20,
    "wr_high": 21,
    "pk_low": 27,
    "pk_high": 28,
    "sc_low": 14,
    "sc_high": 14,
    "swr_low": 12,
    "swr_high": 14,
    "lc_low": 18,
    "lc_high": 18
  },
  {
    "scaled_score": 11,
    "lk_low": 28,
    "lk_high": 28,
    "rk_low": 17,
    "rk_high": 17,
    "bc_low": 23,
    "bc_high": 24,
    "rv_low": 16,
    "rv_high": 16,
    "psp_low": 20,
    "psp_high": 20,
    "el_low": 11,
    "el_high": 12,
    "wr_low": 17,
    "wr_high": 19,
    "pk_low": 25,
    "pk_high": 26,
    "sc_low": 13,
    "sc_high": 13,
    "swr_low": 10,
    "swr_high": 11,
    "lc_low": 17,
    "lc_high": 17
  },
  {
    "scaled_score": 10,
    "lk_low": 27,
    "lk_high": 27,
    "rk_low": 15,
    "rk_high": 16,
    "bc_low": 22,
    "bc_high": 22,
    "rv_low": 15,
    "rv_high": 15,
    "psp_low": 18,
    "psp_high": 19,
    "el_low": 10,
    "el_high": 10,
    "wr_low": 14,
    "wr_high": 16,
    "pk_low": 23,
    "pk_high": 24,
    "sc_low": 12,
    "sc_high": 12,
    "swr_low": 8,
    "swr_high": 9,
    "lc_low": 16,
    "lc_high": 16
  },
  {
    "scaled_score": 9,
    "lk_low": 26,
    "lk_high": 26,
    "rk_low": 12,
    "rk_high": 14,
    "bc_low": 21,
    "bc_high": 21,
    "rv_low": 14,
    "rv_high": 14,
    "psp_low": 16,
    "psp_high": 17,
    "el_low": 9,
    "el_high": 9,
    "wr_low": 11,
    "wr_high": 13,
    "pk_low": 20,
    "pk_high": 22,
    "sc_low": 10,
    "sc_high": 11,
    "swr_low": 6,
    "swr_high": 7,
    "lc_low": 14,
    "lc_high": 15
  },
  {
    "scaled_score": 8,
    "lk_low": 24,
    "lk_high": 25,
    "rk_low": 10,
    "rk_high": 11,
    "bc_low": 20,
    "bc_high": 20,
    "rv_low": 13,
    "rv_high": 13,
    "psp_low": 15,
    "psp_high": 15,
    "el_low": 8,
    "el_high": 8,
    "wr_low": 8,
    "wr_high": 10,
    "pk_low": 18,
    "pk_high": 19,
    "sc_low": 9,
    "sc_high": 9,
    "swr_low": 4,
    "swr_high": 5,
    "lc_low": 12,
    "lc_high": 13
  },
  {
    "scaled_score": 7,
    "lk_low": 22,
    "lk_high": 23,
    "rk_low": 8,
    "rk_high": 9,
    "bc_low": 18,
    "bc_high": 19,
    "rv_low": 11,
    "rv_high": 12,
    "psp_low": 13,
    "psp_high": 14,
    "el_low": 6,
    "el_high": 7,
    "wr_low": 5,
    "wr_high": 7,
    "pk_low": 15,
    "pk_high": 17,
    "sc_low": 7,
    "sc_high": 8,
    "swr_low": 3,
    "swr_high": 3,
    "lc_low": 11,
    "lc_high": 11
  },
  {
    "scaled_score": 6,
    "lk_low": 20,
    "lk_high": 21,
    "rk_low": 6,
    "rk_high": 7,
    "bc_low": 17,
    "bc_high": 17,
    "rv_low": 10,
    "rv_high": 10,
    "psp_low": 11,
    "psp_high": 12,
    "el_low": 5,
    "el_high": 5,
    "wr_low": 3,
    "wr_high": 4,
    "pk_low": 13,
    "pk_high": 14,
    "sc_low": 6,
    "sc_high": 6,
    "swr_low": 2,
    "swr_high": 2,
    "lc_low": 9,
    "lc_high": 10
  },
  {
    "scaled_score": 5,
    "lk_low": 19,
    "lk_high": 19,
    "rk_low": 4,
    "rk_high": 5,
    "bc_low": 15,
    "bc_high": 16,
    "rv_low": 9,
    "rv_high": 9,
    "psp_low": 9,
    "psp_high": 10,
    "el_low": 4,
    "el_high": 4,
    "wr_low": 2,
    "wr_high": 2,
    "pk_low": 10,
    "pk_high": 12,
    "sc_low": 5,
    "sc_high": 5,
    "swr_low": 1,
    "swr_high": 1,
    "lc_low": 8,
    "lc_high": 8
  },
  {
    "scaled_score": 4,
    "lk_low": 17,
    "lk_high": 18,
    "rk_low": 2,
    "rk_high": 3,
    "bc_low": 14,
    "bc_high": 14,
    "rv_low": 8,
    "rv_high": 8,
    "psp_low": 7,
    "psp_high": 8,
    "el_low": 2,
    "el_high": 3,
    "wr_low": 1,
    "wr_high": 1,
    "pk_low": 7,
    "pk_high": 9,
    "sc_low": 3,
    "sc_high": 4,
    "swr_low": 0,
    "swr_high": 0,
    "lc_low": 6,
    "lc_high": 7
  },
  {
    "scaled_score": 3,
    "lk_low": 15,
    "lk_high": 16,
    "rk_low": 1,
    "rk_high": 1,
    "bc_low": 12,
    "bc_high": 13,
    "rv_low": 6,
    "rv_high": 7,
    "psp_low": 5,
    "psp_high": 6,
    "el_low": 1,
    "el_high": 1,
    "wr_low": 0,
    "wr_high": 0,
    "pk_low": 4,
    "pk_high": 6,
    "sc_low": 1,
    "sc_high": 2,
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": 4,
    "lc_high": 5
  },
  {
    "scaled_score": 2,
    "lk_low": 13,
    "lk_high": 14,
    "rk_low": 0,
    "rk_high": 0,
    "bc_low": 11,
    "bc_high": 11,
    "rv_low": 4,
    "rv_high": 5,
    "psp_low": 3,
    "psp_high": 4,
    "el_low": 0,
    "el_high": 0,
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": 1,
    "pk_high": 3,
    "sc_low": 0,
    "sc_high": 0,
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": 2,
    "lc_high": 3
  },
  {
    "scaled_score": 1,
    "lk_low": 0,
    "lk_high": 12,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 0,
    "bc_high": 10,
    "rv_low": 0,
    "rv_high": 3,
    "psp_low": 0,
    "psp_high": 2,
    "el_low": "–",
    "el_high": "–",
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": 0,
    "pk_high": 0,
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": 0,
    "lc_high": 1
  }
];

const kSpringConfidence: any = [
  {
    "confidence_level": "90%",
    "lk": 3,
    "rk": 2,
    "bc": 3,
    "rv": 3,
    "psp": 3,
    "el": 2,
    "wr": 2,
    "pk": 2,
    "sc": 2,
    "swr": 1,
    "lc": 3
  },
  {
    "confidence_level": "95%",
    "lk": 3,
    "rk": 2,
    "bc": 3,
    "rv": 4,
    "psp": 3,
    "el": 3,
    "wr": 2,
    "pk": 2,
    "sc": 3,
    "swr": 2,
    "lc": 3
  }
];

const fFall: any = [
  {
    "scaled_score": 19,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 30,
    "psp_high": 30,
    "el_low": 20,
    "el_high": 20,
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": 35,
    "pk_high": 35,
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 18,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 29,
    "psp_high": 29,
    "el_low": 19,
    "el_high": 19,
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": 34,
    "pk_high": 34,
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": 21,
    "lc_high": 21
  },
  {
    "scaled_score": 17,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 28,
    "psp_high": 28,
    "el_low": 18,
    "el_high": 18,
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": "–",
    "pk_high": "–",
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 16,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 27,
    "psp_high": 27,
    "el_low": 17,
    "el_high": 17,
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": 33,
    "pk_high": 33,
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 15,
    "rk_low": 22,
    "rk_high": 22,
    "bc_low": 28,
    "bc_high": 28,
    "rv_low": 20,
    "rv_high": 20,
    "psp_low": 26,
    "psp_high": 26,
    "el_low": "–",
    "el_high": "–",
    "wr_low": 25,
    "wr_high": 25,
    "pk_low": "–",
    "pk_high": "–",
    "sc_low": 16,
    "sc_high": 16,
    "swr_low": 20,
    "swr_high": 20,
    "lc_low": 20,
    "lc_high": 20
  },
  {
    "scaled_score": 14,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 27,
    "bc_high": 27,
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 25,
    "psp_high": 25,
    "el_low": 16,
    "el_high": 16,
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": 32,
    "pk_high": 32,
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": 19,
    "swr_high": 19,
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 13,
    "rk_low": 21,
    "rk_high": 21,
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": 19,
    "rv_high": 19,
    "psp_low": 24,
    "psp_high": 24,
    "el_low": 15,
    "el_high": 15,
    "wr_low": 24,
    "wr_high": 24,
    "pk_low": "–",
    "pk_high": "–",
    "sc_low": 15,
    "sc_high": 15,
    "swr_low": 18,
    "swr_high": 18,
    "lc_low": 19,
    "lc_high": 19
  },
  {
    "scaled_score": 12,
    "rk_low": 19,
    "rk_high": 20,
    "bc_low": 26,
    "bc_high": 26,
    "rv_low": 18,
    "rv_high": 18,
    "psp_low": 23,
    "psp_high": 23,
    "el_low": 14,
    "el_high": 14,
    "wr_low": 23,
    "wr_high": 23,
    "pk_low": 31,
    "pk_high": 31,
    "sc_low": 14,
    "sc_high": 14,
    "swr_low": 16,
    "swr_high": 17,
    "lc_low": 18,
    "lc_high": 18
  },
  {
    "scaled_score": 11,
    "rk_low": 17,
    "rk_high": 18,
    "bc_low": 25,
    "bc_high": 25,
    "rv_low": 17,
    "rv_high": 17,
    "psp_low": 21,
    "psp_high": 22,
    "el_low": 12,
    "el_high": 13,
    "wr_low": 22,
    "wr_high": 22,
    "pk_low": 29,
    "pk_high": 30,
    "sc_low": 13,
    "sc_high": 13,
    "swr_low": 14,
    "swr_high": 15,
    "lc_low": 17,
    "lc_high": 17
  },
  {
    "scaled_score": 10,
    "rk_low": 15,
    "rk_high": 16,
    "bc_low": 24,
    "bc_high": 24,
    "rv_low": 16,
    "rv_high": 16,
    "psp_low": 20,
    "psp_high": 20,
    "el_low": 11,
    "el_high": 11,
    "wr_low": 20,
    "wr_high": 21,
    "pk_low": 26,
    "pk_high": 28,
    "sc_low": 12,
    "sc_high": 12,
    "swr_low": 12,
    "swr_high": 13,
    "lc_low": 16,
    "lc_high": 16
  },
  {
    "scaled_score": 9,
    "rk_low": 12,
    "rk_high": 14,
    "bc_low": 23,
    "bc_high": 23,
    "rv_low": 15,
    "rv_high": 15,
    "psp_low": 18,
    "psp_high": 19,
    "el_low": 10,
    "el_high": 10,
    "wr_low": 17,
    "wr_high": 19,
    "pk_low": 23,
    "pk_high": 25,
    "sc_low": 10,
    "sc_high": 11,
    "swr_low": 9,
    "swr_high": 11,
    "lc_low": 15,
    "lc_high": 15
  },
  {
    "scaled_score": 8,
    "rk_low": 10,
    "rk_high": 11,
    "bc_low": 21,
    "bc_high": 22,
    "rv_low": 14,
    "rv_high": 14,
    "psp_low": 16,
    "psp_high": 17,
    "el_low": 8,
    "el_high": 9,
    "wr_low": 14,
    "wr_high": 16,
    "pk_low": 20,
    "pk_high": 22,
    "sc_low": 9,
    "sc_high": 9,
    "swr_low": 7,
    "swr_high": 8,
    "lc_low": 13,
    "lc_high": 14
  },
  {
    "scaled_score": 7,
    "rk_low": 8,
    "rk_high": 9,
    "bc_low": 20,
    "bc_high": 20,
    "rv_low": 13,
    "rv_high": 13,
    "psp_low": 15,
    "psp_high": 15,
    "el_low": 7,
    "el_high": 7,
    "wr_low": 12,
    "wr_high": 13,
    "pk_low": 18,
    "pk_high": 19,
    "sc_low": 7,
    "sc_high": 8,
    "swr_low": 5,
    "swr_high": 6,
    "lc_low": 12,
    "lc_high": 12
  },
  {
    "scaled_score": 6,
    "rk_low": 6,
    "rk_high": 7,
    "bc_low": 19,
    "bc_high": 19,
    "rv_low": 12,
    "rv_high": 12,
    "psp_low": 13,
    "psp_high": 14,
    "el_low": 5,
    "el_high": 6,
    "wr_low": 10,
    "wr_high": 11,
    "pk_low": 16,
    "pk_high": 17,
    "sc_low": 6,
    "sc_high": 6,
    "swr_low": 3,
    "swr_high": 4,
    "lc_low": 11,
    "lc_high": 11
  },
  {
    "scaled_score": 5,
    "rk_low": 4,
    "rk_high": 5,
    "bc_low": 18,
    "bc_high": 18,
    "rv_low": 11,
    "rv_high": 11,
    "psp_low": 11,
    "psp_high": 12,
    "el_low": 4,
    "el_high": 4,
    "wr_low": 8,
    "wr_high": 9,
    "pk_low": 13,
    "pk_high": 15,
    "sc_low": 5,
    "sc_high": 5,
    "swr_low": 2,
    "swr_high": 2,
    "lc_low": 9,
    "lc_high": 10
  },
  {
    "scaled_score": 4,
    "rk_low": 2,
    "rk_high": 3,
    "bc_low": 16,
    "bc_high": 17,
    "rv_low": 10,
    "rv_high": 10,
    "psp_low": 9,
    "psp_high": 10,
    "el_low": 3,
    "el_high": 3,
    "wr_low": 5,
    "wr_high": 7,
    "pk_low": 10,
    "pk_high": 12,
    "sc_low": 3,
    "sc_high": 4,
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": 7,
    "lc_high": 8
  },
  {
    "scaled_score": 3,
    "rk_low": 1,
    "rk_high": 1,
    "bc_low": 15,
    "bc_high": 15,
    "rv_low": 9,
    "rv_high": 9,
    "psp_low": 7,
    "psp_high": 8,
    "el_low": 1,
    "el_high": 2,
    "wr_low": 3,
    "wr_high": 4,
    "pk_low": 6,
    "pk_high": 9,
    "sc_low": 1,
    "sc_high": 2,
    "swr_low": 1,
    "swr_high": 1,
    "lc_low": 5,
    "lc_high": 6
  },
  {
    "scaled_score": 2,
    "rk_low": 0,
    "rk_high": 0,
    "bc_low": 13,
    "bc_high": 14,
    "rv_low": 8,
    "rv_high": 8,
    "psp_low": 5,
    "psp_high": 6,
    "el_low": 0,
    "el_high": 0,
    "wr_low": 1,
    "wr_high": 2,
    "pk_low": 2,
    "pk_high": 5,
    "sc_low": 0,
    "sc_high": 0,
    "swr_low": 0,
    "swr_high": 0,
    "lc_low": 3,
    "lc_high": 4
  },
  {
    "scaled_score": 1,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 0,
    "bc_high": 12,
    "rv_low": 0,
    "rv_high": 7,
    "psp_low": 0,
    "psp_high": 4,
    "el_low": "–",
    "el_high": "–",
    "wr_low": 0,
    "wr_high": 0,
    "pk_low": 0,
    "pk_high": 1,
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": 0,
    "lc_high": 2
  }
];

const fFallConfidence: any = [
  {
    "confidence_level": "90%",
    "rk": 2,
    "bc": 3,
    "rv": 3,
    "psp": 3,
    "el": 2,
    "wr": 2,
    "pk": 2,
    "sc": 3,
    "swr": 1,
    "lc": 3
  },
  {
    "confidence_level": "95%",
    "rk": 2,
    "bc": 3,
    "rv": 4,
    "psp": 3,
    "el": 3,
    "wr": 2,
    "pk": 2,
    "sc": 3,
    "swr": 2,
    "lc": 3
  }
];

const fSpring: any = [
  {
    "scaled_score": 19,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 30,
    "psp_high": 30,
    "el_low": 20,
    "el_high": 20,
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": "–",
    "pk_high": "–",
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 18,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 29,
    "psp_high": 29,
    "el_low": "–",
    "el_high": "–",
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": "–",
    "pk_high": "–",
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 17,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 28,
    "psp_high": 28,
    "el_low": 19,
    "el_high": 19,
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": 35,
    "pk_high": 35,
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 16,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": "–",
    "psp_high": "–",
    "el_low": "–",
    "el_high": "–",
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": "–",
    "pk_high": "–",
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 15,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 28,
    "bc_high": 28,
    "rv_low": 20,
    "rv_high": 20,
    "psp_low": 27,
    "psp_high": 27,
    "el_low": 18,
    "el_high": 18,
    "wr_low": 25,
    "wr_high": 25,
    "pk_low": "–",
    "pk_high": "–",
    "sc_low": 16,
    "sc_high": 16,
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": 21,
    "lc_high": 21
  },
  {
    "scaled_score": 14,
    "rk_low": 22,
    "rk_high": 22,
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 26,
    "psp_high": 26,
    "el_low": 17,
    "el_high": 17,
    "wr_low": "–",
    "wr_high": "–",
    "pk_low": 34,
    "pk_high": 34,
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": "–",
    "swr_high": "–",
    "lc_low": "–",
    "lc_high": "–"
  },
  {
    "scaled_score": 13,
    "rk_low": "–",
    "rk_high": "–",
    "bc_low": 27,
    "bc_high": 27,
    "rv_low": 19,
    "rv_high": 19,
    "psp_low": 25,
    "psp_high": 25,
    "el_low": 16,
    "el_high": 16,
    "wr_low": 24,
    "wr_high": 24,
    "pk_low": "–",
    "pk_high": "–",
    "sc_low": 15,
    "sc_high": 15,
    "swr_low": 20,
    "swr_high": 20,
    "lc_low": 20,
    "lc_high": 20
  },
  {
    "scaled_score": 12,
    "rk_low": 21,
    "rk_high": 21,
    "bc_low": "–",
    "bc_high": "–",
    "rv_low": 18,
    "rv_high": 18,
    "psp_low": 23,
    "psp_high": 24,
    "el_low": 15,
    "el_high": 15,
    "wr_low": 23,
    "wr_high": 23,
    "pk_low": 33,
    "pk_high": 33,
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": 19,
    "swr_high": 19,
    "lc_low": 19,
    "lc_high": 19
  },
  {
    "scaled_score": 11,
    "rk_low": 20,
    "rk_high": 20,
    "bc_low": 26,
    "bc_high": 26,
    "rv_low": "–",
    "rv_high": "–",
    "psp_low": 22,
    "psp_high": 22,
    "el_low": 14,
    "el_high": 14,
    "wr_low": 22,
    "wr_high": 22,
    "pk_low": 32,
    "pk_high": 32,
    "sc_low": "–",
    "sc_high": "–",
    "swr_low": 18,
    "swr_high": 18,
    "lc_low": 18,
    "lc_high": 18
  },
  {
    "scaled_score": 10,
    "rk_low": 19,
    "rk_high": 19,
    "bc_low": 25,
    "bc_high": 25,
    "rv_low": 17,
    "rv_high": 17,
    "psp_low": 21,
    "psp_high": 21,
    "el_low": 13,
    "el_high": 13,
    "wr_low": 21,
    "wr_high": 21,
    "pk_low": 30,
    "pk_high": 31,
    "sc_low": 14,
    "sc_high": 14,
    "swr_low": 17,
    "swr_high": 17,
    "lc_low": 17,
    "lc_high": 17
  },
  {
    "scaled_score": 9,
    "rk_low": 17,
    "rk_high": 18,
    "bc_low": 24,
    "bc_high": 24,
    "rv_low": 16,
    "rv_high": 16,
    "psp_low": 19,
    "psp_high": 20,
    "el_low": 12,
    "el_high": 12,
    "wr_low": 19,
    "wr_high": 20,
    "pk_low": 27,
    "pk_high": 29,
    "sc_low": 12,
    "sc_high": 13,
    "swr_low": 15,
    "swr_high": 16,
    "lc_low": 16,
    "lc_high": 16
  },
  {
    "scaled_score": 8,
    "rk_low": 16,
    "rk_high": 16,
    "bc_low": 22,
    "bc_high": 23,
    "rv_low": 15,
    "rv_high": 15,
    "psp_low": 18,
    "psp_high": 18,
    "el_low": 10,
    "el_high": 11,
    "wr_low": 17,
    "wr_high": 18,
    "pk_low": 25,
    "pk_high": 26,
    "sc_low": 10,
    "sc_high": 11,
    "swr_low": 13,
    "swr_high": 14,
    "lc_low": 15,
    "lc_high": 15
  },
  {
    "scaled_score": 7,
    "rk_low": 14,
    "rk_high": 15,
    "bc_low": 21,
    "bc_high": 21,
    "rv_low": 14,
    "rv_high": 14,
    "psp_low": 16,
    "psp_high": 17,
    "el_low": 9,
    "el_high": 9,
    "wr_low": 16,
    "wr_high": 16,
    "pk_low": 22,
    "pk_high": 24,
    "sc_low": 9,
    "sc_high": 9,
    "swr_low": 11,
    "swr_high": 12,
    "lc_low": 14,
    "lc_high": 14
  },
  {
    "scaled_score": 6,
    "rk_low": 12,
    "rk_high": 13,
    "bc_low": 20,
    "bc_high": 20,
    "rv_low": 13,
    "rv_high": 13,
    "psp_low": 15,
    "psp_high": 15,
    "el_low": 7,
    "el_high": 8,
    "wr_low": 14,
    "wr_high": 15,
    "pk_low": 20,
    "pk_high": 21,
    "sc_low": 7,
    "sc_high": 8,
    "swr_low": 10,
    "swr_high": 10,
    "lc_low": 13,
    "lc_high": 13
  },
  {
    "scaled_score": 5,
    "rk_low": 10,
    "rk_high": 11,
    "bc_low": 19,
    "bc_high": 19,
    "rv_low": 12,
    "rv_high": 12,
    "psp_low": 13,
    "psp_high": 14,
    "el_low": 6,
    "el_high": 6,
    "wr_low": 13,
    "wr_high": 13,
    "pk_low": 18,
    "pk_high": 19,
    "sc_low": 6,
    "sc_high": 6,
    "swr_low": 8,
    "swr_high": 9,
    "lc_low": 11,
    "lc_high": 12
  },
  {
    "scaled_score": 4,
    "rk_low": 8,
    "rk_high": 9,
    "bc_low": 18,
    "bc_high": 18,
    "rv_low": 11,
    "rv_high": 11,
    "psp_low": 11,
    "psp_high": 12,
    "el_low": 5,
    "el_high": 5,
    "wr_low": 11,
    "wr_high": 12,
    "pk_low": 16,
    "pk_high": 17,
    "sc_low": 5,
    "sc_high": 5,
    "swr_low": 6,
    "swr_high": 7,
    "lc_low": 10,
    "lc_high": 10
  },
  {
    "scaled_score": 3,
    "rk_low": 5,
    "rk_high": 7,
    "bc_low": 16,
    "bc_high": 17,
    "rv_low": 10,
    "rv_high": 10,
    "psp_low": 9,
    "psp_high": 10,
    "el_low": 3,
    "el_high": 4,
    "wr_low": 9,
    "wr_high": 10,
    "pk_low": 13,
    "pk_high": 15,
    "sc_low": 3,
    "sc_high": 4,
    "swr_low": 4,
    "swr_high": 5,
    "lc_low": 8,
    "lc_high": 9
  },
  {
    "scaled_score": 2,
    "rk_low": 2,
    "rk_high": 4,
    "bc_low": 15,
    "bc_high": 15,
    "rv_low": 8,
    "rv_high": 9,
    "psp_low": 7,
    "psp_high": 8,
    "el_low": 1,
    "el_high": 2,
    "wr_low": 7,
    "wr_high": 8,
    "pk_low": 10,
    "pk_high": 12,
    "sc_low": 1,
    "sc_high": 2,
    "swr_low": 2,
    "swr_high": 3,
    "lc_low": 7,
    "lc_high": 7
  },
  {
    "scaled_score": 1,
    "rk_low": 0,
    "rk_high": 1,
    "bc_low": 0,
    "bc_high": 14,
    "rv_low": 0,
    "rv_high": 7,
    "psp_low": 0,
    "psp_high": 6,
    "el_low": 0,
    "el_high": 0,
    "wr_low": 0,
    "wr_high": 6,
    "pk_low": 0,
    "pk_high": 9,
    "sc_low": 0,
    "sc_high": 0,
    "swr_low": 0,
    "swr_high": 1,
    "lc_low": 0,
    "lc_high": 6
  }
];

const fSpringConfidence: any = [
  {
    "confidence_level": "90%",
    "rk": 2,
    "bc": 3,
    "rv": 3,
    "psp": 3,
    "el": 2,
    "wr": 3,
    "pk": 2,
    "sc": 2,
    "swr": 2,
    "lc": 3
  },
  {
    "confidence_level": "95%",
    "rk": 2,
    "bc": 4,
    "rv": 4,
    "psp": 3,
    "el": 3,
    "wr": 3,
    "pk": 2,
    "sc": 3,
    "swr": 2,
    "lc": 3
  }
];

const pkIndexScores: any = [
  {
    "index_score": 160,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 76,
    "sum_of_subtest_scores_language_index_fall_high": 76,
    "sum_of_subtest_scores_language_index_spring_low": 76,
    "sum_of_subtest_scores_language_index_spring_high": 76
  },
  {
    "index_score": 159,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 158,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 75,
    "sum_of_subtest_scores_language_index_fall_high": 75,
    "sum_of_subtest_scores_language_index_spring_low": 75,
    "sum_of_subtest_scores_language_index_spring_high": 75
  },
  {
    "index_score": 157,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 156,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 74,
    "sum_of_subtest_scores_language_index_fall_high": 74,
    "sum_of_subtest_scores_language_index_spring_low": 74,
    "sum_of_subtest_scores_language_index_spring_high": 74
  },
  {
    "index_score": 155,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 154,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 73,
    "sum_of_subtest_scores_language_index_fall_high": 73,
    "sum_of_subtest_scores_language_index_spring_low": 73,
    "sum_of_subtest_scores_language_index_spring_high": 73
  },
  {
    "index_score": 153,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 152,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 72,
    "sum_of_subtest_scores_language_index_fall_high": 72,
    "sum_of_subtest_scores_language_index_spring_low": 72,
    "sum_of_subtest_scores_language_index_spring_high": 72
  },
  {
    "index_score": 151,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 150,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 38,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 38,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 38,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 38,
    "sum_of_subtest_scores_language_index_fall_low": 71,
    "sum_of_subtest_scores_language_index_fall_high": 71,
    "sum_of_subtest_scores_language_index_spring_low": 71,
    "sum_of_subtest_scores_language_index_spring_high": 71
  },
  {
    "index_score": 149,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 37,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 37,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 37,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 37,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 148,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 70,
    "sum_of_subtest_scores_language_index_fall_high": 70,
    "sum_of_subtest_scores_language_index_spring_low": 70,
    "sum_of_subtest_scores_language_index_spring_high": 70
  },
  {
    "index_score": 147,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 69,
    "sum_of_subtest_scores_language_index_fall_high": 69,
    "sum_of_subtest_scores_language_index_spring_low": 69,
    "sum_of_subtest_scores_language_index_spring_high": 69
  },
  {
    "index_score": 146,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 36,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 36,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 36,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 36,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 145,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 68,
    "sum_of_subtest_scores_language_index_fall_high": 68,
    "sum_of_subtest_scores_language_index_spring_low": 68,
    "sum_of_subtest_scores_language_index_spring_high": 68
  },
  {
    "index_score": 144,
    "percentile_rank": 99.8,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 143,
    "percentile_rank": 99.8,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 35,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 35,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 35,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 35,
    "sum_of_subtest_scores_language_index_fall_low": 67,
    "sum_of_subtest_scores_language_index_fall_high": 67,
    "sum_of_subtest_scores_language_index_spring_low": 67,
    "sum_of_subtest_scores_language_index_spring_high": 67
  },
  {
    "index_score": 142,
    "percentile_rank": 99.7,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 141,
    "percentile_rank": 99.7,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 66,
    "sum_of_subtest_scores_language_index_fall_high": 66,
    "sum_of_subtest_scores_language_index_spring_low": 66,
    "sum_of_subtest_scores_language_index_spring_high": 66
  },
  {
    "index_score": 140,
    "percentile_rank": 99.6,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 34,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 34,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 34,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 34,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 139,
    "percentile_rank": 99.5,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 65,
    "sum_of_subtest_scores_language_index_fall_high": 65,
    "sum_of_subtest_scores_language_index_spring_low": 65,
    "sum_of_subtest_scores_language_index_spring_high": 65
  },
  {
    "index_score": 138,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 64,
    "sum_of_subtest_scores_language_index_fall_high": 64,
    "sum_of_subtest_scores_language_index_spring_low": 64,
    "sum_of_subtest_scores_language_index_spring_high": 64
  },
  {
    "index_score": 137,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 33,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 33,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 33,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 33,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 136,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 63,
    "sum_of_subtest_scores_language_index_fall_high": 63,
    "sum_of_subtest_scores_language_index_spring_low": 63,
    "sum_of_subtest_scores_language_index_spring_high": 63
  },
  {
    "index_score": 135,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 134,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 32,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 32,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 32,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 32,
    "sum_of_subtest_scores_language_index_fall_low": 62,
    "sum_of_subtest_scores_language_index_fall_high": 62,
    "sum_of_subtest_scores_language_index_spring_low": 62,
    "sum_of_subtest_scores_language_index_spring_high": 62
  },
  {
    "index_score": 133,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 132,
    "percentile_rank": 98,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 61,
    "sum_of_subtest_scores_language_index_fall_high": 61,
    "sum_of_subtest_scores_language_index_spring_low": 61,
    "sum_of_subtest_scores_language_index_spring_high": 61
  },
  {
    "index_score": 131,
    "percentile_rank": 98,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 31,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 31,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 31,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 31,
    "sum_of_subtest_scores_language_index_fall_low": 60,
    "sum_of_subtest_scores_language_index_fall_high": 60,
    "sum_of_subtest_scores_language_index_spring_low": 60,
    "sum_of_subtest_scores_language_index_spring_high": 60
  },
  {
    "index_score": 130,
    "percentile_rank": 98,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 129,
    "percentile_rank": 97,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 59,
    "sum_of_subtest_scores_language_index_fall_high": 59,
    "sum_of_subtest_scores_language_index_spring_low": 59,
    "sum_of_subtest_scores_language_index_spring_high": 59
  },
  {
    "index_score": 128,
    "percentile_rank": 97,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 30,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 30,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 30,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 30,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 127,
    "percentile_rank": 96,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 58,
    "sum_of_subtest_scores_language_index_fall_high": 58,
    "sum_of_subtest_scores_language_index_spring_low": 58,
    "sum_of_subtest_scores_language_index_spring_high": 58
  },
  {
    "index_score": 126,
    "percentile_rank": 96,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 57,
    "sum_of_subtest_scores_language_index_fall_high": 57,
    "sum_of_subtest_scores_language_index_spring_low": 57,
    "sum_of_subtest_scores_language_index_spring_high": 57
  },
  {
    "index_score": 125,
    "percentile_rank": 95,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 29,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 29,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 29,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 29,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 124,
    "percentile_rank": 95,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 56,
    "sum_of_subtest_scores_language_index_fall_high": 56,
    "sum_of_subtest_scores_language_index_spring_low": 56,
    "sum_of_subtest_scores_language_index_spring_high": 56
  },
  {
    "index_score": 123,
    "percentile_rank": 94,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 55,
    "sum_of_subtest_scores_language_index_fall_high": 55,
    "sum_of_subtest_scores_language_index_spring_low": 55,
    "sum_of_subtest_scores_language_index_spring_high": 55
  },
  {
    "index_score": 122,
    "percentile_rank": 93,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 28,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 28,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 28,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 28,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 121,
    "percentile_rank": 92,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 54,
    "sum_of_subtest_scores_language_index_fall_high": 54,
    "sum_of_subtest_scores_language_index_spring_low": 54,
    "sum_of_subtest_scores_language_index_spring_high": 54
  },
  {
    "index_score": 120,
    "percentile_rank": 91,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 53,
    "sum_of_subtest_scores_language_index_fall_high": 53,
    "sum_of_subtest_scores_language_index_spring_low": 53,
    "sum_of_subtest_scores_language_index_spring_high": 53
  },
  {
    "index_score": 119,
    "percentile_rank": 90,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 27,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 27,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 27,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 27,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 118,
    "percentile_rank": 88,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 52,
    "sum_of_subtest_scores_language_index_fall_high": 52,
    "sum_of_subtest_scores_language_index_spring_low": 52,
    "sum_of_subtest_scores_language_index_spring_high": 52
  },
  {
    "index_score": 117,
    "percentile_rank": 87,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 51,
    "sum_of_subtest_scores_language_index_fall_high": 51,
    "sum_of_subtest_scores_language_index_spring_low": 51,
    "sum_of_subtest_scores_language_index_spring_high": 51
  },
  {
    "index_score": 116,
    "percentile_rank": 86,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 26,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 26,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 26,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 26,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 115,
    "percentile_rank": 84,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 50,
    "sum_of_subtest_scores_language_index_fall_high": 50,
    "sum_of_subtest_scores_language_index_spring_low": 50,
    "sum_of_subtest_scores_language_index_spring_high": 50
  },
  {
    "index_score": 114,
    "percentile_rank": 82,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 49,
    "sum_of_subtest_scores_language_index_fall_high": 49,
    "sum_of_subtest_scores_language_index_spring_low": 49,
    "sum_of_subtest_scores_language_index_spring_high": 49
  },
  {
    "index_score": 113,
    "percentile_rank": 81,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 25,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 25,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 25,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 25,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 112,
    "percentile_rank": 79,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 48,
    "sum_of_subtest_scores_language_index_fall_high": 48,
    "sum_of_subtest_scores_language_index_spring_low": 48,
    "sum_of_subtest_scores_language_index_spring_high": 48
  },
  {
    "index_score": 111,
    "percentile_rank": 77,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 47,
    "sum_of_subtest_scores_language_index_fall_high": 47,
    "sum_of_subtest_scores_language_index_spring_low": 47,
    "sum_of_subtest_scores_language_index_spring_high": 47
  },
  {
    "index_score": 110,
    "percentile_rank": 75,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 24,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 24,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 24,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 24,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 109,
    "percentile_rank": 73,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 46,
    "sum_of_subtest_scores_language_index_fall_high": 46,
    "sum_of_subtest_scores_language_index_spring_low": 46,
    "sum_of_subtest_scores_language_index_spring_high": 46
  },
  {
    "index_score": 108,
    "percentile_rank": 70,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 23,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 23,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 23,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 23,
    "sum_of_subtest_scores_language_index_fall_low": 45,
    "sum_of_subtest_scores_language_index_fall_high": 45,
    "sum_of_subtest_scores_language_index_spring_low": 45,
    "sum_of_subtest_scores_language_index_spring_high": 45
  },
  {
    "index_score": 107,
    "percentile_rank": 68,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 106,
    "percentile_rank": 66,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 44,
    "sum_of_subtest_scores_language_index_fall_high": 44,
    "sum_of_subtest_scores_language_index_spring_low": 44,
    "sum_of_subtest_scores_language_index_spring_high": 44
  },
  {
    "index_score": 105,
    "percentile_rank": 63,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 22,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 22,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 22,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 22,
    "sum_of_subtest_scores_language_index_fall_low": 43,
    "sum_of_subtest_scores_language_index_fall_high": 43,
    "sum_of_subtest_scores_language_index_spring_low": 43,
    "sum_of_subtest_scores_language_index_spring_high": 43
  },
  {
    "index_score": 104,
    "percentile_rank": 61,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 103,
    "percentile_rank": 58,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 42,
    "sum_of_subtest_scores_language_index_fall_high": 42,
    "sum_of_subtest_scores_language_index_spring_low": 42,
    "sum_of_subtest_scores_language_index_spring_high": 42
  },
  {
    "index_score": 102,
    "percentile_rank": 55,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 21,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 21,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 21,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 21,
    "sum_of_subtest_scores_language_index_fall_low": 41,
    "sum_of_subtest_scores_language_index_fall_high": 41,
    "sum_of_subtest_scores_language_index_spring_low": 41,
    "sum_of_subtest_scores_language_index_spring_high": 41
  },
  {
    "index_score": 101,
    "percentile_rank": 53,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 100,
    "percentile_rank": 50,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 20,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 20,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 20,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 20,
    "sum_of_subtest_scores_language_index_fall_low": 40,
    "sum_of_subtest_scores_language_index_fall_high": 40,
    "sum_of_subtest_scores_language_index_spring_low": 40,
    "sum_of_subtest_scores_language_index_spring_high": 40
  },
  {
    "index_score": 99,
    "percentile_rank": 47,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 39,
    "sum_of_subtest_scores_language_index_fall_high": 39,
    "sum_of_subtest_scores_language_index_spring_low": 39,
    "sum_of_subtest_scores_language_index_spring_high": 39
  },
  {
    "index_score": 98,
    "percentile_rank": 45,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 97,
    "percentile_rank": 42,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 19,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 19,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 19,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 19,
    "sum_of_subtest_scores_language_index_fall_low": 38,
    "sum_of_subtest_scores_language_index_fall_high": 38,
    "sum_of_subtest_scores_language_index_spring_low": 38,
    "sum_of_subtest_scores_language_index_spring_high": 38
  },
  {
    "index_score": 96,
    "percentile_rank": 39,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 37,
    "sum_of_subtest_scores_language_index_fall_high": 37,
    "sum_of_subtest_scores_language_index_spring_low": 37,
    "sum_of_subtest_scores_language_index_spring_high": 37
  },
  {
    "index_score": 95,
    "percentile_rank": 37,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 94,
    "percentile_rank": 34,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 18,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 18,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 18,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 18,
    "sum_of_subtest_scores_language_index_fall_low": 36,
    "sum_of_subtest_scores_language_index_fall_high": 36,
    "sum_of_subtest_scores_language_index_spring_low": 36,
    "sum_of_subtest_scores_language_index_spring_high": 36
  },
  {
    "index_score": 93,
    "percentile_rank": 32,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 35,
    "sum_of_subtest_scores_language_index_fall_high": 35,
    "sum_of_subtest_scores_language_index_spring_low": 35,
    "sum_of_subtest_scores_language_index_spring_high": 35
  },
  {
    "index_score": 92,
    "percentile_rank": 30,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 91,
    "percentile_rank": 27,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 34,
    "sum_of_subtest_scores_language_index_fall_high": 34,
    "sum_of_subtest_scores_language_index_spring_low": 34,
    "sum_of_subtest_scores_language_index_spring_high": 34
  },
  {
    "index_score": 90,
    "percentile_rank": 25,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 17,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 17,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 17,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 17,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 89,
    "percentile_rank": 23,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 33,
    "sum_of_subtest_scores_language_index_fall_high": 33,
    "sum_of_subtest_scores_language_index_spring_low": 33,
    "sum_of_subtest_scores_language_index_spring_high": 33
  },
  {
    "index_score": 88,
    "percentile_rank": 21,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 32,
    "sum_of_subtest_scores_language_index_fall_high": 32,
    "sum_of_subtest_scores_language_index_spring_low": 32,
    "sum_of_subtest_scores_language_index_spring_high": 32
  },
  {
    "index_score": 87,
    "percentile_rank": 19,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 16,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 16,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 16,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 16,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 86,
    "percentile_rank": 18,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 31,
    "sum_of_subtest_scores_language_index_fall_high": 31,
    "sum_of_subtest_scores_language_index_spring_low": 31,
    "sum_of_subtest_scores_language_index_spring_high": 31
  },
  {
    "index_score": 85,
    "percentile_rank": 16,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 30,
    "sum_of_subtest_scores_language_index_fall_high": 30,
    "sum_of_subtest_scores_language_index_spring_low": 30,
    "sum_of_subtest_scores_language_index_spring_high": 30
  },
  {
    "index_score": 84,
    "percentile_rank": 14,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 83,
    "percentile_rank": 13,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 15,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 15,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 15,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 15,
    "sum_of_subtest_scores_language_index_fall_low": 29,
    "sum_of_subtest_scores_language_index_fall_high": 29,
    "sum_of_subtest_scores_language_index_spring_low": 29,
    "sum_of_subtest_scores_language_index_spring_high": 29
  },
  {
    "index_score": 82,
    "percentile_rank": 12,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 28,
    "sum_of_subtest_scores_language_index_fall_high": 28,
    "sum_of_subtest_scores_language_index_spring_low": 28,
    "sum_of_subtest_scores_language_index_spring_high": 28
  },
  {
    "index_score": 81,
    "percentile_rank": 10,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 80,
    "percentile_rank": 9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 14,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 14,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 14,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 14,
    "sum_of_subtest_scores_language_index_fall_low": 27,
    "sum_of_subtest_scores_language_index_fall_high": 27,
    "sum_of_subtest_scores_language_index_spring_low": 27,
    "sum_of_subtest_scores_language_index_spring_high": 27
  },
  {
    "index_score": 79,
    "percentile_rank": 8,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 26,
    "sum_of_subtest_scores_language_index_fall_high": 26,
    "sum_of_subtest_scores_language_index_spring_low": 26,
    "sum_of_subtest_scores_language_index_spring_high": 26
  },
  {
    "index_score": 78,
    "percentile_rank": 7,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 77,
    "percentile_rank": 6,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 25,
    "sum_of_subtest_scores_language_index_fall_high": 25,
    "sum_of_subtest_scores_language_index_spring_low": 25,
    "sum_of_subtest_scores_language_index_spring_high": 25
  },
  {
    "index_score": 76,
    "percentile_rank": 5,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 13,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 13,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 13,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 13,
    "sum_of_subtest_scores_language_index_fall_low": 24,
    "sum_of_subtest_scores_language_index_fall_high": 24,
    "sum_of_subtest_scores_language_index_spring_low": 24,
    "sum_of_subtest_scores_language_index_spring_high": 24
  },
  {
    "index_score": 75,
    "percentile_rank": 5,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 74,
    "percentile_rank": 4,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 23,
    "sum_of_subtest_scores_language_index_fall_high": 23,
    "sum_of_subtest_scores_language_index_spring_low": 23,
    "sum_of_subtest_scores_language_index_spring_high": 23
  },
  {
    "index_score": 73,
    "percentile_rank": 4,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 12,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 12,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 12,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 12,
    "sum_of_subtest_scores_language_index_fall_low": 22,
    "sum_of_subtest_scores_language_index_fall_high": 22,
    "sum_of_subtest_scores_language_index_spring_low": 22,
    "sum_of_subtest_scores_language_index_spring_high": 22
  },
  {
    "index_score": 72,
    "percentile_rank": 3,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 71,
    "percentile_rank": 3,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 21,
    "sum_of_subtest_scores_language_index_fall_high": 21,
    "sum_of_subtest_scores_language_index_spring_low": 21,
    "sum_of_subtest_scores_language_index_spring_high": 21
  },
  {
    "index_score": 70,
    "percentile_rank": 2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 20,
    "sum_of_subtest_scores_language_index_fall_high": 20,
    "sum_of_subtest_scores_language_index_spring_low": 20,
    "sum_of_subtest_scores_language_index_spring_high": 20
  },
  {
    "index_score": 69,
    "percentile_rank": 2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 11,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 11,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 11,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 11,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 68,
    "percentile_rank": 2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 19,
    "sum_of_subtest_scores_language_index_fall_high": 19,
    "sum_of_subtest_scores_language_index_spring_low": 19,
    "sum_of_subtest_scores_language_index_spring_high": 19
  },
  {
    "index_score": 67,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 66,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 10,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 10,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 10,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 10,
    "sum_of_subtest_scores_language_index_fall_low": 18,
    "sum_of_subtest_scores_language_index_fall_high": 18,
    "sum_of_subtest_scores_language_index_spring_low": 18,
    "sum_of_subtest_scores_language_index_spring_high": 18
  },
  {
    "index_score": 65,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 64,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 9,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 9,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 9,
    "sum_of_subtest_scores_language_index_fall_low": 17,
    "sum_of_subtest_scores_language_index_fall_high": 17,
    "sum_of_subtest_scores_language_index_spring_low": 17,
    "sum_of_subtest_scores_language_index_spring_high": 17
  },
  {
    "index_score": 63,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 16,
    "sum_of_subtest_scores_language_index_fall_high": 16,
    "sum_of_subtest_scores_language_index_spring_low": 16,
    "sum_of_subtest_scores_language_index_spring_high": 16
  },
  {
    "index_score": 62,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 61,
    "percentile_rank": 0.5,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 8,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 8,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 8,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 8,
    "sum_of_subtest_scores_language_index_fall_low": 15,
    "sum_of_subtest_scores_language_index_fall_high": 15,
    "sum_of_subtest_scores_language_index_spring_low": 15,
    "sum_of_subtest_scores_language_index_spring_high": 15
  },
  {
    "index_score": 60,
    "percentile_rank": 0.4,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 59,
    "percentile_rank": 0.3,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 7,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 7,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 7,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 7,
    "sum_of_subtest_scores_language_index_fall_low": 14,
    "sum_of_subtest_scores_language_index_fall_high": 14,
    "sum_of_subtest_scores_language_index_spring_low": 14,
    "sum_of_subtest_scores_language_index_spring_high": 14
  },
  {
    "index_score": 58,
    "percentile_rank": 0.3,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 13,
    "sum_of_subtest_scores_language_index_fall_high": 13,
    "sum_of_subtest_scores_language_index_spring_low": 13,
    "sum_of_subtest_scores_language_index_spring_high": 13
  },
  {
    "index_score": 57,
    "percentile_rank": 0.2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 6,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 6,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 6,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 6,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 56,
    "percentile_rank": 0.2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 12,
    "sum_of_subtest_scores_language_index_fall_high": 12,
    "sum_of_subtest_scores_language_index_spring_low": 12,
    "sum_of_subtest_scores_language_index_spring_high": 12
  },
  {
    "index_score": 55,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 5,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 5,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 5,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 5,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 54,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 11,
    "sum_of_subtest_scores_language_index_fall_high": 11,
    "sum_of_subtest_scores_language_index_spring_low": 11,
    "sum_of_subtest_scores_language_index_spring_high": 11
  },
  {
    "index_score": 53,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 4,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 4,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 4,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 4,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 52,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 10,
    "sum_of_subtest_scores_language_index_fall_high": 10,
    "sum_of_subtest_scores_language_index_spring_low": 10,
    "sum_of_subtest_scores_language_index_spring_high": 10
  },
  {
    "index_score": 51,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 3,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 3,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 3,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 3,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 50,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 2,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 2,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 2,
    "sum_of_subtest_scores_language_index_fall_low": 9,
    "sum_of_subtest_scores_language_index_fall_high": 9,
    "sum_of_subtest_scores_language_index_spring_low": 9,
    "sum_of_subtest_scores_language_index_spring_high": 9
  },
  {
    "index_score": 49,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 48,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 8,
    "sum_of_subtest_scores_language_index_fall_high": 8,
    "sum_of_subtest_scores_language_index_spring_low": 8,
    "sum_of_subtest_scores_language_index_spring_high": 8
  },
  {
    "index_score": 47,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 46,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 7,
    "sum_of_subtest_scores_language_index_fall_high": 7,
    "sum_of_subtest_scores_language_index_spring_low": 7,
    "sum_of_subtest_scores_language_index_spring_high": 7
  },
  {
    "index_score": 45,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 44,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 6,
    "sum_of_subtest_scores_language_index_fall_high": 6,
    "sum_of_subtest_scores_language_index_spring_low": 6,
    "sum_of_subtest_scores_language_index_spring_high": 6
  },
  {
    "index_score": 43,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 42,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 5,
    "sum_of_subtest_scores_language_index_fall_high": 5,
    "sum_of_subtest_scores_language_index_spring_low": 5,
    "sum_of_subtest_scores_language_index_spring_high": 5
  },
  {
    "index_score": 41,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 40,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 4,
    "sum_of_subtest_scores_language_index_fall_high": 4,
    "sum_of_subtest_scores_language_index_spring_low": 4,
    "sum_of_subtest_scores_language_index_spring_high": 4
  }
];

const kIndexScores1: any = [
  {
    "index_score": 160,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 114,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 114,
    "sum_of_subtest_scores_language_index_fall_low": 95,
    "sum_of_subtest_scores_language_index_fall_high": 95,
    "sum_of_subtest_scores_language_index_spring_low": 95,
    "sum_of_subtest_scores_language_index_spring_high": 95
  },
  {
    "index_score": 159,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 94,
    "sum_of_subtest_scores_language_index_fall_high": 94,
    "sum_of_subtest_scores_language_index_spring_low": 94,
    "sum_of_subtest_scores_language_index_spring_high": 94
  },
  {
    "index_score": 158,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 113,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 113,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 157,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 112,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 112,
    "sum_of_subtest_scores_language_index_fall_low": 93,
    "sum_of_subtest_scores_language_index_fall_high": 93,
    "sum_of_subtest_scores_language_index_spring_low": 93,
    "sum_of_subtest_scores_language_index_spring_high": 93
  },
  {
    "index_score": 156,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 111,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 111,
    "sum_of_subtest_scores_language_index_fall_low": 92,
    "sum_of_subtest_scores_language_index_fall_high": 92,
    "sum_of_subtest_scores_language_index_spring_low": 92,
    "sum_of_subtest_scores_language_index_spring_high": 92
  },
  {
    "index_score": 155,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 56,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 57,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 91,
    "sum_of_subtest_scores_language_index_fall_high": 91,
    "sum_of_subtest_scores_language_index_spring_low": 91,
    "sum_of_subtest_scores_language_index_spring_high": 91
  },
  {
    "index_score": 154,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 110,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 110,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 153,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 55,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 55,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 109,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 109,
    "sum_of_subtest_scores_language_index_fall_low": 90,
    "sum_of_subtest_scores_language_index_fall_high": 90,
    "sum_of_subtest_scores_language_index_spring_low": 90,
    "sum_of_subtest_scores_language_index_spring_high": 90
  },
  {
    "index_score": 152,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 108,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 108,
    "sum_of_subtest_scores_language_index_fall_low": 89,
    "sum_of_subtest_scores_language_index_fall_high": 89,
    "sum_of_subtest_scores_language_index_spring_low": 89,
    "sum_of_subtest_scores_language_index_spring_high": 89
  },
  {
    "index_score": 151,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 54,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 54,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 107,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 107,
    "sum_of_subtest_scores_language_index_fall_low": 88,
    "sum_of_subtest_scores_language_index_fall_high": 88,
    "sum_of_subtest_scores_language_index_spring_low": 88,
    "sum_of_subtest_scores_language_index_spring_high": 88
  },
  {
    "index_score": 150,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 149,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 53,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 53,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 106,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 106,
    "sum_of_subtest_scores_language_index_fall_low": 87,
    "sum_of_subtest_scores_language_index_fall_high": 87,
    "sum_of_subtest_scores_language_index_spring_low": 87,
    "sum_of_subtest_scores_language_index_spring_high": 87
  },
  {
    "index_score": 148,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 105,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 105,
    "sum_of_subtest_scores_language_index_fall_low": 86,
    "sum_of_subtest_scores_language_index_fall_high": 86,
    "sum_of_subtest_scores_language_index_spring_low": 86,
    "sum_of_subtest_scores_language_index_spring_high": 86
  },
  {
    "index_score": 147,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 52,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 52,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 104,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 104,
    "sum_of_subtest_scores_language_index_fall_low": 85,
    "sum_of_subtest_scores_language_index_fall_high": 85,
    "sum_of_subtest_scores_language_index_spring_low": 85,
    "sum_of_subtest_scores_language_index_spring_high": 85
  },
  {
    "index_score": 146,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 103,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 103,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 145,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 51,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 51,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 84,
    "sum_of_subtest_scores_language_index_fall_high": 84,
    "sum_of_subtest_scores_language_index_spring_low": 84,
    "sum_of_subtest_scores_language_index_spring_high": 84
  },
  {
    "index_score": 144,
    "percentile_rank": 99.8,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 102,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 102,
    "sum_of_subtest_scores_language_index_fall_low": 83,
    "sum_of_subtest_scores_language_index_fall_high": 83,
    "sum_of_subtest_scores_language_index_spring_low": 83,
    "sum_of_subtest_scores_language_index_spring_high": 83
  },
  {
    "index_score": 143,
    "percentile_rank": 99.8,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 50,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 50,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 101,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 101,
    "sum_of_subtest_scores_language_index_fall_low": 82,
    "sum_of_subtest_scores_language_index_fall_high": 82,
    "sum_of_subtest_scores_language_index_spring_low": 82,
    "sum_of_subtest_scores_language_index_spring_high": 82
  },
  {
    "index_score": 142,
    "percentile_rank": 99.7,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 100,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 100,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 141,
    "percentile_rank": 99.7,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 49,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 49,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 99,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 99,
    "sum_of_subtest_scores_language_index_fall_low": 81,
    "sum_of_subtest_scores_language_index_fall_high": 81,
    "sum_of_subtest_scores_language_index_spring_low": 81,
    "sum_of_subtest_scores_language_index_spring_high": 81
  },
  {
    "index_score": 140,
    "percentile_rank": 99.6,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 80,
    "sum_of_subtest_scores_language_index_fall_high": 80,
    "sum_of_subtest_scores_language_index_spring_low": 80,
    "sum_of_subtest_scores_language_index_spring_high": 80
  },
  {
    "index_score": 139,
    "percentile_rank": 99.5,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 48,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 48,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 98,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 98,
    "sum_of_subtest_scores_language_index_fall_low": 79,
    "sum_of_subtest_scores_language_index_fall_high": 79,
    "sum_of_subtest_scores_language_index_spring_low": 79,
    "sum_of_subtest_scores_language_index_spring_high": 79
  },
  {
    "index_score": 138,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 97,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 97,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 137,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 47,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 47,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 96,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 96,
    "sum_of_subtest_scores_language_index_fall_low": 78,
    "sum_of_subtest_scores_language_index_fall_high": 78,
    "sum_of_subtest_scores_language_index_spring_low": 78,
    "sum_of_subtest_scores_language_index_spring_high": 78
  },
  {
    "index_score": 136,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 95,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 95,
    "sum_of_subtest_scores_language_index_fall_low": 77,
    "sum_of_subtest_scores_language_index_fall_high": 77,
    "sum_of_subtest_scores_language_index_spring_low": 77,
    "sum_of_subtest_scores_language_index_spring_high": 77
  },
  {
    "index_score": 135,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 46,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 46,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 94,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 94,
    "sum_of_subtest_scores_language_index_fall_low": 76,
    "sum_of_subtest_scores_language_index_fall_high": 76,
    "sum_of_subtest_scores_language_index_spring_low": 76,
    "sum_of_subtest_scores_language_index_spring_high": 76
  },
  {
    "index_score": 134,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 93,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 93,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 133,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 45,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 45,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 92,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 92,
    "sum_of_subtest_scores_language_index_fall_low": 75,
    "sum_of_subtest_scores_language_index_fall_high": 75,
    "sum_of_subtest_scores_language_index_spring_low": 75,
    "sum_of_subtest_scores_language_index_spring_high": 75
  },
  {
    "index_score": 132,
    "percentile_rank": 98,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 91,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 91,
    "sum_of_subtest_scores_language_index_fall_low": 74,
    "sum_of_subtest_scores_language_index_fall_high": 74,
    "sum_of_subtest_scores_language_index_spring_low": 74,
    "sum_of_subtest_scores_language_index_spring_high": 74
  },
  {
    "index_score": 131,
    "percentile_rank": 98,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 44,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 44,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 90,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 90,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 130,
    "percentile_rank": 98,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 73,
    "sum_of_subtest_scores_language_index_fall_high": 73,
    "sum_of_subtest_scores_language_index_spring_low": 73,
    "sum_of_subtest_scores_language_index_spring_high": 73
  },
  {
    "index_score": 129,
    "percentile_rank": 97,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 43,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 43,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 89,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 89,
    "sum_of_subtest_scores_language_index_fall_low": 72,
    "sum_of_subtest_scores_language_index_fall_high": 72,
    "sum_of_subtest_scores_language_index_spring_low": 72,
    "sum_of_subtest_scores_language_index_spring_high": 72
  },
  {
    "index_score": 128,
    "percentile_rank": 97,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 88,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 88,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 127,
    "percentile_rank": 96,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 42,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 42,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 87,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 87,
    "sum_of_subtest_scores_language_index_fall_low": 71,
    "sum_of_subtest_scores_language_index_fall_high": 71,
    "sum_of_subtest_scores_language_index_spring_low": 71,
    "sum_of_subtest_scores_language_index_spring_high": 71
  },
  {
    "index_score": 126,
    "percentile_rank": 96,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 86,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 86,
    "sum_of_subtest_scores_language_index_fall_low": 70,
    "sum_of_subtest_scores_language_index_fall_high": 70,
    "sum_of_subtest_scores_language_index_spring_low": 70,
    "sum_of_subtest_scores_language_index_spring_high": 70
  },
  {
    "index_score": 125,
    "percentile_rank": 95,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 41,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 41,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 85,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 85,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 124,
    "percentile_rank": 95,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 84,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 84,
    "sum_of_subtest_scores_language_index_fall_low": 69,
    "sum_of_subtest_scores_language_index_fall_high": 69,
    "sum_of_subtest_scores_language_index_spring_low": 69,
    "sum_of_subtest_scores_language_index_spring_high": 69
  },
  {
    "index_score": 123,
    "percentile_rank": 94,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 40,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 40,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 83,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 83,
    "sum_of_subtest_scores_language_index_fall_low": 68,
    "sum_of_subtest_scores_language_index_fall_high": 68,
    "sum_of_subtest_scores_language_index_spring_low": 68,
    "sum_of_subtest_scores_language_index_spring_high": 68
  },
  {
    "index_score": 122,
    "percentile_rank": 93,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 82,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 82,
    "sum_of_subtest_scores_language_index_fall_low": 67,
    "sum_of_subtest_scores_language_index_fall_high": 67,
    "sum_of_subtest_scores_language_index_spring_low": 67,
    "sum_of_subtest_scores_language_index_spring_high": 67
  },
  {
    "index_score": 121,
    "percentile_rank": 92,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 39,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 39,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 81,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 81,
    "sum_of_subtest_scores_language_index_fall_low": 66,
    "sum_of_subtest_scores_language_index_fall_high": 66,
    "sum_of_subtest_scores_language_index_spring_low": 66,
    "sum_of_subtest_scores_language_index_spring_high": 66
  },
  {
    "index_score": 120,
    "percentile_rank": 91,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 119,
    "percentile_rank": 90,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 38,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 38,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 80,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 80,
    "sum_of_subtest_scores_language_index_fall_low": 65,
    "sum_of_subtest_scores_language_index_fall_high": 65,
    "sum_of_subtest_scores_language_index_spring_low": 65,
    "sum_of_subtest_scores_language_index_spring_high": 65
  },
  {
    "index_score": 118,
    "percentile_rank": 88,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 79,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 79,
    "sum_of_subtest_scores_language_index_fall_low": 64,
    "sum_of_subtest_scores_language_index_fall_high": 64,
    "sum_of_subtest_scores_language_index_spring_low": 64,
    "sum_of_subtest_scores_language_index_spring_high": 64
  },
  {
    "index_score": 117,
    "percentile_rank": 87,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 37,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 37,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 78,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 78,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 116,
    "percentile_rank": 86,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 77,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 77,
    "sum_of_subtest_scores_language_index_fall_low": 63,
    "sum_of_subtest_scores_language_index_fall_high": 63,
    "sum_of_subtest_scores_language_index_spring_low": 63,
    "sum_of_subtest_scores_language_index_spring_high": 63
  },
  {
    "index_score": 115,
    "percentile_rank": 84,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 36,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 36,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 76,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 76,
    "sum_of_subtest_scores_language_index_fall_low": 62,
    "sum_of_subtest_scores_language_index_fall_high": 62,
    "sum_of_subtest_scores_language_index_spring_low": 62,
    "sum_of_subtest_scores_language_index_spring_high": 62
  },
  {
    "index_score": 114,
    "percentile_rank": 82,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 75,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 75,
    "sum_of_subtest_scores_language_index_fall_low": 61,
    "sum_of_subtest_scores_language_index_fall_high": 61,
    "sum_of_subtest_scores_language_index_spring_low": 61,
    "sum_of_subtest_scores_language_index_spring_high": 61
  },
  {
    "index_score": 113,
    "percentile_rank": 81,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 35,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 35,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 74,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 74,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 112,
    "percentile_rank": 79,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 73,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 73,
    "sum_of_subtest_scores_language_index_fall_low": 60,
    "sum_of_subtest_scores_language_index_fall_high": 60,
    "sum_of_subtest_scores_language_index_spring_low": 60,
    "sum_of_subtest_scores_language_index_spring_high": 60
  },
  {
    "index_score": 111,
    "percentile_rank": 77,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 34,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 34,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 72,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 72,
    "sum_of_subtest_scores_language_index_fall_low": 59,
    "sum_of_subtest_scores_language_index_fall_high": 59,
    "sum_of_subtest_scores_language_index_spring_low": 59,
    "sum_of_subtest_scores_language_index_spring_high": 59
  },
  {
    "index_score": 110,
    "percentile_rank": 75,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 71,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 71,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 109,
    "percentile_rank": 73,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 33,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 33,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "69–70",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "69–70",
    "sum_of_subtest_scores_language_index_fall_low": 58,
    "sum_of_subtest_scores_language_index_fall_high": 58,
    "sum_of_subtest_scores_language_index_spring_low": 58,
    "sum_of_subtest_scores_language_index_spring_high": 58
  },
  {
    "index_score": 108,
    "percentile_rank": 70,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 68,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 68,
    "sum_of_subtest_scores_language_index_fall_low": 57,
    "sum_of_subtest_scores_language_index_fall_high": 57,
    "sum_of_subtest_scores_language_index_spring_low": 57,
    "sum_of_subtest_scores_language_index_spring_high": 57
  },
  {
    "index_score": 107,
    "percentile_rank": 68,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 67,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 67,
    "sum_of_subtest_scores_language_index_fall_low": 56,
    "sum_of_subtest_scores_language_index_fall_high": 56,
    "sum_of_subtest_scores_language_index_spring_low": 56,
    "sum_of_subtest_scores_language_index_spring_high": 56
  },
  {
    "index_score": 106,
    "percentile_rank": 66,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 32,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 32,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 66,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 66,
    "sum_of_subtest_scores_language_index_fall_low": 55,
    "sum_of_subtest_scores_language_index_fall_high": 55,
    "sum_of_subtest_scores_language_index_spring_low": 55,
    "sum_of_subtest_scores_language_index_spring_high": 55
  },
  {
    "index_score": 105,
    "percentile_rank": 63,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 65,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 65,
    "sum_of_subtest_scores_language_index_fall_low": 54,
    "sum_of_subtest_scores_language_index_fall_high": 54,
    "sum_of_subtest_scores_language_index_spring_low": 54,
    "sum_of_subtest_scores_language_index_spring_high": 54
  },
  {
    "index_score": 104,
    "percentile_rank": 61,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 64,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 64,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 103,
    "percentile_rank": 58,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 31,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 31,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 63,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 63,
    "sum_of_subtest_scores_language_index_fall_low": 53,
    "sum_of_subtest_scores_language_index_fall_high": 53,
    "sum_of_subtest_scores_language_index_spring_low": 53,
    "sum_of_subtest_scores_language_index_spring_high": 53
  },
  {
    "index_score": 102,
    "percentile_rank": 55,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 62,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 62,
    "sum_of_subtest_scores_language_index_fall_low": 52,
    "sum_of_subtest_scores_language_index_fall_high": 52,
    "sum_of_subtest_scores_language_index_spring_low": 52,
    "sum_of_subtest_scores_language_index_spring_high": 52
  },
  {
    "index_score": 101,
    "percentile_rank": 53,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 61,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 61,
    "sum_of_subtest_scores_language_index_fall_low": 51,
    "sum_of_subtest_scores_language_index_fall_high": 51,
    "sum_of_subtest_scores_language_index_spring_low": 51,
    "sum_of_subtest_scores_language_index_spring_high": 51
  },
  {
    "index_score": 100,
    "percentile_rank": 50,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 30,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 30,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 60,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 60,
    "sum_of_subtest_scores_language_index_fall_low": 50,
    "sum_of_subtest_scores_language_index_fall_high": 50,
    "sum_of_subtest_scores_language_index_spring_low": 50,
    "sum_of_subtest_scores_language_index_spring_high": 50
  },
  {
    "index_score": 99,
    "percentile_rank": 47,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 59,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 59,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 98,
    "percentile_rank": 45,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 29,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 29,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 58,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 58,
    "sum_of_subtest_scores_language_index_fall_low": 49,
    "sum_of_subtest_scores_language_index_fall_high": 49,
    "sum_of_subtest_scores_language_index_spring_low": 49,
    "sum_of_subtest_scores_language_index_spring_high": 49
  },
  {
    "index_score": 97,
    "percentile_rank": 42,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 48,
    "sum_of_subtest_scores_language_index_fall_high": 48,
    "sum_of_subtest_scores_language_index_spring_low": 48,
    "sum_of_subtest_scores_language_index_spring_high": 48
  },
  {
    "index_score": 96,
    "percentile_rank": 39,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 28,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 28,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 57,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 57,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 95,
    "percentile_rank": 37,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 56,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 56,
    "sum_of_subtest_scores_language_index_fall_low": 47,
    "sum_of_subtest_scores_language_index_fall_high": 47,
    "sum_of_subtest_scores_language_index_spring_low": 47,
    "sum_of_subtest_scores_language_index_spring_high": 47
  },
  {
    "index_score": 94,
    "percentile_rank": 34,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 27,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 27,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 46,
    "sum_of_subtest_scores_language_index_fall_high": 46,
    "sum_of_subtest_scores_language_index_spring_low": 46,
    "sum_of_subtest_scores_language_index_spring_high": 46
  },
  {
    "index_score": 93,
    "percentile_rank": 32,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 55,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 55,
    "sum_of_subtest_scores_language_index_fall_low": 45,
    "sum_of_subtest_scores_language_index_fall_high": 45,
    "sum_of_subtest_scores_language_index_spring_low": 45,
    "sum_of_subtest_scores_language_index_spring_high": 45
  },
  {
    "index_score": 92,
    "percentile_rank": 30,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 26,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 26,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 91,
    "percentile_rank": 27,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 54,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 54,
    "sum_of_subtest_scores_language_index_fall_low": 44,
    "sum_of_subtest_scores_language_index_fall_high": 44,
    "sum_of_subtest_scores_language_index_spring_low": 44,
    "sum_of_subtest_scores_language_index_spring_high": 44
  },
  {
    "index_score": 90,
    "percentile_rank": 25,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 25,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 25,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 43,
    "sum_of_subtest_scores_language_index_fall_high": 43,
    "sum_of_subtest_scores_language_index_spring_low": 43,
    "sum_of_subtest_scores_language_index_spring_high": 43
  },
  {
    "index_score": 89,
    "percentile_rank": 23,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 53,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 53,
    "sum_of_subtest_scores_language_index_fall_low": 42,
    "sum_of_subtest_scores_language_index_fall_high": 42,
    "sum_of_subtest_scores_language_index_spring_low": 42,
    "sum_of_subtest_scores_language_index_spring_high": 42
  },
  {
    "index_score": 88,
    "percentile_rank": 21,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 24,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 24,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 52,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 52,
    "sum_of_subtest_scores_language_index_fall_low": 41,
    "sum_of_subtest_scores_language_index_fall_high": 41,
    "sum_of_subtest_scores_language_index_spring_low": 41,
    "sum_of_subtest_scores_language_index_spring_high": 41
  },
  {
    "index_score": 87,
    "percentile_rank": 19,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 51,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 51,
    "sum_of_subtest_scores_language_index_fall_low": 40,
    "sum_of_subtest_scores_language_index_fall_high": 40,
    "sum_of_subtest_scores_language_index_spring_low": 40,
    "sum_of_subtest_scores_language_index_spring_high": 40
  },
  {
    "index_score": 86,
    "percentile_rank": 18,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 23,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 23,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 50,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 50,
    "sum_of_subtest_scores_language_index_fall_low": 39,
    "sum_of_subtest_scores_language_index_fall_high": 39,
    "sum_of_subtest_scores_language_index_spring_low": 39,
    "sum_of_subtest_scores_language_index_spring_high": 39
  },
  {
    "index_score": 85,
    "percentile_rank": 16,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 49,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 49,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 84,
    "percentile_rank": 14,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 22,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 22,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 48,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 48,
    "sum_of_subtest_scores_language_index_fall_low": 38,
    "sum_of_subtest_scores_language_index_fall_high": 38,
    "sum_of_subtest_scores_language_index_spring_low": 38,
    "sum_of_subtest_scores_language_index_spring_high": 38
  },
  {
    "index_score": 83,
    "percentile_rank": 13,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 47,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 47,
    "sum_of_subtest_scores_language_index_fall_low": 37,
    "sum_of_subtest_scores_language_index_fall_high": 37,
    "sum_of_subtest_scores_language_index_spring_low": 37,
    "sum_of_subtest_scores_language_index_spring_high": 37
  },
  {
    "index_score": 82,
    "percentile_rank": 12,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 21,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 21,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 46,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 46,
    "sum_of_subtest_scores_language_index_fall_low": 36,
    "sum_of_subtest_scores_language_index_fall_high": 36,
    "sum_of_subtest_scores_language_index_spring_low": 36,
    "sum_of_subtest_scores_language_index_spring_high": 36
  },
  {
    "index_score": 81,
    "percentile_rank": 10,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 35,
    "sum_of_subtest_scores_language_index_fall_high": 35,
    "sum_of_subtest_scores_language_index_spring_low": 35,
    "sum_of_subtest_scores_language_index_spring_high": 35
  },
  {
    "index_score": 80,
    "percentile_rank": 9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 20,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 20,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 45,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 45,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 79,
    "percentile_rank": 8,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 44,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 44,
    "sum_of_subtest_scores_language_index_fall_low": 34,
    "sum_of_subtest_scores_language_index_fall_high": 34,
    "sum_of_subtest_scores_language_index_spring_low": 34,
    "sum_of_subtest_scores_language_index_spring_high": 34
  },
  {
    "index_score": 78,
    "percentile_rank": 7,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 19,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 19,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 43,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 43,
    "sum_of_subtest_scores_language_index_fall_low": 33,
    "sum_of_subtest_scores_language_index_fall_high": 33,
    "sum_of_subtest_scores_language_index_spring_low": 33,
    "sum_of_subtest_scores_language_index_spring_high": 33
  },
  {
    "index_score": 77,
    "percentile_rank": 6,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 42,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 42,
    "sum_of_subtest_scores_language_index_fall_low": 32,
    "sum_of_subtest_scores_language_index_fall_high": 32,
    "sum_of_subtest_scores_language_index_spring_low": 32,
    "sum_of_subtest_scores_language_index_spring_high": 32
  },
  {
    "index_score": 76,
    "percentile_rank": 5,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 18,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 18,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 41,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 41,
    "sum_of_subtest_scores_language_index_fall_low": 31,
    "sum_of_subtest_scores_language_index_fall_high": 31,
    "sum_of_subtest_scores_language_index_spring_low": 31,
    "sum_of_subtest_scores_language_index_spring_high": 31
  },
  {
    "index_score": 75,
    "percentile_rank": 5,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 40,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 40,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 74,
    "percentile_rank": 4,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 17,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 17,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 30,
    "sum_of_subtest_scores_language_index_fall_high": 30,
    "sum_of_subtest_scores_language_index_spring_low": 30,
    "sum_of_subtest_scores_language_index_spring_high": 30
  },
  {
    "index_score": 73,
    "percentile_rank": 4,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 39,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 39,
    "sum_of_subtest_scores_language_index_fall_low": 29,
    "sum_of_subtest_scores_language_index_fall_high": 29,
    "sum_of_subtest_scores_language_index_spring_low": 29,
    "sum_of_subtest_scores_language_index_spring_high": 29
  },
  {
    "index_score": 72,
    "percentile_rank": 3,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 16,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 16,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 38,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 38,
    "sum_of_subtest_scores_language_index_fall_low": 28,
    "sum_of_subtest_scores_language_index_fall_high": 28,
    "sum_of_subtest_scores_language_index_spring_low": 28,
    "sum_of_subtest_scores_language_index_spring_high": 28
  },
  {
    "index_score": 71,
    "percentile_rank": 3,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 37,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 37,
    "sum_of_subtest_scores_language_index_fall_low": 27,
    "sum_of_subtest_scores_language_index_fall_high": 27,
    "sum_of_subtest_scores_language_index_spring_low": 27,
    "sum_of_subtest_scores_language_index_spring_high": 27
  },
  {
    "index_score": 70,
    "percentile_rank": 2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 26,
    "sum_of_subtest_scores_language_index_fall_high": 26,
    "sum_of_subtest_scores_language_index_spring_low": 26,
    "sum_of_subtest_scores_language_index_spring_high": 26
  },
  {
    "index_score": 69,
    "percentile_rank": 2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 15,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 15,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 36,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 36,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 68,
    "percentile_rank": 2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 35,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 35,
    "sum_of_subtest_scores_language_index_fall_low": 25,
    "sum_of_subtest_scores_language_index_fall_high": 25,
    "sum_of_subtest_scores_language_index_spring_low": 25,
    "sum_of_subtest_scores_language_index_spring_high": 25
  },
  {
    "index_score": 67,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 14,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 14,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 34,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 34,
    "sum_of_subtest_scores_language_index_fall_low": 24,
    "sum_of_subtest_scores_language_index_fall_high": 24,
    "sum_of_subtest_scores_language_index_spring_low": 24,
    "sum_of_subtest_scores_language_index_spring_high": 24
  },
  {
    "index_score": 66,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 65,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 13,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 13,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 33,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 33,
    "sum_of_subtest_scores_language_index_fall_low": 23,
    "sum_of_subtest_scores_language_index_fall_high": 23,
    "sum_of_subtest_scores_language_index_spring_low": 23,
    "sum_of_subtest_scores_language_index_spring_high": 23
  },
  {
    "index_score": 64,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 32,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 32,
    "sum_of_subtest_scores_language_index_fall_low": 22,
    "sum_of_subtest_scores_language_index_fall_high": 22,
    "sum_of_subtest_scores_language_index_spring_low": 22,
    "sum_of_subtest_scores_language_index_spring_high": 22
  },
  {
    "index_score": 63,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 12,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 12,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 31,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 31,
    "sum_of_subtest_scores_language_index_fall_low": 21,
    "sum_of_subtest_scores_language_index_fall_high": 21,
    "sum_of_subtest_scores_language_index_spring_low": 21,
    "sum_of_subtest_scores_language_index_spring_high": 21
  },
  {
    "index_score": 62,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 61,
    "percentile_rank": 0.5,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 11,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 11,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 30,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 30,
    "sum_of_subtest_scores_language_index_fall_low": 20,
    "sum_of_subtest_scores_language_index_fall_high": 20,
    "sum_of_subtest_scores_language_index_spring_low": 20,
    "sum_of_subtest_scores_language_index_spring_high": 20
  },
  {
    "index_score": 60,
    "percentile_rank": 0.4,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 29,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 29,
    "sum_of_subtest_scores_language_index_fall_low": 19,
    "sum_of_subtest_scores_language_index_fall_high": 19,
    "sum_of_subtest_scores_language_index_spring_low": 19,
    "sum_of_subtest_scores_language_index_spring_high": 19
  },
  {
    "index_score": 59,
    "percentile_rank": 0.3,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 10,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 10,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 28,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 28,
    "sum_of_subtest_scores_language_index_fall_low": 18,
    "sum_of_subtest_scores_language_index_fall_high": 18,
    "sum_of_subtest_scores_language_index_spring_low": 18,
    "sum_of_subtest_scores_language_index_spring_high": 18
  },
  {
    "index_score": 58,
    "percentile_rank": 0.3,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 57,
    "percentile_rank": 0.2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 9,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 27,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 27,
    "sum_of_subtest_scores_language_index_fall_low": 17,
    "sum_of_subtest_scores_language_index_fall_high": 17,
    "sum_of_subtest_scores_language_index_spring_low": 17,
    "sum_of_subtest_scores_language_index_spring_high": 17
  },
  {
    "index_score": 56,
    "percentile_rank": 0.2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 26,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 26,
    "sum_of_subtest_scores_language_index_fall_low": 16,
    "sum_of_subtest_scores_language_index_fall_high": 16,
    "sum_of_subtest_scores_language_index_spring_low": 16,
    "sum_of_subtest_scores_language_index_spring_high": 16
  },
  {
    "index_score": 55,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 8,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 8,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 25,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 25,
    "sum_of_subtest_scores_language_index_fall_low": 15,
    "sum_of_subtest_scores_language_index_fall_high": 15,
    "sum_of_subtest_scores_language_index_spring_low": 15,
    "sum_of_subtest_scores_language_index_spring_high": 15
  },
  {
    "index_score": 54,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 53,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 7,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 7,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 24,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 24,
    "sum_of_subtest_scores_language_index_fall_low": 14,
    "sum_of_subtest_scores_language_index_fall_high": 14,
    "sum_of_subtest_scores_language_index_spring_low": 14,
    "sum_of_subtest_scores_language_index_spring_high": 14
  },
  {
    "index_score": 52,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 23,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 23,
    "sum_of_subtest_scores_language_index_fall_low": 13,
    "sum_of_subtest_scores_language_index_fall_high": 13,
    "sum_of_subtest_scores_language_index_spring_low": 13,
    "sum_of_subtest_scores_language_index_spring_high": 13
  },
  {
    "index_score": 51,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 6,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 6,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 22,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 22,
    "sum_of_subtest_scores_language_index_fall_low": 12,
    "sum_of_subtest_scores_language_index_fall_high": 12,
    "sum_of_subtest_scores_language_index_spring_low": 12,
    "sum_of_subtest_scores_language_index_spring_high": 12
  },
  {
    "index_score": 50,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 49,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 5,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 5,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 21,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 21,
    "sum_of_subtest_scores_language_index_fall_low": 11,
    "sum_of_subtest_scores_language_index_fall_high": 11,
    "sum_of_subtest_scores_language_index_spring_low": 11,
    "sum_of_subtest_scores_language_index_spring_high": 11
  },
  {
    "index_score": 48,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 20,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 20,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 47,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 4,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 4,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 19,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 19,
    "sum_of_subtest_scores_language_index_fall_low": 10,
    "sum_of_subtest_scores_language_index_fall_high": 10,
    "sum_of_subtest_scores_language_index_spring_low": 10,
    "sum_of_subtest_scores_language_index_spring_high": 10
  },
  {
    "index_score": 46,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 9,
    "sum_of_subtest_scores_language_index_fall_high": 9,
    "sum_of_subtest_scores_language_index_spring_low": 9,
    "sum_of_subtest_scores_language_index_spring_high": 9
  },
  {
    "index_score": 45,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 3,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 3,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 18,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 18,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 44,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 17,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 17,
    "sum_of_subtest_scores_language_index_fall_low": 8,
    "sum_of_subtest_scores_language_index_fall_high": 8,
    "sum_of_subtest_scores_language_index_spring_low": 8,
    "sum_of_subtest_scores_language_index_spring_high": 8
  },
  {
    "index_score": 43,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 16,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 16,
    "sum_of_subtest_scores_language_index_fall_low": 7,
    "sum_of_subtest_scores_language_index_fall_high": 7,
    "sum_of_subtest_scores_language_index_spring_low": 7,
    "sum_of_subtest_scores_language_index_spring_high": 7
  },
  {
    "index_score": 42,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 6,
    "sum_of_subtest_scores_language_index_fall_high": 6,
    "sum_of_subtest_scores_language_index_spring_low": 6,
    "sum_of_subtest_scores_language_index_spring_high": 6
  },
  {
    "index_score": 41,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 15,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 15,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 40,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 6,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 14,
    "sum_of_subtest_scores_language_index_fall_low": 5,
    "sum_of_subtest_scores_language_index_fall_high": 5,
    "sum_of_subtest_scores_language_index_spring_low": 5,
    "sum_of_subtest_scores_language_index_spring_high": 5
  }
];

const kIndexScores2: any = [
  {
    "index_score": 155,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 57,
    "sum_of_subtest_scores_phonological_index_spring_high": 57,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 57,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 57
  },
  {
    "index_score": 154,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 56,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 56
  },
  {
    "index_score": 153,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 56,
    "sum_of_subtest_scores_phonological_index_spring_high": 56,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 152,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 55,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 55
  },
  {
    "index_score": 151,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 55,
    "sum_of_subtest_scores_phonological_index_spring_high": 55,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 150,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_phonological_index_fall_low": 37,
    "sum_of_subtest_scores_phonological_index_fall_high": 38,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 149,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_phonological_index_fall_low": 36,
    "sum_of_subtest_scores_phonological_index_fall_high": 36,
    "sum_of_subtest_scores_phonological_index_spring_low": 54,
    "sum_of_subtest_scores_phonological_index_spring_high": 54,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 54,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 54
  },
  {
    "index_score": 148,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 147,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 53,
    "sum_of_subtest_scores_phonological_index_spring_high": 53,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 53,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 53
  },
  {
    "index_score": 146,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_phonological_index_fall_low": 35,
    "sum_of_subtest_scores_phonological_index_fall_high": 35,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 145,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 52,
    "sum_of_subtest_scores_phonological_index_spring_high": 52,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 52,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 52
  },
  {
    "index_score": 144,
    "percentile_rank": 99.8,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 143,
    "percentile_rank": 99.8,
    "sum_of_subtest_scores_phonological_index_fall_low": 34,
    "sum_of_subtest_scores_phonological_index_fall_high": 34,
    "sum_of_subtest_scores_phonological_index_spring_low": 51,
    "sum_of_subtest_scores_phonological_index_spring_high": 51,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 142,
    "percentile_rank": 99.7,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 51,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 51
  },
  {
    "index_score": 141,
    "percentile_rank": 99.7,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 50,
    "sum_of_subtest_scores_phonological_index_spring_high": 50,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 140,
    "percentile_rank": 99.6,
    "sum_of_subtest_scores_phonological_index_fall_low": 33,
    "sum_of_subtest_scores_phonological_index_fall_high": 33,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 50,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 50
  },
  {
    "index_score": 139,
    "percentile_rank": 99.5,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 49,
    "sum_of_subtest_scores_phonological_index_spring_high": 49,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 138,
    "percentile_rank": 99,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 49,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 49
  },
  {
    "index_score": 137,
    "percentile_rank": 99,
    "sum_of_subtest_scores_phonological_index_fall_low": 32,
    "sum_of_subtest_scores_phonological_index_fall_high": 32,
    "sum_of_subtest_scores_phonological_index_spring_low": 48,
    "sum_of_subtest_scores_phonological_index_spring_high": 48,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 136,
    "percentile_rank": 99,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 135,
    "percentile_rank": 99,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 47,
    "sum_of_subtest_scores_phonological_index_spring_high": 47,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 48,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 48
  },
  {
    "index_score": 134,
    "percentile_rank": 99,
    "sum_of_subtest_scores_phonological_index_fall_low": 31,
    "sum_of_subtest_scores_phonological_index_fall_high": 31,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 133,
    "percentile_rank": 99,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 46,
    "sum_of_subtest_scores_phonological_index_spring_high": 46,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 47,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 47
  },
  {
    "index_score": 132,
    "percentile_rank": 98,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 131,
    "percentile_rank": 98,
    "sum_of_subtest_scores_phonological_index_fall_low": 30,
    "sum_of_subtest_scores_phonological_index_fall_high": 30,
    "sum_of_subtest_scores_phonological_index_spring_low": 45,
    "sum_of_subtest_scores_phonological_index_spring_high": 45,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 46,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 46
  },
  {
    "index_score": 130,
    "percentile_rank": 98,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 129,
    "percentile_rank": 97,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 44,
    "sum_of_subtest_scores_phonological_index_spring_high": 44,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 128,
    "percentile_rank": 97,
    "sum_of_subtest_scores_phonological_index_fall_low": 29,
    "sum_of_subtest_scores_phonological_index_fall_high": 29,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 45,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 45
  },
  {
    "index_score": 127,
    "percentile_rank": 96,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 43,
    "sum_of_subtest_scores_phonological_index_spring_high": 43,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 126,
    "percentile_rank": 96,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 44,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 44
  },
  {
    "index_score": 125,
    "percentile_rank": 95,
    "sum_of_subtest_scores_phonological_index_fall_low": 28,
    "sum_of_subtest_scores_phonological_index_fall_high": 28,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 124,
    "percentile_rank": 95,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 42,
    "sum_of_subtest_scores_phonological_index_spring_high": 42,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 43,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 43
  },
  {
    "index_score": 123,
    "percentile_rank": 94,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 122,
    "percentile_rank": 93,
    "sum_of_subtest_scores_phonological_index_fall_low": 27,
    "sum_of_subtest_scores_phonological_index_fall_high": 27,
    "sum_of_subtest_scores_phonological_index_spring_low": 41,
    "sum_of_subtest_scores_phonological_index_spring_high": 41,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 42,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 42
  },
  {
    "index_score": 121,
    "percentile_rank": 92,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 120,
    "percentile_rank": 91,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 40,
    "sum_of_subtest_scores_phonological_index_spring_high": 40,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 41,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 41
  },
  {
    "index_score": 119,
    "percentile_rank": 90,
    "sum_of_subtest_scores_phonological_index_fall_low": 26,
    "sum_of_subtest_scores_phonological_index_fall_high": 26,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 118,
    "percentile_rank": 88,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 39,
    "sum_of_subtest_scores_phonological_index_spring_high": 39,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 40,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 40
  },
  {
    "index_score": 117,
    "percentile_rank": 87,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 116,
    "percentile_rank": 86,
    "sum_of_subtest_scores_phonological_index_fall_low": 25,
    "sum_of_subtest_scores_phonological_index_fall_high": 25,
    "sum_of_subtest_scores_phonological_index_spring_low": 38,
    "sum_of_subtest_scores_phonological_index_spring_high": 38,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 39,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 39
  },
  {
    "index_score": 115,
    "percentile_rank": 84,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 114,
    "percentile_rank": 82,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 37,
    "sum_of_subtest_scores_phonological_index_spring_high": 37,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 38,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 38
  },
  {
    "index_score": 113,
    "percentile_rank": 81,
    "sum_of_subtest_scores_phonological_index_fall_low": 24,
    "sum_of_subtest_scores_phonological_index_fall_high": 24,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 112,
    "percentile_rank": 79,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 36,
    "sum_of_subtest_scores_phonological_index_spring_high": 36,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 37,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 37
  },
  {
    "index_score": 111,
    "percentile_rank": 77,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 110,
    "percentile_rank": 75,
    "sum_of_subtest_scores_phonological_index_fall_low": 23,
    "sum_of_subtest_scores_phonological_index_fall_high": 23,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 36,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 36
  },
  {
    "index_score": 109,
    "percentile_rank": 73,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 35,
    "sum_of_subtest_scores_phonological_index_spring_high": 35,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 108,
    "percentile_rank": 70,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 34,
    "sum_of_subtest_scores_phonological_index_spring_high": 34,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 35,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 35
  },
  {
    "index_score": 107,
    "percentile_rank": 68,
    "sum_of_subtest_scores_phonological_index_fall_low": 22,
    "sum_of_subtest_scores_phonological_index_fall_high": 22,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 106,
    "percentile_rank": 66,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 33,
    "sum_of_subtest_scores_phonological_index_spring_high": 33,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 34,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 34
  },
  {
    "index_score": 105,
    "percentile_rank": 63,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 104,
    "percentile_rank": 61,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 32,
    "sum_of_subtest_scores_phonological_index_spring_high": 32,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 33,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 33
  },
  {
    "index_score": 103,
    "percentile_rank": 58,
    "sum_of_subtest_scores_phonological_index_fall_low": 21,
    "sum_of_subtest_scores_phonological_index_fall_high": 21,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 102,
    "percentile_rank": 55,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 31,
    "sum_of_subtest_scores_phonological_index_spring_high": 31,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 32,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 32
  },
  {
    "index_score": 101,
    "percentile_rank": 53,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 100,
    "percentile_rank": 50,
    "sum_of_subtest_scores_phonological_index_fall_low": 20,
    "sum_of_subtest_scores_phonological_index_fall_high": 20,
    "sum_of_subtest_scores_phonological_index_spring_low": 30,
    "sum_of_subtest_scores_phonological_index_spring_high": 30,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 31,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 31
  },
  {
    "index_score": 99,
    "percentile_rank": 47,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 30,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 30
  },
  {
    "index_score": 98,
    "percentile_rank": 45,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 29,
    "sum_of_subtest_scores_phonological_index_spring_high": 29,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 97,
    "percentile_rank": 42,
    "sum_of_subtest_scores_phonological_index_fall_low": 19,
    "sum_of_subtest_scores_phonological_index_fall_high": 19,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 29,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 29
  },
  {
    "index_score": 96,
    "percentile_rank": 39,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 28,
    "sum_of_subtest_scores_phonological_index_spring_high": 28,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 95,
    "percentile_rank": 37,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 94,
    "percentile_rank": 34,
    "sum_of_subtest_scores_phonological_index_fall_low": 18,
    "sum_of_subtest_scores_phonological_index_fall_high": 18,
    "sum_of_subtest_scores_phonological_index_spring_low": 27,
    "sum_of_subtest_scores_phonological_index_spring_high": 27,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 28,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 28
  },
  {
    "index_score": 93,
    "percentile_rank": 32,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 92,
    "percentile_rank": 30,
    "sum_of_subtest_scores_phonological_index_fall_low": 17,
    "sum_of_subtest_scores_phonological_index_fall_high": 17,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 27,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 27
  },
  {
    "index_score": 91,
    "percentile_rank": 27,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 26,
    "sum_of_subtest_scores_phonological_index_spring_high": 26,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 90,
    "percentile_rank": 25,
    "sum_of_subtest_scores_phonological_index_fall_low": 16,
    "sum_of_subtest_scores_phonological_index_fall_high": 16,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 26,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 26
  },
  {
    "index_score": 89,
    "percentile_rank": 23,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 25,
    "sum_of_subtest_scores_phonological_index_spring_high": 25,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 88,
    "percentile_rank": 21,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 25,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 25
  },
  {
    "index_score": 87,
    "percentile_rank": 19,
    "sum_of_subtest_scores_phonological_index_fall_low": 15,
    "sum_of_subtest_scores_phonological_index_fall_high": 15,
    "sum_of_subtest_scores_phonological_index_spring_low": 24,
    "sum_of_subtest_scores_phonological_index_spring_high": 24,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 86,
    "percentile_rank": 18,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 24,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 24
  },
  {
    "index_score": 85,
    "percentile_rank": 16,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 23,
    "sum_of_subtest_scores_phonological_index_spring_high": 23,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 84,
    "percentile_rank": 14,
    "sum_of_subtest_scores_phonological_index_fall_low": 14,
    "sum_of_subtest_scores_phonological_index_fall_high": 14,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 23,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 23
  },
  {
    "index_score": 83,
    "percentile_rank": 13,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 22,
    "sum_of_subtest_scores_phonological_index_spring_high": 22,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 82,
    "percentile_rank": 12,
    "sum_of_subtest_scores_phonological_index_fall_low": 13,
    "sum_of_subtest_scores_phonological_index_fall_high": 13,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 22,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 22
  },
  {
    "index_score": 81,
    "percentile_rank": 10,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 80,
    "percentile_rank": 9,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 21,
    "sum_of_subtest_scores_phonological_index_spring_high": 21,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 21,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 21
  },
  {
    "index_score": 79,
    "percentile_rank": 8,
    "sum_of_subtest_scores_phonological_index_fall_low": 12,
    "sum_of_subtest_scores_phonological_index_fall_high": 12,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 78,
    "percentile_rank": 7,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 20,
    "sum_of_subtest_scores_phonological_index_spring_high": 20,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 20,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 20
  },
  {
    "index_score": 77,
    "percentile_rank": 6,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 76,
    "percentile_rank": 5,
    "sum_of_subtest_scores_phonological_index_fall_low": 11,
    "sum_of_subtest_scores_phonological_index_fall_high": 11,
    "sum_of_subtest_scores_phonological_index_spring_low": 19,
    "sum_of_subtest_scores_phonological_index_spring_high": 19,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 19,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 19
  },
  {
    "index_score": 75,
    "percentile_rank": 5,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 74,
    "percentile_rank": 4,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 18,
    "sum_of_subtest_scores_phonological_index_spring_high": 18,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 18,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 18
  },
  {
    "index_score": 73,
    "percentile_rank": 4,
    "sum_of_subtest_scores_phonological_index_fall_low": 10,
    "sum_of_subtest_scores_phonological_index_fall_high": 10,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 72,
    "percentile_rank": 3,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 17,
    "sum_of_subtest_scores_phonological_index_spring_high": 17,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 17,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 17
  },
  {
    "index_score": 71,
    "percentile_rank": 3,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 70,
    "percentile_rank": 2,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 16,
    "sum_of_subtest_scores_phonological_index_spring_high": 16,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 16,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 16
  },
  {
    "index_score": 69,
    "percentile_rank": 2,
    "sum_of_subtest_scores_phonological_index_fall_low": 9,
    "sum_of_subtest_scores_phonological_index_fall_high": 9,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 68,
    "percentile_rank": 2,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 15,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 15
  },
  {
    "index_score": 67,
    "percentile_rank": 1,
    "sum_of_subtest_scores_phonological_index_fall_low": 8,
    "sum_of_subtest_scores_phonological_index_fall_high": 8,
    "sum_of_subtest_scores_phonological_index_spring_low": 15,
    "sum_of_subtest_scores_phonological_index_spring_high": 15,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 66,
    "percentile_rank": 1,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 14,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 14
  },
  {
    "index_score": 65,
    "percentile_rank": 1,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 14,
    "sum_of_subtest_scores_phonological_index_spring_high": 14,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 64,
    "percentile_rank": 1,
    "sum_of_subtest_scores_phonological_index_fall_low": 7,
    "sum_of_subtest_scores_phonological_index_fall_high": 7,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 13,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 13
  },
  {
    "index_score": 63,
    "percentile_rank": 1,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 13,
    "sum_of_subtest_scores_phonological_index_spring_high": 13,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 62,
    "percentile_rank": 1,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 12,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 12
  },
  {
    "index_score": 61,
    "percentile_rank": 0.5,
    "sum_of_subtest_scores_phonological_index_fall_low": 6,
    "sum_of_subtest_scores_phonological_index_fall_high": 6,
    "sum_of_subtest_scores_phonological_index_spring_low": 12,
    "sum_of_subtest_scores_phonological_index_spring_high": 12,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 60,
    "percentile_rank": 0.4,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 11,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 11
  },
  {
    "index_score": 59,
    "percentile_rank": 0.3,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 11,
    "sum_of_subtest_scores_phonological_index_spring_high": 11,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 58,
    "percentile_rank": 0.3,
    "sum_of_subtest_scores_phonological_index_fall_low": 5,
    "sum_of_subtest_scores_phonological_index_fall_high": 5,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 10,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 10
  },
  {
    "index_score": 57,
    "percentile_rank": 0.2,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 10,
    "sum_of_subtest_scores_phonological_index_spring_high": 10,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 56,
    "percentile_rank": 0.2,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 9,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 9
  },
  {
    "index_score": 55,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_phonological_index_fall_low": 4,
    "sum_of_subtest_scores_phonological_index_fall_high": 4,
    "sum_of_subtest_scores_phonological_index_spring_low": 9,
    "sum_of_subtest_scores_phonological_index_spring_high": 9,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 54,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 8,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 8
  },
  {
    "index_score": 53,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 8,
    "sum_of_subtest_scores_phonological_index_spring_high": 8,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 52,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_phonological_index_fall_low": 3,
    "sum_of_subtest_scores_phonological_index_fall_high": 3,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 7,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 7
  },
  {
    "index_score": 51,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 7,
    "sum_of_subtest_scores_phonological_index_spring_high": 7,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 50,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_phonological_index_fall_low": 2,
    "sum_of_subtest_scores_phonological_index_fall_high": 2,
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 6,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 6
  },
  {
    "index_score": 49,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 6,
    "sum_of_subtest_scores_phonological_index_spring_high": 6,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 48,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 5,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 5
  },
  {
    "index_score": 47,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 5,
    "sum_of_subtest_scores_phonological_index_spring_high": 5,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 46,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 4,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 4
  },
  {
    "index_score": 45,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": 3,
    "sum_of_subtest_scores_phonological_index_spring_high": 4,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 3,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 3
  }
];

const fIndexScores1: any = [
  {
    "index_score": 160,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 95,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 95,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 95,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 95,
    "sum_of_subtest_scores_language_index_fall_low": 93,
    "sum_of_subtest_scores_language_index_fall_high": 95,
    "sum_of_subtest_scores_language_index_spring_low": 93,
    "sum_of_subtest_scores_language_index_spring_high": 95
  },
  {
    "index_score": 159,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 92,
    "sum_of_subtest_scores_language_index_fall_high": 92,
    "sum_of_subtest_scores_language_index_spring_low": 92,
    "sum_of_subtest_scores_language_index_spring_high": 92
  },
  {
    "index_score": 158,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 94,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 94,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 94,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 94,
    "sum_of_subtest_scores_language_index_fall_low": 91,
    "sum_of_subtest_scores_language_index_fall_high": 91,
    "sum_of_subtest_scores_language_index_spring_low": 91,
    "sum_of_subtest_scores_language_index_spring_high": 91
  },
  {
    "index_score": 157,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 93,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 93,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 93,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 93,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 156,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 92,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 92,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 92,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 92,
    "sum_of_subtest_scores_language_index_fall_low": 90,
    "sum_of_subtest_scores_language_index_fall_high": 90,
    "sum_of_subtest_scores_language_index_spring_low": 90,
    "sum_of_subtest_scores_language_index_spring_high": 90
  },
  {
    "index_score": 155,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 91,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 91,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 91,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 91,
    "sum_of_subtest_scores_language_index_fall_low": 89,
    "sum_of_subtest_scores_language_index_fall_high": 89,
    "sum_of_subtest_scores_language_index_spring_low": 89,
    "sum_of_subtest_scores_language_index_spring_high": 89
  },
  {
    "index_score": 154,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 88,
    "sum_of_subtest_scores_language_index_fall_high": 88,
    "sum_of_subtest_scores_language_index_spring_low": 88,
    "sum_of_subtest_scores_language_index_spring_high": 88
  },
  {
    "index_score": 153,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 90,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 90,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 90,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 90,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 152,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 89,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 89,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 89,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 89,
    "sum_of_subtest_scores_language_index_fall_low": 87,
    "sum_of_subtest_scores_language_index_fall_high": 87,
    "sum_of_subtest_scores_language_index_spring_low": 87,
    "sum_of_subtest_scores_language_index_spring_high": 87
  },
  {
    "index_score": 151,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 88,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 88,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 88,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 88,
    "sum_of_subtest_scores_language_index_fall_low": 86,
    "sum_of_subtest_scores_language_index_fall_high": 86,
    "sum_of_subtest_scores_language_index_spring_low": 86,
    "sum_of_subtest_scores_language_index_spring_high": 86
  },
  {
    "index_score": 150,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 85,
    "sum_of_subtest_scores_language_index_fall_high": 85,
    "sum_of_subtest_scores_language_index_spring_low": 85,
    "sum_of_subtest_scores_language_index_spring_high": 85
  },
  {
    "index_score": 149,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 87,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 87,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 87,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 87,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 148,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 86,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 86,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 86,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 86,
    "sum_of_subtest_scores_language_index_fall_low": 84,
    "sum_of_subtest_scores_language_index_fall_high": 84,
    "sum_of_subtest_scores_language_index_spring_low": 84,
    "sum_of_subtest_scores_language_index_spring_high": 84
  },
  {
    "index_score": 147,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 85,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 85,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 85,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 85,
    "sum_of_subtest_scores_language_index_fall_low": 83,
    "sum_of_subtest_scores_language_index_fall_high": 83,
    "sum_of_subtest_scores_language_index_spring_low": 83,
    "sum_of_subtest_scores_language_index_spring_high": 83
  },
  {
    "index_score": 146,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 82,
    "sum_of_subtest_scores_language_index_fall_high": 82,
    "sum_of_subtest_scores_language_index_spring_low": 82,
    "sum_of_subtest_scores_language_index_spring_high": 82
  },
  {
    "index_score": 145,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 84,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 84,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 84,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 84,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 144,
    "percentile_rank": 99.8,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 83,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 83,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 83,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 83,
    "sum_of_subtest_scores_language_index_fall_low": 81,
    "sum_of_subtest_scores_language_index_fall_high": 81,
    "sum_of_subtest_scores_language_index_spring_low": 81,
    "sum_of_subtest_scores_language_index_spring_high": 81
  },
  {
    "index_score": 143,
    "percentile_rank": 99.8,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 82,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 82,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 82,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 82,
    "sum_of_subtest_scores_language_index_fall_low": 80,
    "sum_of_subtest_scores_language_index_fall_high": 80,
    "sum_of_subtest_scores_language_index_spring_low": 80,
    "sum_of_subtest_scores_language_index_spring_high": 80
  },
  {
    "index_score": 142,
    "percentile_rank": 99.7,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 79,
    "sum_of_subtest_scores_language_index_fall_high": 79,
    "sum_of_subtest_scores_language_index_spring_low": 79,
    "sum_of_subtest_scores_language_index_spring_high": 79
  },
  {
    "index_score": 141,
    "percentile_rank": 99.7,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 81,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 81,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 81,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 81,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 140,
    "percentile_rank": 99.6,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 80,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 80,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 80,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 80,
    "sum_of_subtest_scores_language_index_fall_low": 78,
    "sum_of_subtest_scores_language_index_fall_high": 78,
    "sum_of_subtest_scores_language_index_spring_low": 78,
    "sum_of_subtest_scores_language_index_spring_high": 78
  },
  {
    "index_score": 139,
    "percentile_rank": 99.5,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 79,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 79,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 79,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 79,
    "sum_of_subtest_scores_language_index_fall_low": 77,
    "sum_of_subtest_scores_language_index_fall_high": 77,
    "sum_of_subtest_scores_language_index_spring_low": 77,
    "sum_of_subtest_scores_language_index_spring_high": 77
  },
  {
    "index_score": 138,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 76,
    "sum_of_subtest_scores_language_index_fall_high": 76,
    "sum_of_subtest_scores_language_index_spring_low": 76,
    "sum_of_subtest_scores_language_index_spring_high": 76
  },
  {
    "index_score": 137,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 78,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 78,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 78,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 78,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 136,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 77,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 77,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 77,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 77,
    "sum_of_subtest_scores_language_index_fall_low": 75,
    "sum_of_subtest_scores_language_index_fall_high": 75,
    "sum_of_subtest_scores_language_index_spring_low": 75,
    "sum_of_subtest_scores_language_index_spring_high": 75
  },
  {
    "index_score": 135,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 74,
    "sum_of_subtest_scores_language_index_fall_high": 74,
    "sum_of_subtest_scores_language_index_spring_low": 74,
    "sum_of_subtest_scores_language_index_spring_high": 74
  },
  {
    "index_score": 134,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 76,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 76,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 76,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 76,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 133,
    "percentile_rank": 99,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 75,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 75,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 75,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 75,
    "sum_of_subtest_scores_language_index_fall_low": 73,
    "sum_of_subtest_scores_language_index_fall_high": 73,
    "sum_of_subtest_scores_language_index_spring_low": 73,
    "sum_of_subtest_scores_language_index_spring_high": 73
  },
  {
    "index_score": 132,
    "percentile_rank": 98,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 74,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 74,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 74,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 74,
    "sum_of_subtest_scores_language_index_fall_low": 72,
    "sum_of_subtest_scores_language_index_fall_high": 72,
    "sum_of_subtest_scores_language_index_spring_low": 72,
    "sum_of_subtest_scores_language_index_spring_high": 72
  },
  {
    "index_score": 131,
    "percentile_rank": 98,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 130,
    "percentile_rank": 98,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 73,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 73,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 73,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 73,
    "sum_of_subtest_scores_language_index_fall_low": 71,
    "sum_of_subtest_scores_language_index_fall_high": 71,
    "sum_of_subtest_scores_language_index_spring_low": 71,
    "sum_of_subtest_scores_language_index_spring_high": 71
  },
  {
    "index_score": 129,
    "percentile_rank": 97,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 72,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 72,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 72,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 72,
    "sum_of_subtest_scores_language_index_fall_low": 70,
    "sum_of_subtest_scores_language_index_fall_high": 70,
    "sum_of_subtest_scores_language_index_spring_low": 70,
    "sum_of_subtest_scores_language_index_spring_high": 70
  },
  {
    "index_score": 128,
    "percentile_rank": 97,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 127,
    "percentile_rank": 96,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 71,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 71,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 71,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 71,
    "sum_of_subtest_scores_language_index_fall_low": 69,
    "sum_of_subtest_scores_language_index_fall_high": 69,
    "sum_of_subtest_scores_language_index_spring_low": 69,
    "sum_of_subtest_scores_language_index_spring_high": 69
  },
  {
    "index_score": 126,
    "percentile_rank": 96,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 70,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 70,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 70,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 70,
    "sum_of_subtest_scores_language_index_fall_low": 68,
    "sum_of_subtest_scores_language_index_fall_high": 68,
    "sum_of_subtest_scores_language_index_spring_low": 68,
    "sum_of_subtest_scores_language_index_spring_high": 68
  },
  {
    "index_score": 125,
    "percentile_rank": 95,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 67,
    "sum_of_subtest_scores_language_index_fall_high": 67,
    "sum_of_subtest_scores_language_index_spring_low": 67,
    "sum_of_subtest_scores_language_index_spring_high": 67
  },
  {
    "index_score": 124,
    "percentile_rank": 95,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 69,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 69,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 69,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 69,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 123,
    "percentile_rank": 94,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 68,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 68,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 68,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 68,
    "sum_of_subtest_scores_language_index_fall_low": 66,
    "sum_of_subtest_scores_language_index_fall_high": 66,
    "sum_of_subtest_scores_language_index_spring_low": 66,
    "sum_of_subtest_scores_language_index_spring_high": 66
  },
  {
    "index_score": 122,
    "percentile_rank": 93,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 67,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 67,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 67,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 67,
    "sum_of_subtest_scores_language_index_fall_low": 65,
    "sum_of_subtest_scores_language_index_fall_high": 65,
    "sum_of_subtest_scores_language_index_spring_low": 65,
    "sum_of_subtest_scores_language_index_spring_high": 65
  },
  {
    "index_score": 121,
    "percentile_rank": 92,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 120,
    "percentile_rank": 91,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 66,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 66,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 66,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 66,
    "sum_of_subtest_scores_language_index_fall_low": 64,
    "sum_of_subtest_scores_language_index_fall_high": 64,
    "sum_of_subtest_scores_language_index_spring_low": 64,
    "sum_of_subtest_scores_language_index_spring_high": 64
  },
  {
    "index_score": 119,
    "percentile_rank": 90,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 65,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 65,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 65,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 65,
    "sum_of_subtest_scores_language_index_fall_low": 63,
    "sum_of_subtest_scores_language_index_fall_high": 63,
    "sum_of_subtest_scores_language_index_spring_low": 63,
    "sum_of_subtest_scores_language_index_spring_high": 63
  },
  {
    "index_score": 118,
    "percentile_rank": 88,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 64,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 64,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 64,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 64,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 117,
    "percentile_rank": 87,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 62,
    "sum_of_subtest_scores_language_index_fall_high": 62,
    "sum_of_subtest_scores_language_index_spring_low": 62,
    "sum_of_subtest_scores_language_index_spring_high": 62
  },
  {
    "index_score": 116,
    "percentile_rank": 86,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 63,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 63,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 63,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 63,
    "sum_of_subtest_scores_language_index_fall_low": 61,
    "sum_of_subtest_scores_language_index_fall_high": 61,
    "sum_of_subtest_scores_language_index_spring_low": 61,
    "sum_of_subtest_scores_language_index_spring_high": 61
  },
  {
    "index_score": 115,
    "percentile_rank": 84,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 62,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 62,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 62,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 62,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 114,
    "percentile_rank": 82,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 60,
    "sum_of_subtest_scores_language_index_fall_high": 60,
    "sum_of_subtest_scores_language_index_spring_low": 60,
    "sum_of_subtest_scores_language_index_spring_high": 60
  },
  {
    "index_score": 113,
    "percentile_rank": 81,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 61,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 61,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 61,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 61,
    "sum_of_subtest_scores_language_index_fall_low": 59,
    "sum_of_subtest_scores_language_index_fall_high": 59,
    "sum_of_subtest_scores_language_index_spring_low": 59,
    "sum_of_subtest_scores_language_index_spring_high": 59
  },
  {
    "index_score": 112,
    "percentile_rank": 79,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 60,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 60,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 60,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 60,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 111,
    "percentile_rank": 77,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 58,
    "sum_of_subtest_scores_language_index_fall_high": 58,
    "sum_of_subtest_scores_language_index_spring_low": 58,
    "sum_of_subtest_scores_language_index_spring_high": 58
  },
  {
    "index_score": 110,
    "percentile_rank": 75,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 59,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 59,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 59,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 59,
    "sum_of_subtest_scores_language_index_fall_low": 57,
    "sum_of_subtest_scores_language_index_fall_high": 57,
    "sum_of_subtest_scores_language_index_spring_low": 57,
    "sum_of_subtest_scores_language_index_spring_high": 57
  },
  {
    "index_score": 109,
    "percentile_rank": 73,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 58,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 58,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 58,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 58,
    "sum_of_subtest_scores_language_index_fall_low": 56,
    "sum_of_subtest_scores_language_index_fall_high": 56,
    "sum_of_subtest_scores_language_index_spring_low": 56,
    "sum_of_subtest_scores_language_index_spring_high": 56
  },
  {
    "index_score": 108,
    "percentile_rank": 70,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 107,
    "percentile_rank": 68,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 57,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 57,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 57,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 57,
    "sum_of_subtest_scores_language_index_fall_low": 55,
    "sum_of_subtest_scores_language_index_fall_high": 55,
    "sum_of_subtest_scores_language_index_spring_low": 55,
    "sum_of_subtest_scores_language_index_spring_high": 55
  },
  {
    "index_score": 106,
    "percentile_rank": 66,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 56,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 56,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 56,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 56,
    "sum_of_subtest_scores_language_index_fall_low": 54,
    "sum_of_subtest_scores_language_index_fall_high": 54,
    "sum_of_subtest_scores_language_index_spring_low": 54,
    "sum_of_subtest_scores_language_index_spring_high": 54
  },
  {
    "index_score": 105,
    "percentile_rank": 63,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 55,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 55,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 55,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 55,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 104,
    "percentile_rank": 61,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 53,
    "sum_of_subtest_scores_language_index_fall_high": 53,
    "sum_of_subtest_scores_language_index_spring_low": 53,
    "sum_of_subtest_scores_language_index_spring_high": 53
  },
  {
    "index_score": 103,
    "percentile_rank": 58,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 54,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 54,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 54,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 54,
    "sum_of_subtest_scores_language_index_fall_low": 52,
    "sum_of_subtest_scores_language_index_fall_high": 52,
    "sum_of_subtest_scores_language_index_spring_low": 52,
    "sum_of_subtest_scores_language_index_spring_high": 52
  },
  {
    "index_score": 102,
    "percentile_rank": 55,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 53,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 53,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 53,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 53,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 101,
    "percentile_rank": 53,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 52,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 52,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 52,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 52,
    "sum_of_subtest_scores_language_index_fall_low": 51,
    "sum_of_subtest_scores_language_index_fall_high": 51,
    "sum_of_subtest_scores_language_index_spring_low": 51,
    "sum_of_subtest_scores_language_index_spring_high": 51
  },
  {
    "index_score": 100,
    "percentile_rank": 50,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 51,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 51,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 51,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 51,
    "sum_of_subtest_scores_language_index_fall_low": 50,
    "sum_of_subtest_scores_language_index_fall_high": 50,
    "sum_of_subtest_scores_language_index_spring_low": 50,
    "sum_of_subtest_scores_language_index_spring_high": 50
  },
  {
    "index_score": 99,
    "percentile_rank": 47,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 50,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 50,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 50,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 50,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 98,
    "percentile_rank": 45,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 49,
    "sum_of_subtest_scores_language_index_fall_high": 49,
    "sum_of_subtest_scores_language_index_spring_low": 49,
    "sum_of_subtest_scores_language_index_spring_high": 49
  },
  {
    "index_score": 97,
    "percentile_rank": 42,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 49,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 49,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 49,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 49,
    "sum_of_subtest_scores_language_index_fall_low": 48,
    "sum_of_subtest_scores_language_index_fall_high": 48,
    "sum_of_subtest_scores_language_index_spring_low": 48,
    "sum_of_subtest_scores_language_index_spring_high": 48
  },
  {
    "index_score": 96,
    "percentile_rank": 39,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 95,
    "percentile_rank": 37,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 48,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 48,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 48,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 48,
    "sum_of_subtest_scores_language_index_fall_low": 47,
    "sum_of_subtest_scores_language_index_fall_high": 47,
    "sum_of_subtest_scores_language_index_spring_low": 47,
    "sum_of_subtest_scores_language_index_spring_high": 47
  },
  {
    "index_score": 94,
    "percentile_rank": 34,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 46,
    "sum_of_subtest_scores_language_index_fall_high": 46,
    "sum_of_subtest_scores_language_index_spring_low": 46,
    "sum_of_subtest_scores_language_index_spring_high": 46
  },
  {
    "index_score": 93,
    "percentile_rank": 32,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 47,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 47,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 47,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 47,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 92,
    "percentile_rank": 30,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 46,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 46,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 46,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 46,
    "sum_of_subtest_scores_language_index_fall_low": 45,
    "sum_of_subtest_scores_language_index_fall_high": 45,
    "sum_of_subtest_scores_language_index_spring_low": 45,
    "sum_of_subtest_scores_language_index_spring_high": 45
  },
  {
    "index_score": 91,
    "percentile_rank": 27,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 44,
    "sum_of_subtest_scores_language_index_fall_high": 44,
    "sum_of_subtest_scores_language_index_spring_low": 44,
    "sum_of_subtest_scores_language_index_spring_high": 44
  },
  {
    "index_score": 90,
    "percentile_rank": 25,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 45,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 45,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 45,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 45,
    "sum_of_subtest_scores_language_index_fall_low": 43,
    "sum_of_subtest_scores_language_index_fall_high": 43,
    "sum_of_subtest_scores_language_index_spring_low": 43,
    "sum_of_subtest_scores_language_index_spring_high": 43
  },
  {
    "index_score": 89,
    "percentile_rank": 23,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 44,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 44,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 44,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 44,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 88,
    "percentile_rank": 21,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 43,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 43,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 43,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 43,
    "sum_of_subtest_scores_language_index_fall_low": 42,
    "sum_of_subtest_scores_language_index_fall_high": 42,
    "sum_of_subtest_scores_language_index_spring_low": 42,
    "sum_of_subtest_scores_language_index_spring_high": 42
  },
  {
    "index_score": 87,
    "percentile_rank": 19,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 42,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 42,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 42,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 42,
    "sum_of_subtest_scores_language_index_fall_low": 41,
    "sum_of_subtest_scores_language_index_fall_high": 41,
    "sum_of_subtest_scores_language_index_spring_low": 41,
    "sum_of_subtest_scores_language_index_spring_high": 41
  },
  {
    "index_score": 86,
    "percentile_rank": 18,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 41,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 41,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 41,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 41,
    "sum_of_subtest_scores_language_index_fall_low": 40,
    "sum_of_subtest_scores_language_index_fall_high": 40,
    "sum_of_subtest_scores_language_index_spring_low": 40,
    "sum_of_subtest_scores_language_index_spring_high": 40
  },
  {
    "index_score": 85,
    "percentile_rank": 16,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 40,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 40,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 40,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 40,
    "sum_of_subtest_scores_language_index_fall_low": 39,
    "sum_of_subtest_scores_language_index_fall_high": 39,
    "sum_of_subtest_scores_language_index_spring_low": 39,
    "sum_of_subtest_scores_language_index_spring_high": 39
  },
  {
    "index_score": 84,
    "percentile_rank": 14,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 39,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 39,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 39,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 39,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 83,
    "percentile_rank": 13,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 38,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 38,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 38,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 38,
    "sum_of_subtest_scores_language_index_fall_low": 38,
    "sum_of_subtest_scores_language_index_fall_high": 38,
    "sum_of_subtest_scores_language_index_spring_low": 38,
    "sum_of_subtest_scores_language_index_spring_high": 38
  },
  {
    "index_score": 82,
    "percentile_rank": 12,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 37,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 37,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 37,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 37,
    "sum_of_subtest_scores_language_index_fall_low": 37,
    "sum_of_subtest_scores_language_index_fall_high": 37,
    "sum_of_subtest_scores_language_index_spring_low": 37,
    "sum_of_subtest_scores_language_index_spring_high": 37
  },
  {
    "index_score": 81,
    "percentile_rank": 10,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 36,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 36,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 36,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 36,
    "sum_of_subtest_scores_language_index_fall_low": 36,
    "sum_of_subtest_scores_language_index_fall_high": 36,
    "sum_of_subtest_scores_language_index_spring_low": 36,
    "sum_of_subtest_scores_language_index_spring_high": 36
  },
  {
    "index_score": 80,
    "percentile_rank": 9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 35,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 35,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 35,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 35,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 79,
    "percentile_rank": 8,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 34,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 34,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 34,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 34,
    "sum_of_subtest_scores_language_index_fall_low": 35,
    "sum_of_subtest_scores_language_index_fall_high": 35,
    "sum_of_subtest_scores_language_index_spring_low": 35,
    "sum_of_subtest_scores_language_index_spring_high": 35
  },
  {
    "index_score": 78,
    "percentile_rank": 7,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 33,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 33,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 33,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 33,
    "sum_of_subtest_scores_language_index_fall_low": 34,
    "sum_of_subtest_scores_language_index_fall_high": 34,
    "sum_of_subtest_scores_language_index_spring_low": 34,
    "sum_of_subtest_scores_language_index_spring_high": 34
  },
  {
    "index_score": 77,
    "percentile_rank": 6,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 32,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 32,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 32,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 32,
    "sum_of_subtest_scores_language_index_fall_low": 33,
    "sum_of_subtest_scores_language_index_fall_high": 33,
    "sum_of_subtest_scores_language_index_spring_low": 33,
    "sum_of_subtest_scores_language_index_spring_high": 33
  },
  {
    "index_score": 76,
    "percentile_rank": 5,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 31,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 31,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 31,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 31,
    "sum_of_subtest_scores_language_index_fall_low": 32,
    "sum_of_subtest_scores_language_index_fall_high": 32,
    "sum_of_subtest_scores_language_index_spring_low": 32,
    "sum_of_subtest_scores_language_index_spring_high": 32
  },
  {
    "index_score": 75,
    "percentile_rank": 5,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 30,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 30,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 30,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 30,
    "sum_of_subtest_scores_language_index_fall_low": 31,
    "sum_of_subtest_scores_language_index_fall_high": 31,
    "sum_of_subtest_scores_language_index_spring_low": 31,
    "sum_of_subtest_scores_language_index_spring_high": 31
  },
  {
    "index_score": 74,
    "percentile_rank": 4,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 29,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 29,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 29,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 29,
    "sum_of_subtest_scores_language_index_fall_low": 30,
    "sum_of_subtest_scores_language_index_fall_high": 30,
    "sum_of_subtest_scores_language_index_spring_low": 30,
    "sum_of_subtest_scores_language_index_spring_high": 30
  },
  {
    "index_score": 73,
    "percentile_rank": 4,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 28,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 28,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 28,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 28,
    "sum_of_subtest_scores_language_index_fall_low": 29,
    "sum_of_subtest_scores_language_index_fall_high": 29,
    "sum_of_subtest_scores_language_index_spring_low": 29,
    "sum_of_subtest_scores_language_index_spring_high": 29
  },
  {
    "index_score": 72,
    "percentile_rank": 3,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 27,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 27,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 27,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 27,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 71,
    "percentile_rank": 3,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 26,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 26,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 26,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 26,
    "sum_of_subtest_scores_language_index_fall_low": 28,
    "sum_of_subtest_scores_language_index_fall_high": 28,
    "sum_of_subtest_scores_language_index_spring_low": 28,
    "sum_of_subtest_scores_language_index_spring_high": 28
  },
  {
    "index_score": 70,
    "percentile_rank": 2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 25,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 25,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 25,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 25,
    "sum_of_subtest_scores_language_index_fall_low": 27,
    "sum_of_subtest_scores_language_index_fall_high": 27,
    "sum_of_subtest_scores_language_index_spring_low": 27,
    "sum_of_subtest_scores_language_index_spring_high": 27
  },
  {
    "index_score": 69,
    "percentile_rank": 2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 26,
    "sum_of_subtest_scores_language_index_fall_high": 26,
    "sum_of_subtest_scores_language_index_spring_low": 26,
    "sum_of_subtest_scores_language_index_spring_high": 26
  },
  {
    "index_score": 68,
    "percentile_rank": 2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 24,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 24,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 24,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 24,
    "sum_of_subtest_scores_language_index_fall_low": 25,
    "sum_of_subtest_scores_language_index_fall_high": 25,
    "sum_of_subtest_scores_language_index_spring_low": 25,
    "sum_of_subtest_scores_language_index_spring_high": 25
  },
  {
    "index_score": 67,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 23,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 23,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 23,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 23,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 66,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 24,
    "sum_of_subtest_scores_language_index_fall_high": 24,
    "sum_of_subtest_scores_language_index_spring_low": 24,
    "sum_of_subtest_scores_language_index_spring_high": 24
  },
  {
    "index_score": 65,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 22,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 22,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 22,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 22,
    "sum_of_subtest_scores_language_index_fall_low": 23,
    "sum_of_subtest_scores_language_index_fall_high": 23,
    "sum_of_subtest_scores_language_index_spring_low": 23,
    "sum_of_subtest_scores_language_index_spring_high": 23
  },
  {
    "index_score": 64,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 21,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 21,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 21,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 21,
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 63,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": 22,
    "sum_of_subtest_scores_language_index_fall_high": 22,
    "sum_of_subtest_scores_language_index_spring_low": 22,
    "sum_of_subtest_scores_language_index_spring_high": 22
  },
  {
    "index_score": 62,
    "percentile_rank": 1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 20,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 20,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 20,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 20,
    "sum_of_subtest_scores_language_index_fall_low": 21,
    "sum_of_subtest_scores_language_index_fall_high": 21,
    "sum_of_subtest_scores_language_index_spring_low": 21,
    "sum_of_subtest_scores_language_index_spring_high": 21
  },
  {
    "index_score": 61,
    "percentile_rank": 0.5,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 19,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 19,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 19,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 19,
    "sum_of_subtest_scores_language_index_fall_low": 20,
    "sum_of_subtest_scores_language_index_fall_high": 20,
    "sum_of_subtest_scores_language_index_spring_low": 20,
    "sum_of_subtest_scores_language_index_spring_high": 20
  },
  {
    "index_score": 60,
    "percentile_rank": 0.4,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 59,
    "percentile_rank": 0.3,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 18,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 18,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 18,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 18,
    "sum_of_subtest_scores_language_index_fall_low": 19,
    "sum_of_subtest_scores_language_index_fall_high": 19,
    "sum_of_subtest_scores_language_index_spring_low": 19,
    "sum_of_subtest_scores_language_index_spring_high": 19
  },
  {
    "index_score": 58,
    "percentile_rank": 0.3,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 17,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 17,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 17,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 17,
    "sum_of_subtest_scores_language_index_fall_low": 18,
    "sum_of_subtest_scores_language_index_fall_high": 18,
    "sum_of_subtest_scores_language_index_spring_low": 18,
    "sum_of_subtest_scores_language_index_spring_high": 18
  },
  {
    "index_score": 57,
    "percentile_rank": 0.2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 56,
    "percentile_rank": 0.2,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 16,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 16,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 16,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 16,
    "sum_of_subtest_scores_language_index_fall_low": 17,
    "sum_of_subtest_scores_language_index_fall_high": 17,
    "sum_of_subtest_scores_language_index_spring_low": 17,
    "sum_of_subtest_scores_language_index_spring_high": 17
  },
  {
    "index_score": 55,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 15,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 15,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 15,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 15,
    "sum_of_subtest_scores_language_index_fall_low": 16,
    "sum_of_subtest_scores_language_index_fall_high": 16,
    "sum_of_subtest_scores_language_index_spring_low": 16,
    "sum_of_subtest_scores_language_index_spring_high": 16
  },
  {
    "index_score": 54,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 53,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 14,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 14,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 14,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 14,
    "sum_of_subtest_scores_language_index_fall_low": 15,
    "sum_of_subtest_scores_language_index_fall_high": 15,
    "sum_of_subtest_scores_language_index_spring_low": 15,
    "sum_of_subtest_scores_language_index_spring_high": 15
  },
  {
    "index_score": 52,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 13,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 13,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 13,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 13,
    "sum_of_subtest_scores_language_index_fall_low": 14,
    "sum_of_subtest_scores_language_index_fall_high": 14,
    "sum_of_subtest_scores_language_index_spring_low": 14,
    "sum_of_subtest_scores_language_index_spring_high": 14
  },
  {
    "index_score": 51,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 50,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 12,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 12,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 12,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 12,
    "sum_of_subtest_scores_language_index_fall_low": 13,
    "sum_of_subtest_scores_language_index_fall_high": 13,
    "sum_of_subtest_scores_language_index_spring_low": 13,
    "sum_of_subtest_scores_language_index_spring_high": 13
  },
  {
    "index_score": 49,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 11,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 11,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 11,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 11,
    "sum_of_subtest_scores_language_index_fall_low": 12,
    "sum_of_subtest_scores_language_index_fall_high": 12,
    "sum_of_subtest_scores_language_index_spring_low": 12,
    "sum_of_subtest_scores_language_index_spring_high": 12
  },
  {
    "index_score": 48,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 47,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 10,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 10,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 10,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 10,
    "sum_of_subtest_scores_language_index_fall_low": 11,
    "sum_of_subtest_scores_language_index_fall_high": 11,
    "sum_of_subtest_scores_language_index_spring_low": 11,
    "sum_of_subtest_scores_language_index_spring_high": 11
  },
  {
    "index_score": 46,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 9,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 9,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 9,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 9,
    "sum_of_subtest_scores_language_index_fall_low": 10,
    "sum_of_subtest_scores_language_index_fall_high": 10,
    "sum_of_subtest_scores_language_index_spring_low": 10,
    "sum_of_subtest_scores_language_index_spring_high": 10
  },
  {
    "index_score": 45,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 44,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 8,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 8,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 8,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 8,
    "sum_of_subtest_scores_language_index_fall_low": 9,
    "sum_of_subtest_scores_language_index_fall_high": 9,
    "sum_of_subtest_scores_language_index_spring_low": 9,
    "sum_of_subtest_scores_language_index_spring_high": 9
  },
  {
    "index_score": 43,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 7,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 7,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 7,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 7,
    "sum_of_subtest_scores_language_index_fall_low": 8,
    "sum_of_subtest_scores_language_index_fall_high": 8,
    "sum_of_subtest_scores_language_index_spring_low": 8,
    "sum_of_subtest_scores_language_index_spring_high": 8
  },
  {
    "index_score": 42,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": "–",
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": "–",
    "sum_of_subtest_scores_language_index_fall_low": "–",
    "sum_of_subtest_scores_language_index_fall_high": "–",
    "sum_of_subtest_scores_language_index_spring_low": "–",
    "sum_of_subtest_scores_language_index_spring_high": "–"
  },
  {
    "index_score": 41,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 6,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 6,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 6,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 6,
    "sum_of_subtest_scores_language_index_fall_low": 7,
    "sum_of_subtest_scores_language_index_fall_high": 7,
    "sum_of_subtest_scores_language_index_spring_low": 7,
    "sum_of_subtest_scores_language_index_spring_high": 7
  },
  {
    "index_score": 40,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_emergent_literacy_index_fall_low": 5,
    "sum_of_subtest_scores_emergent_literacy_index_fall_high": 5,
    "sum_of_subtest_scores_emergent_literacy_index_spring_low": 5,
    "sum_of_subtest_scores_emergent_literacy_index_spring_high": 5,
    "sum_of_subtest_scores_language_index_fall_low": 5,
    "sum_of_subtest_scores_language_index_fall_high": 6,
    "sum_of_subtest_scores_language_index_spring_low": 5,
    "sum_of_subtest_scores_language_index_spring_high": 6
  }
];

const fIndexScores2: any = [
  {
    "index_score": 155,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_phonological_index_fall_low": 57,
    "sum_of_subtest_scores_phonological_index_fall_high": 57,
    "sum_of_subtest_scores_phonological_index_spring_low": 57,
    "sum_of_subtest_scores_phonological_index_spring_high": 57,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 154,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_phonological_index_fall_low": 56,
    "sum_of_subtest_scores_phonological_index_fall_high": 56,
    "sum_of_subtest_scores_phonological_index_spring_low": 56,
    "sum_of_subtest_scores_phonological_index_spring_high": 56,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 153,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 152,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_phonological_index_fall_low": 55,
    "sum_of_subtest_scores_phonological_index_fall_high": 55,
    "sum_of_subtest_scores_phonological_index_spring_low": 55,
    "sum_of_subtest_scores_phonological_index_spring_high": 55,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 151,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 150,
    "percentile_rank": ">99.9",
    "sum_of_subtest_scores_phonological_index_fall_low": 54,
    "sum_of_subtest_scores_phonological_index_fall_high": 54,
    "sum_of_subtest_scores_phonological_index_spring_low": 54,
    "sum_of_subtest_scores_phonological_index_spring_high": 54,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 38,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 38,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 38,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 38
  },
  {
    "index_score": 149,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 148,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_phonological_index_fall_low": 53,
    "sum_of_subtest_scores_phonological_index_fall_high": 53,
    "sum_of_subtest_scores_phonological_index_spring_low": 53,
    "sum_of_subtest_scores_phonological_index_spring_high": 53,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 147,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 146,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_phonological_index_fall_low": 52,
    "sum_of_subtest_scores_phonological_index_fall_high": 52,
    "sum_of_subtest_scores_phonological_index_spring_low": 52,
    "sum_of_subtest_scores_phonological_index_spring_high": 52,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 37,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 37,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 37,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 37
  },
  {
    "index_score": 145,
    "percentile_rank": 99.9,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 144,
    "percentile_rank": 99.8,
    "sum_of_subtest_scores_phonological_index_fall_low": 51,
    "sum_of_subtest_scores_phonological_index_fall_high": 51,
    "sum_of_subtest_scores_phonological_index_spring_low": 51,
    "sum_of_subtest_scores_phonological_index_spring_high": 51,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 143,
    "percentile_rank": 99.8,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 142,
    "percentile_rank": 99.7,
    "sum_of_subtest_scores_phonological_index_fall_low": 50,
    "sum_of_subtest_scores_phonological_index_fall_high": 50,
    "sum_of_subtest_scores_phonological_index_spring_low": 50,
    "sum_of_subtest_scores_phonological_index_spring_high": 50,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 36,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 36,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 36,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 36
  },
  {
    "index_score": 141,
    "percentile_rank": 99.7,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 140,
    "percentile_rank": 99.6,
    "sum_of_subtest_scores_phonological_index_fall_low": 49,
    "sum_of_subtest_scores_phonological_index_fall_high": 49,
    "sum_of_subtest_scores_phonological_index_spring_low": 49,
    "sum_of_subtest_scores_phonological_index_spring_high": 49,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 139,
    "percentile_rank": 99.5,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 138,
    "percentile_rank": 99,
    "sum_of_subtest_scores_phonological_index_fall_low": 48,
    "sum_of_subtest_scores_phonological_index_fall_high": 48,
    "sum_of_subtest_scores_phonological_index_spring_low": 48,
    "sum_of_subtest_scores_phonological_index_spring_high": 48,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 35,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 35,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 35,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 35
  },
  {
    "index_score": 137,
    "percentile_rank": 99,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 136,
    "percentile_rank": 99,
    "sum_of_subtest_scores_phonological_index_fall_low": 47,
    "sum_of_subtest_scores_phonological_index_fall_high": 47,
    "sum_of_subtest_scores_phonological_index_spring_low": 47,
    "sum_of_subtest_scores_phonological_index_spring_high": 47,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 135,
    "percentile_rank": 99,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 34,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 34,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 34,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 34
  },
  {
    "index_score": 134,
    "percentile_rank": 99,
    "sum_of_subtest_scores_phonological_index_fall_low": 46,
    "sum_of_subtest_scores_phonological_index_fall_high": 46,
    "sum_of_subtest_scores_phonological_index_spring_low": 46,
    "sum_of_subtest_scores_phonological_index_spring_high": 46,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 133,
    "percentile_rank": 99,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 132,
    "percentile_rank": 98,
    "sum_of_subtest_scores_phonological_index_fall_low": 45,
    "sum_of_subtest_scores_phonological_index_fall_high": 45,
    "sum_of_subtest_scores_phonological_index_spring_low": 45,
    "sum_of_subtest_scores_phonological_index_spring_high": 45,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 33,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 33,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 33,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 33
  },
  {
    "index_score": 131,
    "percentile_rank": 98,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 130,
    "percentile_rank": 98,
    "sum_of_subtest_scores_phonological_index_fall_low": 44,
    "sum_of_subtest_scores_phonological_index_fall_high": 44,
    "sum_of_subtest_scores_phonological_index_spring_low": 44,
    "sum_of_subtest_scores_phonological_index_spring_high": 44,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 129,
    "percentile_rank": 97,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 32,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 32,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 32,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 32
  },
  {
    "index_score": 128,
    "percentile_rank": 97,
    "sum_of_subtest_scores_phonological_index_fall_low": 43,
    "sum_of_subtest_scores_phonological_index_fall_high": 43,
    "sum_of_subtest_scores_phonological_index_spring_low": 43,
    "sum_of_subtest_scores_phonological_index_spring_high": 43,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 127,
    "percentile_rank": 96,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 126,
    "percentile_rank": 96,
    "sum_of_subtest_scores_phonological_index_fall_low": 42,
    "sum_of_subtest_scores_phonological_index_fall_high": 42,
    "sum_of_subtest_scores_phonological_index_spring_low": 42,
    "sum_of_subtest_scores_phonological_index_spring_high": 42,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 31,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 31,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 31,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 31
  },
  {
    "index_score": 125,
    "percentile_rank": 95,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 124,
    "percentile_rank": 95,
    "sum_of_subtest_scores_phonological_index_fall_low": 41,
    "sum_of_subtest_scores_phonological_index_fall_high": 41,
    "sum_of_subtest_scores_phonological_index_spring_low": 41,
    "sum_of_subtest_scores_phonological_index_spring_high": 41,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 123,
    "percentile_rank": 94,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 30,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 30,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 30,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 30
  },
  {
    "index_score": 122,
    "percentile_rank": 93,
    "sum_of_subtest_scores_phonological_index_fall_low": 40,
    "sum_of_subtest_scores_phonological_index_fall_high": 40,
    "sum_of_subtest_scores_phonological_index_spring_low": 40,
    "sum_of_subtest_scores_phonological_index_spring_high": 40,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 121,
    "percentile_rank": 92,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 120,
    "percentile_rank": 91,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 29,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 29,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 29,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 29
  },
  {
    "index_score": 119,
    "percentile_rank": 90,
    "sum_of_subtest_scores_phonological_index_fall_low": 39,
    "sum_of_subtest_scores_phonological_index_fall_high": 39,
    "sum_of_subtest_scores_phonological_index_spring_low": 39,
    "sum_of_subtest_scores_phonological_index_spring_high": 39,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 118,
    "percentile_rank": 88,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 28,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 28,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 28,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 28
  },
  {
    "index_score": 117,
    "percentile_rank": 87,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 116,
    "percentile_rank": 86,
    "sum_of_subtest_scores_phonological_index_fall_low": 38,
    "sum_of_subtest_scores_phonological_index_fall_high": 38,
    "sum_of_subtest_scores_phonological_index_spring_low": 38,
    "sum_of_subtest_scores_phonological_index_spring_high": 38,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 115,
    "percentile_rank": 84,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 27,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 27,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 27,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 27
  },
  {
    "index_score": 114,
    "percentile_rank": 82,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 113,
    "percentile_rank": 81,
    "sum_of_subtest_scores_phonological_index_fall_low": 37,
    "sum_of_subtest_scores_phonological_index_fall_high": 37,
    "sum_of_subtest_scores_phonological_index_spring_low": 37,
    "sum_of_subtest_scores_phonological_index_spring_high": 37,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 26,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 26,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 26,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 26
  },
  {
    "index_score": 112,
    "percentile_rank": 79,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 111,
    "percentile_rank": 77,
    "sum_of_subtest_scores_phonological_index_fall_low": 36,
    "sum_of_subtest_scores_phonological_index_fall_high": 36,
    "sum_of_subtest_scores_phonological_index_spring_low": 36,
    "sum_of_subtest_scores_phonological_index_spring_high": 36,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 110,
    "percentile_rank": 75,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 25,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 25,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 25,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 25
  },
  {
    "index_score": 109,
    "percentile_rank": 73,
    "sum_of_subtest_scores_phonological_index_fall_low": 35,
    "sum_of_subtest_scores_phonological_index_fall_high": 35,
    "sum_of_subtest_scores_phonological_index_spring_low": 35,
    "sum_of_subtest_scores_phonological_index_spring_high": 35,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 108,
    "percentile_rank": 70,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 24,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 24,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 24,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 24
  },
  {
    "index_score": 107,
    "percentile_rank": 68,
    "sum_of_subtest_scores_phonological_index_fall_low": 34,
    "sum_of_subtest_scores_phonological_index_fall_high": 34,
    "sum_of_subtest_scores_phonological_index_spring_low": 34,
    "sum_of_subtest_scores_phonological_index_spring_high": 34,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 106,
    "percentile_rank": 66,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 23,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 23,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 23,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 23
  },
  {
    "index_score": 105,
    "percentile_rank": 63,
    "sum_of_subtest_scores_phonological_index_fall_low": 33,
    "sum_of_subtest_scores_phonological_index_fall_high": 33,
    "sum_of_subtest_scores_phonological_index_spring_low": 33,
    "sum_of_subtest_scores_phonological_index_spring_high": 33,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 104,
    "percentile_rank": 61,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 22,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 22,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 22,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 22
  },
  {
    "index_score": 103,
    "percentile_rank": 58,
    "sum_of_subtest_scores_phonological_index_fall_low": 32,
    "sum_of_subtest_scores_phonological_index_fall_high": 32,
    "sum_of_subtest_scores_phonological_index_spring_low": 32,
    "sum_of_subtest_scores_phonological_index_spring_high": 32,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 102,
    "percentile_rank": 55,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 21,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 21,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 21,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 21
  },
  {
    "index_score": 101,
    "percentile_rank": 53,
    "sum_of_subtest_scores_phonological_index_fall_low": 31,
    "sum_of_subtest_scores_phonological_index_fall_high": 31,
    "sum_of_subtest_scores_phonological_index_spring_low": 31,
    "sum_of_subtest_scores_phonological_index_spring_high": 31,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 100,
    "percentile_rank": 50,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 20,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 20,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 20,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 20
  },
  {
    "index_score": 99,
    "percentile_rank": 47,
    "sum_of_subtest_scores_phonological_index_fall_low": 30,
    "sum_of_subtest_scores_phonological_index_fall_high": 30,
    "sum_of_subtest_scores_phonological_index_spring_low": 30,
    "sum_of_subtest_scores_phonological_index_spring_high": 30,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 98,
    "percentile_rank": 45,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 97,
    "percentile_rank": 42,
    "sum_of_subtest_scores_phonological_index_fall_low": 29,
    "sum_of_subtest_scores_phonological_index_fall_high": 29,
    "sum_of_subtest_scores_phonological_index_spring_low": 29,
    "sum_of_subtest_scores_phonological_index_spring_high": 29,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 19,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 19,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 19,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 19
  },
  {
    "index_score": 96,
    "percentile_rank": 39,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 95,
    "percentile_rank": 37,
    "sum_of_subtest_scores_phonological_index_fall_low": 28,
    "sum_of_subtest_scores_phonological_index_fall_high": 28,
    "sum_of_subtest_scores_phonological_index_spring_low": 28,
    "sum_of_subtest_scores_phonological_index_spring_high": 28,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 94,
    "percentile_rank": 34,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 18,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 18,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 18,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 18
  },
  {
    "index_score": 93,
    "percentile_rank": 32,
    "sum_of_subtest_scores_phonological_index_fall_low": 27,
    "sum_of_subtest_scores_phonological_index_fall_high": 27,
    "sum_of_subtest_scores_phonological_index_spring_low": 27,
    "sum_of_subtest_scores_phonological_index_spring_high": 27,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 92,
    "percentile_rank": 30,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 91,
    "percentile_rank": 27,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 17,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 17,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 17,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 17
  },
  {
    "index_score": 90,
    "percentile_rank": 25,
    "sum_of_subtest_scores_phonological_index_fall_low": 26,
    "sum_of_subtest_scores_phonological_index_fall_high": 26,
    "sum_of_subtest_scores_phonological_index_spring_low": 26,
    "sum_of_subtest_scores_phonological_index_spring_high": 26,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 89,
    "percentile_rank": 23,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 88,
    "percentile_rank": 21,
    "sum_of_subtest_scores_phonological_index_fall_low": 25,
    "sum_of_subtest_scores_phonological_index_fall_high": 25,
    "sum_of_subtest_scores_phonological_index_spring_low": 25,
    "sum_of_subtest_scores_phonological_index_spring_high": 25,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 16,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 16,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 16,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 16
  },
  {
    "index_score": 87,
    "percentile_rank": 19,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 86,
    "percentile_rank": 18,
    "sum_of_subtest_scores_phonological_index_fall_low": 24,
    "sum_of_subtest_scores_phonological_index_fall_high": 24,
    "sum_of_subtest_scores_phonological_index_spring_low": 24,
    "sum_of_subtest_scores_phonological_index_spring_high": 24,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 85,
    "percentile_rank": 16,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 15,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 15,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 15,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 15
  },
  {
    "index_score": 84,
    "percentile_rank": 14,
    "sum_of_subtest_scores_phonological_index_fall_low": 23,
    "sum_of_subtest_scores_phonological_index_fall_high": 23,
    "sum_of_subtest_scores_phonological_index_spring_low": 23,
    "sum_of_subtest_scores_phonological_index_spring_high": 23,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 83,
    "percentile_rank": 13,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 82,
    "percentile_rank": 12,
    "sum_of_subtest_scores_phonological_index_fall_low": 22,
    "sum_of_subtest_scores_phonological_index_fall_high": 22,
    "sum_of_subtest_scores_phonological_index_spring_low": 22,
    "sum_of_subtest_scores_phonological_index_spring_high": 22,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 14,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 14,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 14,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 14
  },
  {
    "index_score": 81,
    "percentile_rank": 10,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 80,
    "percentile_rank": 9,
    "sum_of_subtest_scores_phonological_index_fall_low": 21,
    "sum_of_subtest_scores_phonological_index_fall_high": 21,
    "sum_of_subtest_scores_phonological_index_spring_low": 21,
    "sum_of_subtest_scores_phonological_index_spring_high": 21,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 79,
    "percentile_rank": 8,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 13,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 13,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 13,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 13
  },
  {
    "index_score": 78,
    "percentile_rank": 7,
    "sum_of_subtest_scores_phonological_index_fall_low": 20,
    "sum_of_subtest_scores_phonological_index_fall_high": 20,
    "sum_of_subtest_scores_phonological_index_spring_low": 20,
    "sum_of_subtest_scores_phonological_index_spring_high": 20,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 77,
    "percentile_rank": 6,
    "sum_of_subtest_scores_phonological_index_fall_low": 19,
    "sum_of_subtest_scores_phonological_index_fall_high": 19,
    "sum_of_subtest_scores_phonological_index_spring_low": 19,
    "sum_of_subtest_scores_phonological_index_spring_high": 19,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 76,
    "percentile_rank": 5,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 12,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 12,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 12,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 12
  },
  {
    "index_score": 75,
    "percentile_rank": 5,
    "sum_of_subtest_scores_phonological_index_fall_low": 18,
    "sum_of_subtest_scores_phonological_index_fall_high": 18,
    "sum_of_subtest_scores_phonological_index_spring_low": 18,
    "sum_of_subtest_scores_phonological_index_spring_high": 18,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 74,
    "percentile_rank": 4,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 73,
    "percentile_rank": 4,
    "sum_of_subtest_scores_phonological_index_fall_low": 17,
    "sum_of_subtest_scores_phonological_index_fall_high": 17,
    "sum_of_subtest_scores_phonological_index_spring_low": 17,
    "sum_of_subtest_scores_phonological_index_spring_high": 17,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 11,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 11,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 11,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 11
  },
  {
    "index_score": 72,
    "percentile_rank": 3,
    "sum_of_subtest_scores_phonological_index_fall_low": 16,
    "sum_of_subtest_scores_phonological_index_fall_high": 16,
    "sum_of_subtest_scores_phonological_index_spring_low": 16,
    "sum_of_subtest_scores_phonological_index_spring_high": 16,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 71,
    "percentile_rank": 3,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 70,
    "percentile_rank": 2,
    "sum_of_subtest_scores_phonological_index_fall_low": 15,
    "sum_of_subtest_scores_phonological_index_fall_high": 15,
    "sum_of_subtest_scores_phonological_index_spring_low": 15,
    "sum_of_subtest_scores_phonological_index_spring_high": 15,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 10,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 10,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 10,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 10
  },
  {
    "index_score": 69,
    "percentile_rank": 2,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 68,
    "percentile_rank": 2,
    "sum_of_subtest_scores_phonological_index_fall_low": 14,
    "sum_of_subtest_scores_phonological_index_fall_high": 14,
    "sum_of_subtest_scores_phonological_index_spring_low": 14,
    "sum_of_subtest_scores_phonological_index_spring_high": 14,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 9,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 9,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 9,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 9
  },
  {
    "index_score": 67,
    "percentile_rank": 1,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 66,
    "percentile_rank": 1,
    "sum_of_subtest_scores_phonological_index_fall_low": 13,
    "sum_of_subtest_scores_phonological_index_fall_high": 13,
    "sum_of_subtest_scores_phonological_index_spring_low": 13,
    "sum_of_subtest_scores_phonological_index_spring_high": 13,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 65,
    "percentile_rank": 1,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 8,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 8,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 8,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 8
  },
  {
    "index_score": 64,
    "percentile_rank": 1,
    "sum_of_subtest_scores_phonological_index_fall_low": 12,
    "sum_of_subtest_scores_phonological_index_fall_high": 12,
    "sum_of_subtest_scores_phonological_index_spring_low": 12,
    "sum_of_subtest_scores_phonological_index_spring_high": 12,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 63,
    "percentile_rank": 1,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 7,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 7,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 7,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 7
  },
  {
    "index_score": 62,
    "percentile_rank": 1,
    "sum_of_subtest_scores_phonological_index_fall_low": 11,
    "sum_of_subtest_scores_phonological_index_fall_high": 11,
    "sum_of_subtest_scores_phonological_index_spring_low": 11,
    "sum_of_subtest_scores_phonological_index_spring_high": 11,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 61,
    "percentile_rank": 0.5,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 60,
    "percentile_rank": 0.4,
    "sum_of_subtest_scores_phonological_index_fall_low": 10,
    "sum_of_subtest_scores_phonological_index_fall_high": 10,
    "sum_of_subtest_scores_phonological_index_spring_low": 10,
    "sum_of_subtest_scores_phonological_index_spring_high": 10,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 6,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 6,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 6,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 6
  },
  {
    "index_score": 59,
    "percentile_rank": 0.3,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 58,
    "percentile_rank": 0.3,
    "sum_of_subtest_scores_phonological_index_fall_low": 9,
    "sum_of_subtest_scores_phonological_index_fall_high": 9,
    "sum_of_subtest_scores_phonological_index_spring_low": 9,
    "sum_of_subtest_scores_phonological_index_spring_high": 9,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 5,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 5,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 5,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 5
  },
  {
    "index_score": 57,
    "percentile_rank": 0.2,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 56,
    "percentile_rank": 0.2,
    "sum_of_subtest_scores_phonological_index_fall_low": 8,
    "sum_of_subtest_scores_phonological_index_fall_high": 8,
    "sum_of_subtest_scores_phonological_index_spring_low": 8,
    "sum_of_subtest_scores_phonological_index_spring_high": 8,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 55,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 4,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 4,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 4,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 4
  },
  {
    "index_score": 54,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_phonological_index_fall_low": 7,
    "sum_of_subtest_scores_phonological_index_fall_high": 7,
    "sum_of_subtest_scores_phonological_index_spring_low": 7,
    "sum_of_subtest_scores_phonological_index_spring_high": 7,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 53,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 3,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 3,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 3,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 3
  },
  {
    "index_score": 52,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_phonological_index_fall_low": 6,
    "sum_of_subtest_scores_phonological_index_fall_high": 6,
    "sum_of_subtest_scores_phonological_index_spring_low": 6,
    "sum_of_subtest_scores_phonological_index_spring_high": 6,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 51,
    "percentile_rank": 0.1,
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 50,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_phonological_index_fall_low": 5,
    "sum_of_subtest_scores_phonological_index_fall_high": 5,
    "sum_of_subtest_scores_phonological_index_spring_low": 5,
    "sum_of_subtest_scores_phonological_index_spring_high": 5,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": 2,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": 2,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": 2,
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": 2
  },
  {
    "index_score": 49,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 48,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_phonological_index_fall_low": 4,
    "sum_of_subtest_scores_phonological_index_fall_high": 4,
    "sum_of_subtest_scores_phonological_index_spring_low": 4,
    "sum_of_subtest_scores_phonological_index_spring_high": 4,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 47,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 46,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_phonological_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_index_spring_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  },
  {
    "index_score": 45,
    "percentile_rank": "<0.1",
    "sum_of_subtest_scores_phonological_index_fall_low": 3,
    "sum_of_subtest_scores_phonological_index_fall_high": 3,
    "sum_of_subtest_scores_phonological_index_spring_low": 3,
    "sum_of_subtest_scores_phonological_index_spring_high": 3,
    "sum_of_subtest_scores_phonological_orthographic_index_fall_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_fall_high": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_low": "–",
    "sum_of_subtest_scores_phonological_orthographic_index_spring_high": "–"
  }
];

const percentileRanksForIndexScores: any = [
  {
    "index_score": 160,
    "percentile_rank": ">99.9"
  },
  {
    "index_score": 159,
    "percentile_rank": ">99.9"
  },
  {
    "index_score": 158,
    "percentile_rank": ">99.9"
  },
  {
    "index_score": 157,
    "percentile_rank": ">99.9"
  },
  {
    "index_score": 156,
    "percentile_rank": ">99.9"
  },
  {
    "index_score": 155,
    "percentile_rank": ">99.9"
  },
  {
    "index_score": 154,
    "percentile_rank": ">99.9"
  },
  {
    "index_score": 153,
    "percentile_rank": ">99.9"
  },
  {
    "index_score": 152,
    "percentile_rank": ">99.9"
  },
  {
    "index_score": 151,
    "percentile_rank": ">99.9"
  },
  {
    "index_score": 150,
    "percentile_rank": ">99.9"
  },
  {
    "index_score": 149,
    "percentile_rank": 99.9
  },
  {
    "index_score": 148,
    "percentile_rank": 99.9
  },
  {
    "index_score": 147,
    "percentile_rank": 99.9
  },
  {
    "index_score": 146,
    "percentile_rank": 99.9
  },
  {
    "index_score": 145,
    "percentile_rank": 99.9
  },
  {
    "index_score": 144,
    "percentile_rank": 99.8
  },
  {
    "index_score": 143,
    "percentile_rank": 99.8
  },
  {
    "index_score": 142,
    "percentile_rank": 99.7
  },
  {
    "index_score": 141,
    "percentile_rank": 99.7
  },
  {
    "index_score": 140,
    "percentile_rank": 99.6
  },
  {
    "index_score": 139,
    "percentile_rank": 99.5
  },
  {
    "index_score": 138,
    "percentile_rank": 99
  },
  {
    "index_score": 137,
    "percentile_rank": 99
  },
  {
    "index_score": 136,
    "percentile_rank": 99
  },
  {
    "index_score": 135,
    "percentile_rank": 99
  },
  {
    "index_score": 134,
    "percentile_rank": 99
  },
  {
    "index_score": 133,
    "percentile_rank": 99
  },
  {
    "index_score": 132,
    "percentile_rank": 98
  },
  {
    "index_score": 131,
    "percentile_rank": 98
  },
  {
    "index_score": 130,
    "percentile_rank": 98
  },
  {
    "index_score": 129,
    "percentile_rank": 97
  },
  {
    "index_score": 128,
    "percentile_rank": 97
  },
  {
    "index_score": 127,
    "percentile_rank": 96
  },
  {
    "index_score": 126,
    "percentile_rank": 96
  },
  {
    "index_score": 125,
    "percentile_rank": 95
  },
  {
    "index_score": 124,
    "percentile_rank": 95
  },
  {
    "index_score": 123,
    "percentile_rank": 94
  },
  {
    "index_score": 122,
    "percentile_rank": 93
  },
  {
    "index_score": 121,
    "percentile_rank": 92
  },
  {
    "index_score": 120,
    "percentile_rank": 91
  },
  {
    "index_score": 119,
    "percentile_rank": 90
  },
  {
    "index_score": 118,
    "percentile_rank": 88
  },
  {
    "index_score": 117,
    "percentile_rank": 87
  },
  {
    "index_score": 116,
    "percentile_rank": 86
  },
  {
    "index_score": 115,
    "percentile_rank": 84
  },
  {
    "index_score": 114,
    "percentile_rank": 82
  },
  {
    "index_score": 113,
    "percentile_rank": 81
  },
  {
    "index_score": 112,
    "percentile_rank": 79
  },
  {
    "index_score": 111,
    "percentile_rank": 77
  },
  {
    "index_score": 110,
    "percentile_rank": 75
  },
  {
    "index_score": 109,
    "percentile_rank": 73
  },
  {
    "index_score": 108,
    "percentile_rank": 70
  },
  {
    "index_score": 107,
    "percentile_rank": 68
  },
  {
    "index_score": 106,
    "percentile_rank": 66
  },
  {
    "index_score": 105,
    "percentile_rank": 63
  },
  {
    "index_score": 104,
    "percentile_rank": 61
  },
  {
    "index_score": 103,
    "percentile_rank": 58
  },
  {
    "index_score": 102,
    "percentile_rank": 55
  },
  {
    "index_score": 101,
    "percentile_rank": 53
  },
  {
    "index_score": 100,
    "percentile_rank": 50
  },
  {
    "index_score": 99,
    "percentile_rank": 47
  },
  {
    "index_score": 98,
    "percentile_rank": 45
  },
  {
    "index_score": 97,
    "percentile_rank": 42
  },
  {
    "index_score": 96,
    "percentile_rank": 39
  },
  {
    "index_score": 95,
    "percentile_rank": 37
  },
  {
    "index_score": 94,
    "percentile_rank": 34
  },
  {
    "index_score": 93,
    "percentile_rank": 32
  },
  {
    "index_score": 92,
    "percentile_rank": 30
  },
  {
    "index_score": 91,
    "percentile_rank": 27
  },
  {
    "index_score": 90,
    "percentile_rank": 25
  },
  {
    "index_score": 89,
    "percentile_rank": 23
  },
  {
    "index_score": 88,
    "percentile_rank": 21
  },
  {
    "index_score": 87,
    "percentile_rank": 19
  },
  {
    "index_score": 86,
    "percentile_rank": 18
  },
  {
    "index_score": 85,
    "percentile_rank": 16
  },
  {
    "index_score": 84,
    "percentile_rank": 14
  },
  {
    "index_score": 83,
    "percentile_rank": 13
  },
  {
    "index_score": 82,
    "percentile_rank": 12
  },
  {
    "index_score": 81,
    "percentile_rank": 10
  },
  {
    "index_score": 80,
    "percentile_rank": 9
  },
  {
    "index_score": 79,
    "percentile_rank": 8
  },
  {
    "index_score": 78,
    "percentile_rank": 7
  },
  {
    "index_score": 77,
    "percentile_rank": 6
  },
  {
    "index_score": 76,
    "percentile_rank": 5
  },
  {
    "index_score": 75,
    "percentile_rank": 5
  },
  {
    "index_score": 74,
    "percentile_rank": 4
  },
  {
    "index_score": 73,
    "percentile_rank": 4
  },
  {
    "index_score": 72,
    "percentile_rank": 3
  },
  {
    "index_score": 71,
    "percentile_rank": 3
  },
  {
    "index_score": 70,
    "percentile_rank": 2
  },
  {
    "index_score": 69,
    "percentile_rank": 2
  },
  {
    "index_score": 68,
    "percentile_rank": 2
  },
  {
    "index_score": 67,
    "percentile_rank": 1
  },
  {
    "index_score": 66,
    "percentile_rank": 1
  },
  {
    "index_score": 65,
    "percentile_rank": 1
  },
  {
    "index_score": 64,
    "percentile_rank": 1
  },
  {
    "index_score": 63,
    "percentile_rank": 1
  },
  {
    "index_score": 62,
    "percentile_rank": 1
  },
  {
    "index_score": 61,
    "percentile_rank": 0.5
  },
  {
    "index_score": 60,
    "percentile_rank": 0.4
  },
  {
    "index_score": 59,
    "percentile_rank": 0.3
  },
  {
    "index_score": 58,
    "percentile_rank": 0.3
  },
  {
    "index_score": 57,
    "percentile_rank": 0.2
  },
  {
    "index_score": 56,
    "percentile_rank": 0.2
  },
  {
    "index_score": 55,
    "percentile_rank": 0.1
  },
  {
    "index_score": 54,
    "percentile_rank": 0.1
  },
  {
    "index_score": 53,
    "percentile_rank": 0.1
  },
  {
    "index_score": 52,
    "percentile_rank": 0.1
  },
  {
    "index_score": 51,
    "percentile_rank": 0.1
  },
  {
    "index_score": 50,
    "percentile_rank": "<0.1"
  },
  {
    "index_score": 49,
    "percentile_rank": "<0.1"
  },
  {
    "index_score": 48,
    "percentile_rank": "<0.1"
  },
  {
    "index_score": 47,
    "percentile_rank": "<0.1"
  },
  {
    "index_score": 46,
    "percentile_rank": "<0.1"
  },
  {
    "index_score": 45,
    "percentile_rank": "<0.1"
  },
  {
    "index_score": 44,
    "percentile_rank": "<0.1"
  },
  {
    "index_score": 43,
    "percentile_rank": "<0.1"
  },
  {
    "index_score": 42,
    "percentile_rank": "<0.1"
  },
  {
    "index_score": 41,
    "percentile_rank": "<0.1"
  },
  {
    "index_score": 40,
    "percentile_rank": "<0.1"
  }
];

const criterionScores: any = [
  {
    "subtest": "Book Handling",
    "grade": "PK",
    "criterion_score": 2
  },
  {
    "subtest": "Book Handling",
    "grade": "K",
    "criterion_score": 4
  },
  {
    "subtest": "Book Handling",
    "grade": "1st",
    "criterion_score": 6
  },
  {
    "subtest": "Concept of Word",
    "grade": "PK",
    "criterion_score": 0
  },
  {
    "subtest": "Concept of Word",
    "grade": "K",
    "criterion_score": 0
  },
  {
    "subtest": "Concept of Word",
    "grade": "1st",
    "criterion_score": 5
  },
  {
    "subtest": "Matching Symbols",
    "grade": "PK",
    "criterion_score": 3
  },
  {
    "subtest": "Matching Symbols",
    "grade": "K",
    "criterion_score": 5
  },
  {
    "subtest": "Matching Symbols",
    "grade": "1st",
    "criterion_score": 7
  },
  {
    "subtest": "Word Retrieval",
    "grade": "PK",
    "criterion_score": 3
  },
  {
    "subtest": "Word Retrieval",
    "grade": "K",
    "criterion_score": 4
  },
  {
    "subtest": "Word Retrieval",
    "grade": "1st",
    "criterion_score": 6
  },
  {
    "subtest": "Rapid Automatic Naming",
    "grade": "PK",
    "criterion_score": 105
  },
  {
    "subtest": "Rapid Automatic Naming",
    "grade": "K",
    "criterion_score": 130
  },
  {
    "subtest": "Rapid Automatic Naming",
    "grade": "1st",
    "criterion_score": 104
  },
  {
    "subtest": "Invented Spelling",
    "grade": "PK",
    "criterion_score": 0
  },
  {
    "subtest": "Invented Spelling",
    "grade": "K",
    "criterion_score": 0
  },
  {
    "subtest": "Invented Spelling",
    "grade": "1st",
    "criterion_score": 32
  },
  {
    "subtest": "Letter Knowledge",
    "grade": "PK",
    "criterion_score": 0
  },
  {
    "subtest": "Letter Knowledge",
    "grade": "K",
    "criterion_score": 0
  },
  {
    "subtest": "Letter Knowledge",
    "grade": "1st",
    "criterion_score": 26
  }
];

function TestALL({}: TestALLProps) {
  const routeParams = useParams();
  const [test, setTest] = useState({} as any);
  const [schemas, setSchemas] = useState([] as any);
  const [schema, setSchema] = useState({} as any);
  const [categories, setCategories] = useState([] as any);
  const [answers, setAnswers] = useState({} as any);
  const [textAnswers, setTextAnswers] = useState({} as any);
  const [numericAnswers, setNumericAnswers] = useState({} as any);
  const [correctAnswers, setCorrectAnswers] = useState(0 as any);
  const [incorrectAnswers, setIncorrectAnswers] = useState(0 as any);
  const [blankAnswers, setBlankAnswers] = useState(0 as any);
  const [cardKey, setCardKey] = useState("" as any);
  const [domains, setDomains] = useState({} as any);
  const [selectedSubtest, setSelectedSubtest] = useState(null as any);
  const [mode, setMode] = useState("Prompt" as any);
  const [subtestEntryMode, setSubtestEntryMode] = useState(true as any);
  const [subtestScores, setSubtestScores] = useState([] as any);
  const [errors, setErrors] = useState([]);
  const [testAdministrationDate, setTestAdministrationDate] = useState(null as any);

  const today = new Date();
  const currentMonth = today.getMonth();

  const [studentName, setStudentName] = useState("" as any);
  const [studentGrade, setStudentGrade] = useState("" as any);
  const [season, setSeason] = useState("" as any);
  
  useEffect(() => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/schemas', {
      method: 'get',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setSchemas(data);

      for (let i = 0; i < data?.length; i++) {
        if (data[i].name == 'ALL') {
          setSchema(data[i]);
          
          let rawQuestions: any = data[i].questions;
          let groupedCategories: any = [];

          for (let j = 0; j < data[i].questions?.length; j++) {
            let categoryIndex: number = -1;
            for (let k = 0; k < groupedCategories.length; k++) {
              if (groupedCategories[k].name == data[i].questions[j].category) {
                categoryIndex = k;
                break;
              }
            }

            if (categoryIndex == -1) {
              categoryIndex = groupedCategories.length;
              groupedCategories.push({
                name: data[i].questions[j].category,
                subcategories: []
              });
            }

            let subcategoryIndex: number = -1;
            for (let k = 0; k < groupedCategories[categoryIndex].subcategories.length; k++) {
              if (groupedCategories[categoryIndex].subcategories[k].name == data[i].questions[j].subcategory) {
                subcategoryIndex = k;
                break;
              }
            }

            if (subcategoryIndex == -1) {
              subcategoryIndex = groupedCategories[categoryIndex].subcategories.length;
              groupedCategories[categoryIndex].subcategories.push({
                name: data[i].questions[j].subcategory,
                questions: []
              });
            }

            groupedCategories[categoryIndex].subcategories[subcategoryIndex].questions.push(data[i].questions[j]);
          }

          setCategories(groupedCategories);

          fetch(ventrisConfig.url + '/api/test/' + routeParams.testId, {
            method: 'get',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
            }
          }).then(function (response) {
            return response.json();
          }).then(async function (data) {
            let answersUpdated: any = {};
            let textAnswersUpdated: any = {};
            let numericAnswersUpdated: any = {};
            let correctAnswersUpdated = 0;
            let incorrectAnswersUpdated = 0;
            let blankAnswersUpdated = 0;
            let domainsUpdated: any = {};

            if (data.test.subtest_entry_mode) {
              for (let i = 0; i < data.test.subtest_scores?.length; i++) {
                domainsUpdated[data.test.subtest_scores[i].subtest_name] = {
                    domain: data.test.subtest_scores[i].subtest_name,
                    score: data.test.subtest_scores[i].score,
                    isCriterion: subtests[data.test.subtest_scores[i].subtest_name].isCriterion,
                    scaledScoreKey: subtests[data.test.subtest_scores[i].subtest_name].scaledScoreKey
                  }
              }
            } else {
              for (let i = 0; i < data.test?.answers?.length; i++) {
                answersUpdated[data.test.answers[i].test_schema_question_id] = data.test.answers[i].test_schema_question_answer_id;
                textAnswersUpdated[data.test.answers[i].test_schema_question_id] = data.test.answers[i].text_answer;
                numericAnswersUpdated[data.test.answers[i].test_schema_question_id] = data.test.answers[i].numeric_answer;
                if (!domainsUpdated[data.test.answers[i].question?.category]) {
                  let startingScore = 0;

                  for (let x = 0; x < categories?.length; x++) {
                    if (categories[x].name == data.test.answers[i].question?.category) {
                      for (let y = 0; y < categories[x].subcategories?.length; y++) {
                        startingScore += startingNumberForSection(data.test.answers[i].question?.category, y, categories[x].subcategories[y].questions);
                      }
                    }
                  }

                  domainsUpdated[data.test.answers[i].question?.category] = {
                    domain: data.test.answers[i].question?.category,
                    score: startingScore,
                    isCriterion: subtests[data.test.answers[i].question?.category].isCriterion,
                    scaledScoreKey: subtests[data.test.answers[i].question?.category].scaledScoreKey
                  }
                }

                if (data.test.answers[i].test_schema_question_answer_id == 0 && data.test.answers[i].question?.answers?.length == 0) {
                  let score = parseInt(data.test.answers[i].numeric_answer);
                  if (!isNaN(score)) {
                    domainsUpdated[data.test.answers[i].question?.category].score += score;
                  }
                }

                for (let j = 0; j < rawQuestions?.length; j++) {
                  if (data.test.answers[i].test_schema_question_id == rawQuestions[j].id) {
                    for (let k = 0; k < rawQuestions[j].answers?.length; k++) {
                      if (rawQuestions[j].answers[k].id == data.test.answers[i].test_schema_question_answer_id) {
                        if (rawQuestions[j].answers[k].correct == 1) {
                          correctAnswersUpdated++;
                        } else {
                          incorrectAnswersUpdated++;
                        }
                        domainsUpdated[data.test.answers[i].question?.category].score += rawQuestions[j].answers[k].score;
                      }
                    }
                  }
                }
              }

              blankAnswersUpdated = rawQuestions.length - correctAnswersUpdated - incorrectAnswersUpdated;
            }

            let scaledScoreData: any = [];
            let confidenceIntervalData: any = [];

            if (data.test.student.grade == 'PK' && data.test.season == 'Fall') {
              scaledScoreData = pkFall;
              confidenceIntervalData = pkFallConfidence;
            } else if (data.test.student.grade == 'PK' && data.test.season == 'Spring') {
              scaledScoreData = pkSpring;
              confidenceIntervalData = pkSpringConfidence;
            } else if (data.test.student.grade == 'K' && data.test.season == 'Fall') {
              scaledScoreData = kFall;
              confidenceIntervalData = kFallConfidence;
            } else if (data.test.student.grade == 'K' && data.test.season == 'Spring') {
              scaledScoreData = kSpring;
              confidenceIntervalData = kSpringConfidence;
            } else if (data.test.student.grade == '1st' && data.test.season == 'Fall') {
              scaledScoreData = fFall;
              confidenceIntervalData = fFallConfidence;
            } else if (data.test.student.grade == '1st' && data.test.season == 'Spring') {
              scaledScoreData = fSpring;
              confidenceIntervalData = fSpringConfidence;
            }

            if (scaledScoreData.length > 0 && confidenceIntervalData.length > 0) {
              for (const i in domainsUpdated) {
                if (domainsUpdated[i].isCriterion || (data.test.student.grade == '1st' && domainsUpdated[i].domain == 'Letter Knowledge')) {
                  domainsUpdated[i].criterion = "";

                  for (let j = 0; j < criterionScores.length; j++) {
                    if (criterionScores[j].subtest == domainsUpdated[i].domain && criterionScores[j].grade == data.test.student.grade) {
                      if (domainsUpdated[i].score >= criterionScores[j].criterion_score) {
                        domainsUpdated[i].criterion = (criterionScores[j].subtest == 'Rapid Automatic Naming' ? 'Does Not Meet' : 'Meets');
                      } else {
                        domainsUpdated[i].criterion = (criterionScores[j].subtest == 'Rapid Automatic Naming' ? 'Meets' : 'Does Not Meet');
                      }
                    }
                  }
                } else {
                  domainsUpdated[i].scaledScore = "";
                  domainsUpdated[i].scaledScorePointsPlusMinus = "";
                  domainsUpdated[i].confidenceIntervalLow = "";
                  domainsUpdated[i].confidenceIntervalHigh = "";
                  domainsUpdated[i].percentileRank = "";
                  domainsUpdated[i].percentileRankConfidenceIntervalLow = "";
                  domainsUpdated[i].percentileRankConfidenceIntervalHigh = "";

                  if (domainsUpdated[i].scaledScoreKey) {
                    for (let j = 0; j < scaledScoreData.length; j++) {
                      if (isNumeric(scaledScoreData[j][domainsUpdated[i].scaledScoreKey + '_low']) &&
                        isNumeric(scaledScoreData[j][domainsUpdated[i].scaledScoreKey + '_high']) &&
                        domainsUpdated[i].score >= scaledScoreData[j][domainsUpdated[i].scaledScoreKey + '_low'] &&
                        domainsUpdated[i].score <= scaledScoreData[j][domainsUpdated[i].scaledScoreKey + '_high']) {
                          domainsUpdated[i].scaledScore = scaledScoreData[j].scaled_score;
                          break;
                      }
                    }
                    if (confidenceIntervalData[1][domainsUpdated[i].scaledScoreKey]) {
                      domainsUpdated[i].scaledScorePointsPlusMinus = confidenceIntervalData[1][domainsUpdated[i].scaledScoreKey];
                      domainsUpdated[i].confidenceIntervalLow = Math.max(0, domainsUpdated[i].scaledScore - confidenceIntervalData[1][domainsUpdated[i].scaledScoreKey]);
                      domainsUpdated[i].confidenceIntervalHigh = (domainsUpdated[i].scaledScore + confidenceIntervalData[1][domainsUpdated[i].scaledScoreKey]);

                      if (domainsUpdated[i].confidenceIntervalLow < 1) {
                        domainsUpdated[i].confidenceIntervalLow = 1;
                      }

                      if (domainsUpdated[i].confidenceIntervalHigh > 19) {
                        domainsUpdated[i].confidenceIntervalHigh = 19;
                      }

                      for (let j = 0; j < percentileRanks.length; j++) {
                        if (percentileRanks[j].subtest_scaled_score == domainsUpdated[i].scaledScore) {
                          domainsUpdated[i].percentileRank = percentileRanks[j].percentile_rank;
                        }
                        if (percentileRanks[j].subtest_scaled_score == domainsUpdated[i].confidenceIntervalLow) {
                          domainsUpdated[i].percentileRankConfidenceIntervalLow = percentileRanks[j].percentile_rank;
                        }
                        if (percentileRanks[j].subtest_scaled_score == domainsUpdated[i].confidenceIntervalHigh) {
                          domainsUpdated[i].percentileRankConfidenceIntervalHigh = percentileRanks[j].percentile_rank;
                        }
                      }
                    }
                  }
                }
              }
            }

            setTest(data.test);
            setAnswers(answersUpdated);
            setTextAnswers(textAnswersUpdated);
            setNumericAnswers(numericAnswersUpdated);
            setCorrectAnswers(correctAnswersUpdated);
            setIncorrectAnswers(incorrectAnswersUpdated);
            setBlankAnswers(blankAnswersUpdated);
            setDomains(domainsUpdated);
            setStudentName(data.test.student.student_code);
            setStudentGrade(data.test.student.grade);
            setSubtestEntryMode(data.test.subtest_entry_mode ?? false);
            setSubtestScores(data.test.subtest_scores ?? []);
            setMode(data.test.prompt_mode ? "Prompt" : "Record Form");
            setSeason(data.test.season);
            setTestAdministrationDate(data.test.completed_timestamp);
          });

          break;
        }
      }
    });
  }, []);

  const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  const isNumeric = (value: any) => {
    return typeof value === 'number' && !isNaN(value);
  }

  const answerLetterForOrderNumber = (orderNum: number) => {
    if (orderNum == 1) {
      return "a";
    } else if (orderNum == 2) {
      return "b";
    } else if (orderNum == 3) {
      return "c";
    } else if (orderNum == 4) {
      return "d";
    } else if (orderNum == 5) {
      return "e";
    } else if (orderNum == 6) {
      return "f";
    } else if (orderNum == 7) {
      return "g";
    } else if (orderNum == 8) {
      return "h";
    } else if (orderNum == 9) {
      return "i";
    } else if (orderNum == 10) {
      return "j";
    }

    return "z";
  }

  const answerQuestion = (question: any, answer: any, isCurrentAnswer: boolean) => {
    console.log(isCurrentAnswer);
    let answersUpdated: any = answers;
    answersUpdated[question.id] = isCurrentAnswer ? null : answer.id;
    setAnswers(answersUpdated);
    setCardKey(uuidv4());

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId + '/answer', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        answers: JSON.stringify(answersUpdated),
        text_answers: JSON.stringify(textAnswers),
        numeric_answers: JSON.stringify(numericAnswers),
        subtest_scores: JSON.stringify(subtestScores)
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
    });
  }

  const updateTextAnswer = (question: any, answer: any) => {
    let answersUpdated: any = textAnswers;
    answersUpdated[question.id] = answer;
    setTextAnswers(answersUpdated);

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId + '/answer', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        answers: JSON.stringify(answers),
        text_answers: JSON.stringify(answersUpdated),
        numeric_answers: JSON.stringify(numericAnswers),
        subtest_scores: JSON.stringify(subtestScores)
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
    });
  }

  const updateNumericAnswer = (question: any, answer: any) => {
    let answersUpdated: any = numericAnswers;
    answersUpdated[question.id] = answer;
    setNumericAnswers(answersUpdated);

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId + '/answer', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        answers: JSON.stringify(answers),
        text_answers: JSON.stringify(textAnswers),
        numeric_answers: JSON.stringify(answersUpdated),
        subtest_scores: JSON.stringify(subtestScores)
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
    });
  }

  const scoreForSubtest = (subtest: any) => {
    for (let i = 0; i < subtestScores?.length; i++) {
      if (subtestScores[i].subtest_name == subtest) {
        return subtestScores[i].score;
      }
    }
    
    return null;
  }

  const updateSubtestScore = (subtest: any, score: any) => {
    let found = false;
    for (let i = 0; i < subtestScores?.length; i++) {
      if (subtestScores[i].subtest_name == subtest) {
        found = true;
        subtestScores[i].score = score;
      }
    }
    if (!found) {
      subtestScores.push({
        subtest_name: subtest,
        score: score
      });
    }
    setSubtestScores(subtestScores);

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId + '/answer', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        answers: JSON.stringify(answers),
        text_answers: JSON.stringify(textAnswers),
        numeric_answers: JSON.stringify(numericAnswers),
        subtest_scores: JSON.stringify(subtestScores)
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
    });
  }

  const completeTest = () => {
    let errors: any = [];
    
    if (!testAdministrationDate || season == '') {
      errors.push("Test Administration Date and Season are both required before computing scores!");
    }

    if (subtestEntryMode) {
      for (let i = 0; i < subtestScores?.length; i++) {
        if (subtestScores[i].score < 0) {
          errors.push("The minimum score for subtest " + subtestScores[i].subtest_name + " is 0.");
        } else if (subtests[subtestScores[i].subtest_name].maxScore && subtestScores[i].score > subtests[subtestScores[i].subtest_name].maxScore) {
          errors.push("The maximum score for subtest " + subtestScores[i].subtest_name + " is " + subtests[subtestScores[i].subtest_name].maxScore + ".");
        } else if (subtests[subtestScores[i].subtest_name].maxScores && subtestScores[i].score > subtests[subtestScores[i].subtest_name].maxScores[studentGrade]) {
          errors.push("The maximum score for subtest " + subtestScores[i].subtest_name + " is " + subtests[subtestScores[i].subtest_name].maxScores[studentGrade] + ".");
        }
      }
    }

    setErrors(errors);

    if (errors.length > 0) {
      return;
    }

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId, {
      method: 'put',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        name: test.name,
        code: test.code,
        status: "Complete",
        prompt_mode: (mode == "Prompt"),
        subtest_entry_mode: subtestEntryMode,
        completed_timestamp: testAdministrationDate,
        season: season
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
      document.location.href = "/tests";
    });
  }

  const saveSubtestEntryMode = (subtestEntryMode: boolean) => {
    setSubtestEntryMode(subtestEntryMode);

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId, {
      method: 'put',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        name: test.name,
        code: test.code,
        status: test.status,
        subtest_entry_mode: subtestEntryMode,
        prompt_mode: (mode == "Prompt"),
        completed_timestamp: testAdministrationDate,
        season: season
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
    });
  }

  const saveMode = (mode: string) => {
    setMode(mode);

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId, {
      method: 'put',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        name: test.name,
        code: test.code,
        status: test.status,
        subtest_entry_mode: subtestEntryMode,
        prompt_mode: (mode == "Prompt"),
        completed_timestamp: testAdministrationDate,
        season: season
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
    });
  }

  const saveCompletedTimestamp = (date: string) => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId, {
      method: 'put',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        name: test.name,
        code: test.code,
        status: test.status,
        subtest_entry_mode: subtestEntryMode,
        prompt_mode: (mode == "Prompt"),
        completed_timestamp: date,
        season: season
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
      setTestAdministrationDate(date);
    });
  }

  const saveSeason = (season: string) => {
    setSeason(season);

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId, {
      method: 'put',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        name: test.name,
        code: test.code,
        status: test.status,
        subtest_entry_mode: subtestEntryMode,
        prompt_mode: (mode == "Prompt"),
        completed_timestamp: testAdministrationDate,
        season: season
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
    });
  }

  const showSubtest = (subtest: string) => {
    if (subtest == "Caregiver Questionnaire") {
      return false;
    }

    if (subtests[subtest]) {
      if (season == "Fall") {
        return subtests[subtest].fallGrades.includes(studentGrade);
      } else {
        return subtests[subtest].springGrades.includes(studentGrade);
      }
    }

    return false;
  }

  const showSubtestForSubtestEntry = (subtest: string) => {
    if (subtest == "Caregiver Questionnaire") {
      return false;
    }

    if (subtests[subtest]) {
      if (!subtests[subtest].scaledScoreKey && !subtests[subtest].isCriterion) {
        return false;
      } else if (season == "Fall") {
        return subtests[subtest].fallGrades.includes(studentGrade);
      } else {
        return subtests[subtest].springGrades.includes(studentGrade);
      }
    }

    return false;
  }

  const showSection = (subtest: string, section: number) => {
    if (subtests[subtest]) {
      if (subtests[subtest].sectionVisibility) {
        return (subtests[subtest].sectionVisibility[section][studentGrade]);
      }
    }

    return true;
  }

  const startingNumberForSection = (subtest: string, section: number, questions: any, arrow: boolean = false) => {
    if (subtests[subtest] && questions) {
      if (subtests[subtest].startingPoints) {
        let initialStartingPoint = (subtests[subtest].startingPoints[section][studentGrade] ? subtests[subtest].startingPoints[section][studentGrade] - 1 : 0);
        for (let i = 0; i < questions?.length; i++) {
          for (let j = 0; j < questions[i].answers?.length; j++) {
            if (answers[questions[i].id] == questions[i].answers[j].id) {
              if (i < initialStartingPoint && !arrow) {
                initialStartingPoint = i; 
              }
            }
          }
        }
        if (subtests[subtest].basalRule && questions[initialStartingPoint] && !arrow) {
          for (let j = 0; j < questions[initialStartingPoint].answers?.length; j++) {
            if (answers[questions[initialStartingPoint].id] == questions[initialStartingPoint].answers[j].id && questions[initialStartingPoint].answers[j].score <= (subtests[subtest].discontinueRule.maxScore ?? 0)) {
              if (initialStartingPoint >= subtests[subtest].basalRule) {
                return initialStartingPoint - subtests[subtest].basalRule;
              }
            }
          }
        }
        return initialStartingPoint;
      }
    }

    return 0;
  }

  const discontinueNumberForSection = (subtest: string, section: number, sections: any) => {
    if (subtests[subtest] && sections) {
      if (subtests[subtest].discontinueRule) {
        let failureCount = 0;
        let startingSectionIndex = 0;
        if (subtests[subtest].discontinueRule.perTask) {
          startingSectionIndex = section;
        }
        for (let k = startingSectionIndex; k < sections?.length; k++) {
          let questions = sections[k].questions;
          for (let i = startingNumberForSection(subtest, section, questions); i < questions?.length; i++) {
            for (let j = 0; j < questions[i].answers?.length; j++) {
              if (answers[questions[i].id] == questions[i].answers[j].id && questions[i].answers[j].score <= subtests[subtest].discontinueRule.maxScore) {
                failureCount++;
              } else if (answers[questions[i].id] == questions[i].answers[j].id && questions[i].answers[j].score > subtests[subtest].discontinueRule.maxScore) {
                failureCount = 0;
              }
              if (failureCount >= subtests[subtest].discontinueRule.consecutiveScores) {
                if (k < section) {
                  return 0;
                } else if (k == section) {
                  return (i + 1);
                }
              }
            }
          }
        }
      } else if (subtest == "Emergent Writing") {
        if (section == 1 || section == 2) {
          const consecutiveScores = (section == 1) ? 4 : 6;
          let failureCount = 0;
          let questions = sections[section].questions;
          for (let i = 0; i < questions?.length; i++) {
            for (let j = 0; j < questions[i].answers?.length; j++) {
              if (answers[questions[i].id] == questions[i].answers[j].id) {
                if (j > 0) {
                  failureCount = 0;
                } else {
                  failureCount++;
                }
              }
              if (failureCount >= consecutiveScores) {
                return (i + 1);
              }
            }
          }
        }
      }
    }

    return 100000;
  }

  const questionCountFromPreviousSubcategories = (category: any, subcategoryIndex: number) => {
    let questionCount = 0;
    for (let i = 0; i < subcategoryIndex; i++) {
      if (showSection(category.name, subcategoryIndex)) {
        questionCount += category.subcategories[i].questions?.length;
      }
    }
    return questionCount;
  }

  const statusForSubtest = (subtest: string) => {
    let someAnswered = false;
    let allAnswered = true;

    for (let i = 0; i < categories?.length; i++) {
      if (categories[i].name == subtest) {
        for (let j = 0; j < categories[i].subcategories?.length; j++) {
          const startingNumber = startingNumberForSection(subtest, j, categories[i].subcategories[j].questions);
          const discontinueNumber = discontinueNumberForSection(subtest, j, categories[i].subcategories);
          for (let k = startingNumber; k < Math.min(categories[i].subcategories[j].questions?.length, discontinueNumber); k++) {
            if (answers[categories[i].subcategories[j].questions[k].id] || numericAnswers[categories[i].subcategories[j].questions[k].id]) {
              someAnswered = true;
            } else if (showSection(subtest, j)) {
              allAnswered = false;
            }
          }
        }
      }
    }

    if (someAnswered && allAnswered) {
      return "Complete"
    } else if (someAnswered && !allAnswered) {
      return "In Progress"
    }

    return "No Data";
  }

  const subtestScaledScoreForCompositeScoreReport = (subtest: string, columnGrade: string, columnSeason: string, forceNumeric: boolean = false) => {
    if (studentGrade == columnGrade && (season == columnSeason || columnGrade != 'K')) {
      if (domains[subtest]) {
        if (forceNumeric) {
          if (isNaN(parseInt(domains[subtest].scaledScore))) {
            return 0;
          }
          return parseInt(domains[subtest].scaledScore);
        }
        return domains[subtest].scaledScore;
      } else {
        return 0;
      }
    }

    return (forceNumeric ? 0 : "");
  }

  const sumOfSubtestScaledScoreForCompositeScoreReport = (group: string, columnGrade: string, columnSeason: string) => {
    if (studentGrade == columnGrade && (season == columnSeason || columnGrade != 'K')) {
      if (group == "Emergent Literacy") {
        if ((subtestScaledScoreForCompositeScoreReport('Letter Knowledge', columnGrade, columnSeason, true) == "" && studentGrade != '1st') ||
            subtestScaledScoreForCompositeScoreReport('Rhyme Knowledge', columnGrade, columnSeason, true) == "" ||
            (subtestScaledScoreForCompositeScoreReport('Elision', columnGrade, columnSeason, true) == "" && studentGrade != 'PK') ||
            (subtestScaledScoreForCompositeScoreReport('Phonics Knowledge', columnGrade, columnSeason, true) == "" && (studentGrade == '1st' || (studentGrade == 'K' && season == 'Spring'))) ||
            (subtestScaledScoreForCompositeScoreReport('Sound Categorization', columnGrade, columnSeason, true) == "" && (studentGrade == '1st' || (studentGrade == 'K' && season == 'Spring'))) ||
            (subtestScaledScoreForCompositeScoreReport('Sight Word Recognition', columnGrade, columnSeason, true) == "" && (studentGrade == '1st' || (studentGrade == 'K' && season == 'Spring')))) {
          return "";
        }

        return subtestScaledScoreForCompositeScoreReport('Letter Knowledge', columnGrade, columnSeason, true) +
                subtestScaledScoreForCompositeScoreReport('Rhyme Knowledge', columnGrade, columnSeason, true) +
                subtestScaledScoreForCompositeScoreReport('Elision', columnGrade, columnSeason, true) +
                subtestScaledScoreForCompositeScoreReport('Phonics Knowledge', columnGrade, columnSeason, true) +
                subtestScaledScoreForCompositeScoreReport('Sound Categorization', columnGrade, columnSeason, true) +
                subtestScaledScoreForCompositeScoreReport('Sight Word Recognition', columnGrade, columnSeason, true);
      } else if (group == "Language") {
        if (subtestScaledScoreForCompositeScoreReport('Basic Concepts', columnGrade, columnSeason, true) == "" ||
            subtestScaledScoreForCompositeScoreReport('Receptive Vocabulary', columnGrade, columnSeason, true) == "" ||
            subtestScaledScoreForCompositeScoreReport('Parallel Sentence Production', columnGrade, columnSeason, true) == "" ||
            (subtestScaledScoreForCompositeScoreReport('Word Relationships', columnGrade, columnSeason, true) == "" && studentGrade != 'PK') ||
            subtestScaledScoreForCompositeScoreReport('Listening Comprehension', columnGrade, columnSeason, true) == "") {
          return "";
        }

        return subtestScaledScoreForCompositeScoreReport('Basic Concepts', columnGrade, columnSeason, true) +
                subtestScaledScoreForCompositeScoreReport('Receptive Vocabulary', columnGrade, columnSeason, true) +
                subtestScaledScoreForCompositeScoreReport('Parallel Sentence Production', columnGrade, columnSeason, true) +
                subtestScaledScoreForCompositeScoreReport('Word Relationships', columnGrade, columnSeason, true) +
                subtestScaledScoreForCompositeScoreReport('Listening Comprehension', columnGrade, columnSeason, true);
      } else if (group == "Phonological") {
        if ((subtestScaledScoreForCompositeScoreReport('Rhyme Knowledge', columnGrade, columnSeason, true) == "" && studentGrade != 'PK') ||
            (subtestScaledScoreForCompositeScoreReport('Elision', columnGrade, columnSeason, true) == "" && studentGrade != 'PK') ||
            (subtestScaledScoreForCompositeScoreReport('Sound Categorization', columnGrade, columnSeason, true) == "" && (studentGrade == '1st' || (studentGrade == 'K' && season == 'Spring')))) {
          return "";
        }

        return subtestScaledScoreForCompositeScoreReport('Rhyme Knowledge', columnGrade, columnSeason, true) +
                subtestScaledScoreForCompositeScoreReport('Elision', columnGrade, columnSeason, true) +
                subtestScaledScoreForCompositeScoreReport('Sound Categorization', columnGrade, columnSeason, true);
      } else if (group == "Phonological - Orthographic") {
        if ((subtestScaledScoreForCompositeScoreReport('Letter Knowledge', columnGrade, columnSeason, true) == "" && studentGrade == 'K') ||
            (subtestScaledScoreForCompositeScoreReport('Phonics Knowledge', columnGrade, columnSeason, true) == "" && (studentGrade == '1st' || (studentGrade == 'K' && season == 'Spring'))) ||
            (subtestScaledScoreForCompositeScoreReport('Sight Word Recognition', columnGrade, columnSeason, true) == "" && (studentGrade == '1st' || (studentGrade == 'K' && season == 'Spring')))) {
          return "";
        }

        return subtestScaledScoreForCompositeScoreReport('Letter Knowledge', columnGrade, columnSeason, true) +
                subtestScaledScoreForCompositeScoreReport('Phonics Knowledge', columnGrade, columnSeason, true) +
                subtestScaledScoreForCompositeScoreReport('Sight Word Recognition', columnGrade, columnSeason, true);
      }
    }

    return "";
  }

  const indexScoreForCompositeScoreReport = (group: string, columnGrade: string, columnSeason: string) => {
    const sumOfSubtestScores = sumOfSubtestScaledScoreForCompositeScoreReport(group, columnGrade, columnSeason);
    if (sumOfSubtestScores != "") {
      if (columnGrade == "PK") {
        for (let i = 0; i < pkIndexScores.length; i++) {
          if (group == "Language") {
            if (season == "Fall") {
              if (typeof(pkIndexScores[i].sum_of_subtest_scores_language_index_fall_low) === 'number' &&
                  typeof(pkIndexScores[i].sum_of_subtest_scores_language_index_fall_high) === 'number' &&
                  sumOfSubtestScores >= pkIndexScores[i].sum_of_subtest_scores_language_index_fall_low &&
                  sumOfSubtestScores <= pkIndexScores[i].sum_of_subtest_scores_language_index_fall_high) {
                    return pkIndexScores[i].index_score;
                  }
            } else {
              if (typeof(pkIndexScores[i].sum_of_subtest_scores_language_index_spring_low) === 'number' &&
                  typeof(pkIndexScores[i].sum_of_subtest_scores_language_index_spring_high) === 'number' &&
                  sumOfSubtestScores >= pkIndexScores[i].sum_of_subtest_scores_language_index_spring_low &&
                  sumOfSubtestScores <= pkIndexScores[i].sum_of_subtest_scores_language_index_spring_high) {
                    return pkIndexScores[i].index_score;
                  }
            }
          } else {
            if (season == "Fall") {
              if (typeof(pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_fall_low) === 'number' &&
                  typeof(pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_fall_high) === 'number' &&
                  sumOfSubtestScores >= pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_fall_low &&
                  sumOfSubtestScores <= pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_fall_high) {
                    return pkIndexScores[i].index_score;
                  }
            } else {
              if (typeof(pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_spring_low) === 'number' &&
                  typeof(pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_spring_high) === 'number' &&
                  sumOfSubtestScores >= pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_spring_low &&
                  sumOfSubtestScores <= pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_spring_high) {
                    return pkIndexScores[i].index_score;
                  }
            }
          }
        }
      } else if (columnGrade == "K") {
        if (group == "Emergent Literacy" || group == "Language") {
          for (let i = 0; i < kIndexScores1.length; i++) {
            if (group == "Emergent Literacy") {
              if (columnSeason == "Fall") {
                if (typeof(kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_low) === 'number' &&
                    typeof(kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_low &&
                    sumOfSubtestScores <= kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_high) {
                      return kIndexScores1[i].index_score;
                    }
              } else {
                if (typeof(kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_low) === 'number' &&
                    typeof(kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_low &&
                    sumOfSubtestScores <= kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_high) {
                      return kIndexScores1[i].index_score;
                    }
              }
            } else {
              if (columnSeason == "Fall") {
                if (typeof(kIndexScores1[i].sum_of_subtest_scores_language_index_fall_low) === 'number' &&
                    typeof(kIndexScores1[i].sum_of_subtest_scores_language_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores1[i].sum_of_subtest_scores_language_index_fall_low &&
                    sumOfSubtestScores <= kIndexScores1[i].sum_of_subtest_scores_language_index_fall_high) {
                      return kIndexScores1[i].index_score;
                    }
              } else {
                if (typeof(kIndexScores1[i].sum_of_subtest_scores_language_index_spring_low) === 'number' &&
                    typeof(kIndexScores1[i].sum_of_subtest_scores_language_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores1[i].sum_of_subtest_scores_language_index_spring_low &&
                    sumOfSubtestScores <= kIndexScores1[i].sum_of_subtest_scores_language_index_spring_high) {
                      return kIndexScores1[i].index_score;
                    }
              }
            }
          }
        } else {
          for (let i = 0; i < kIndexScores2.length; i++) {
            if (group == "Phonological") {
              if (columnSeason == "Fall") {
                if (typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_low) === 'number' &&
                    typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_low &&
                    sumOfSubtestScores <= kIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_high) {
                      return kIndexScores2[i].index_score;
                    }
              } else {
                if (typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_low) === 'number' &&
                    typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_low &&
                    sumOfSubtestScores <= kIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_high) {
                      return kIndexScores2[i].index_score;
                    }
              }
            } else {
              if (columnSeason == "Fall") {
                if (typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_low) === 'number' &&
                    typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_low &&
                    sumOfSubtestScores <= kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_high) {
                      return kIndexScores2[i].index_score;
                    }
              } else {
                if (typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_low) === 'number' &&
                    typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_low &&
                    sumOfSubtestScores <= kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_high) {
                      return kIndexScores2[i].index_score;
                    }
              }
            }
          }
        }
      } else if (columnGrade == "1st") {
        if (group == "Emergent Literacy" || group == "Language") {
          for (let i = 0; i < fIndexScores1.length; i++) {
            if (group == "Emergent Literacy") {
              if (season == "Fall") {
                if (typeof(fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_low) === 'number' &&
                    typeof(fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_low &&
                    sumOfSubtestScores <= fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_high) {
                      return fIndexScores1[i].index_score;
                    }
              } else {
                if (typeof(fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_low) === 'number' &&
                    typeof(fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_low &&
                    sumOfSubtestScores <= fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_high) {
                      return fIndexScores1[i].index_score;
                    }
              }
            } else {
              if (season == "Fall") {
                if (typeof(fIndexScores1[i].sum_of_subtest_scores_language_index_fall_low) === 'number' &&
                    typeof(fIndexScores1[i].sum_of_subtest_scores_language_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores1[i].sum_of_subtest_scores_language_index_fall_low &&
                    sumOfSubtestScores <= fIndexScores1[i].sum_of_subtest_scores_language_index_fall_high) {
                      return fIndexScores1[i].index_score;
                    }
              } else {
                if (typeof(fIndexScores1[i].sum_of_subtest_scores_language_index_spring_low) === 'number' &&
                    typeof(fIndexScores1[i].sum_of_subtest_scores_language_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores1[i].sum_of_subtest_scores_language_index_spring_low &&
                    sumOfSubtestScores <= fIndexScores1[i].sum_of_subtest_scores_language_index_spring_high) {
                      return fIndexScores1[i].index_score;
                    }
              }
            }
          }
        } else {
          for (let i = 0; i < fIndexScores2.length; i++) {
            if (group == "Phonological") {
              if (season == "Fall") {
                if (typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_low) === 'number' &&
                    typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_low &&
                    sumOfSubtestScores <= fIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_high) {
                      return fIndexScores2[i].index_score;
                    }
              } else {
                if (typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_low) === 'number' &&
                    typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_low &&
                    sumOfSubtestScores <= fIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_high) {
                      return fIndexScores2[i].index_score;
                    }
              }
            } else {
              if (season == "Fall") {
                if (typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_low) === 'number' &&
                    typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_low &&
                    sumOfSubtestScores <= fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_high) {
                      return fIndexScores2[i].index_score;
                    }
              } else {
                if (typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_low) === 'number' &&
                    typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_low &&
                    sumOfSubtestScores <= fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_high) {
                      return fIndexScores2[i].index_score;
                    }
              }
            }
          }
        }
      }
    }
    return "";
  }

  const indexScoreSpreadForCompositeScoreReport = (group: string, columnGrade: string, columnSeason: string) => {
    if (sumOfSubtestScaledScoreForCompositeScoreReport(group, columnGrade, columnSeason) != "") {
      if (columnGrade == "PK") {
        if (group == "Language") {
          return 7;
        } else {
          return 6;
        }
      } else if (columnGrade == "K" && columnSeason == "Fall") {
        if (group == "Emergent Literacy") {
          return 7;
        } else if (group == "Language") {
          return 6;
        } else if (group == "Phonological") {
          return 7;
        }
      } else if (columnGrade == "K" && columnSeason == "Spring") {
        if (group == "Emergent Literacy") {
          return 5;
        } else if (group == "Language") {
          return 7;
        } else if (group == "Phonological") {
          return 8;
        } else if (group == "Phonological - Orthographic") {
          return 7;
        }
      } else if (columnGrade == "1st" && season == "Fall") {
        if (group == "Emergent Literacy") {
          return 5;
        } else if (group == "Language") {
          return 8;
        } else if (group == "Phonological") {
          return 8;
        } else if (group == "Phonological - Orthographic") {
          return 5;
        }
      } else if (columnGrade == "1st" && season == "Spring") {
        if (group == "Emergent Literacy") {
          return 6;
        } else if (group == "Language") {
          return 9;
        } else if (group == "Phonological") {
          return 8;
        } else if (group == "Phonological - Orthographic") {
          return 7;
        }
      }
    }

    return "";
  }

  const confidenceIntervalForCompositeScoreReport = (group: string, columnGrade: string, columnSeason: string) => {
    const indexScore = indexScoreForCompositeScoreReport(group, columnGrade, columnSeason);
    if (indexScore != "") {
      const spread = indexScoreSpreadForCompositeScoreReport(group, columnGrade, columnSeason);
      if (spread != "") {
        return (indexScore - spread) + " - " + (indexScore + spread);
      }
    }
    return "";
  }

  const percentileRankForCompositeScoreReport = (group: string, columnGrade: string, columnSeason: string) => {
    const sumOfSubtestScores = sumOfSubtestScaledScoreForCompositeScoreReport(group, columnGrade, columnSeason);
    if (sumOfSubtestScores != "") {
      if (columnGrade == "PK") {
        for (let i = 0; i < pkIndexScores.length; i++) {
          if (group == "Language") {
            if (season == "Fall") {
              if (typeof(pkIndexScores[i].sum_of_subtest_scores_language_index_fall_low) === 'number' &&
                  typeof(pkIndexScores[i].sum_of_subtest_scores_language_index_fall_high) === 'number' &&
                  sumOfSubtestScores >= pkIndexScores[i].sum_of_subtest_scores_language_index_fall_low &&
                  sumOfSubtestScores <= pkIndexScores[i].sum_of_subtest_scores_language_index_fall_high) {
                    return pkIndexScores[i].percentile_rank;
                  }
            } else {
              if (typeof(pkIndexScores[i].sum_of_subtest_scores_language_index_spring_low) === 'number' &&
                  typeof(pkIndexScores[i].sum_of_subtest_scores_language_index_spring_high) === 'number' &&
                  sumOfSubtestScores >= pkIndexScores[i].sum_of_subtest_scores_language_index_spring_low &&
                  sumOfSubtestScores <= pkIndexScores[i].sum_of_subtest_scores_language_index_spring_high) {
                    return pkIndexScores[i].percentile_rank;
                  }
            }
          } else {
            if (season == "Fall") {
              if (typeof(pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_fall_low) === 'number' &&
                  typeof(pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_fall_high) === 'number' &&
                  sumOfSubtestScores >= pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_fall_low &&
                  sumOfSubtestScores <= pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_fall_high) {
                    return pkIndexScores[i].percentile_rank;
                  }
            } else {
              if (typeof(pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_spring_low) === 'number' &&
                  typeof(pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_spring_high) === 'number' &&
                  sumOfSubtestScores >= pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_spring_low &&
                  sumOfSubtestScores <= pkIndexScores[i].sum_of_subtest_scores_emergent_literacy_index_spring_high) {
                    return pkIndexScores[i].percentile_rank;
                  }
            }
          }
        }
      } else if (columnGrade == "K") {
        if (group == "Emergent Literacy" || group == "Language") {
          for (let i = 0; i < kIndexScores1.length; i++) {
            if (group == "Emergent Literacy") {
              if (columnSeason == "Fall") {
                if (typeof(kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_low) === 'number' &&
                    typeof(kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_low &&
                    sumOfSubtestScores <= kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_high) {
                      return kIndexScores1[i].percentile_rank;
                    }
              } else {
                if (typeof(kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_low) === 'number' &&
                    typeof(kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_low &&
                    sumOfSubtestScores <= kIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_high) {
                      return kIndexScores1[i].percentile_rank;
                    }
              }
            } else {
              if (columnSeason == "Fall") {
                if (typeof(kIndexScores1[i].sum_of_subtest_scores_language_index_fall_low) === 'number' &&
                    typeof(kIndexScores1[i].sum_of_subtest_scores_language_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores1[i].sum_of_subtest_scores_language_index_fall_low &&
                    sumOfSubtestScores <= kIndexScores1[i].sum_of_subtest_scores_language_index_fall_high) {
                      return kIndexScores1[i].percentile_rank;
                    }
              } else {
                if (typeof(kIndexScores1[i].sum_of_subtest_scores_language_index_spring_low) === 'number' &&
                    typeof(kIndexScores1[i].sum_of_subtest_scores_language_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores1[i].sum_of_subtest_scores_language_index_spring_low &&
                    sumOfSubtestScores <= kIndexScores1[i].sum_of_subtest_scores_language_index_spring_high) {
                      return kIndexScores1[i].percentile_rank;
                    }
              }
            }
          }
        } else {
          for (let i = 0; i < kIndexScores2.length; i++) {
            if (group == "Phonological") {
              if (columnSeason == "Fall") {
                if (typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_low) === 'number' &&
                    typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_low &&
                    sumOfSubtestScores <= kIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_high) {
                      return kIndexScores2[i].percentile_rank;
                    }
              } else {
                if (typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_low) === 'number' &&
                    typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_low &&
                    sumOfSubtestScores <= kIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_high) {
                      return kIndexScores2[i].percentile_rank;
                    }
              }
            } else {
              if (columnSeason == "Fall") {
                if (typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_low) === 'number' &&
                    typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_low &&
                    sumOfSubtestScores <= kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_high) {
                      return kIndexScores2[i].percentile_rank;
                    }
              } else {
                if (typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_low) === 'number' &&
                    typeof(kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_low &&
                    sumOfSubtestScores <= kIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_high) {
                      return kIndexScores2[i].percentile_rank;
                    }
              }
            }
          }
        }
      }  else if (columnGrade == "1st") {
        if (group == "Emergent Literacy" || group == "Language") {
          for (let i = 0; i < fIndexScores1.length; i++) {
            if (group == "Emergent Literacy") {
              if (season == "Fall") {
                if (typeof(fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_low) === 'number' &&
                    typeof(fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_low &&
                    sumOfSubtestScores <= fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_fall_high) {
                      return fIndexScores1[i].percentile_rank;
                    }
              } else {
                if (typeof(fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_low) === 'number' &&
                    typeof(fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_low &&
                    sumOfSubtestScores <= fIndexScores1[i].sum_of_subtest_scores_emergent_literacy_index_spring_high) {
                      return fIndexScores1[i].percentile_rank;
                    }
              }
            } else {
              if (season == "Fall") {
                if (typeof(fIndexScores1[i].sum_of_subtest_scores_language_index_fall_low) === 'number' &&
                    typeof(fIndexScores1[i].sum_of_subtest_scores_language_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores1[i].sum_of_subtest_scores_language_index_fall_low &&
                    sumOfSubtestScores <= fIndexScores1[i].sum_of_subtest_scores_language_index_fall_high) {
                      return fIndexScores1[i].percentile_rank;
                    }
              } else {
                if (typeof(fIndexScores1[i].sum_of_subtest_scores_language_index_spring_low) === 'number' &&
                    typeof(fIndexScores1[i].sum_of_subtest_scores_language_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores1[i].sum_of_subtest_scores_language_index_spring_low &&
                    sumOfSubtestScores <= fIndexScores1[i].sum_of_subtest_scores_language_index_spring_high) {
                      return fIndexScores1[i].percentile_rank;
                    }
              }
            }
          }
        } else {
          for (let i = 0; i < fIndexScores2.length; i++) {
            if (group == "Phonological") {
              if (season == "Fall") {
                if (typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_low) === 'number' &&
                    typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_low &&
                    sumOfSubtestScores <= fIndexScores2[i].sum_of_subtest_scores_phonological_index_fall_high) {
                      return fIndexScores2[i].percentile_rank;
                    }
              } else {
                if (typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_low) === 'number' &&
                    typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_low &&
                    sumOfSubtestScores <= fIndexScores2[i].sum_of_subtest_scores_phonological_index_spring_high) {
                      return fIndexScores2[i].percentile_rank;
                    }
              }
            } else {
              if (season == "Fall") {
                if (typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_low) === 'number' &&
                    typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_low &&
                    sumOfSubtestScores <= fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_fall_high) {
                      return fIndexScores2[i].percentile_rank;
                    }
              } else {
                if (typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_low) === 'number' &&
                    typeof(fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_high) === 'number' &&
                    sumOfSubtestScores >= fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_low &&
                    sumOfSubtestScores <= fIndexScores2[i].sum_of_subtest_scores_phonological_orthographic_index_spring_high) {
                      return fIndexScores2[i].percentile_rank;
                    }
              }
            }
          }
        }
      }
    }
    return "";
  }

  const percentileRankConfidenceIntervalForCompositeScoreReport = (group: string, columnGrade: string, columnSeason: string) => {
    const indexScore = indexScoreForCompositeScoreReport(group, columnGrade, columnSeason);
    if (indexScore != "") {
      const spread = indexScoreSpreadForCompositeScoreReport(group, columnGrade, columnSeason);
      if (spread != "") {
        return percentileRankForindexScore(indexScore - spread) + " - " + percentileRankForindexScore(indexScore + spread);
      }
    }
    return "";
  }

  const percentileRankForindexScore = (indexScore: any) => {
    for (let i = 0; i < percentileRanksForIndexScores.length; i++) {
      if (percentileRanksForIndexScores[i].index_score == indexScore) {
        return percentileRanksForIndexScores[i].percentile_rank;
      }
    }

    return "";
  }

  return (
    <Container fluid className="ventris-content-wrapper">
      <Header portal={sessionStorage.getItem("portal")!} page="tests" />
      <Container as="main" id="main-content" tabIndex={-1}>
        <Row>
          <Col>
            <h1 className="page-header">ALL Test {test.status == "Complete" ? "Results" : "Data Entry"}</h1>
            {test.status !== "Complete" && !selectedSubtest ?
            <Card className="content-card" key={cardKey}>
              <div className="flex flex-row">
                <h5 className="flex-grow">Student: {studentName} (Grade: {studentGrade})</h5>
                <div className="table-actions">
                  {season == '' ? <span>Please choose a norming season for the scoring:<br /><br /></span> : null}
                  <Dropdown>
                    <Dropdown.Toggle id="all-season-menu">
                      Current Season: {season}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item as="button" type="button" onClick={() => saveSeason("Fall")}>Fall</Dropdown.Item>
                      <Dropdown.Item as="button" type="button" onClick={() => saveSeason("Spring")}>Spring</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
              <br />
              <div className="flex flex-row">
                {!subtestEntryMode ? <Button variant="link" className="btn-link flex flex-grow" onClick={() => setSelectedSubtest("Caregiver Questionnaire")}>Caregiver Questionnaire</Button> : null}
                <Dropdown style={{display: 'none'}}>
                  <Dropdown.Toggle id="all-score-entry-mode-menu">
                    Manually Enter Subtest Scores: {subtestEntryMode ? 'Yes' : 'No'}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item as="button" type="button" onClick={() => saveSubtestEntryMode(false)}>No</Dropdown.Item>
                    <Dropdown.Item as="button" type="button" onClick={() => saveSubtestEntryMode(true)}>Yes</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <br />
              <div className="flex flex-row">
                <div className="test-date-caption">Test Administration Date:</div>
                <Form.Control type="date" placeholder="Test Administration Date" className="test-answer-inline" defaultValue={test?.completed_timestamp?.split(' ')[0]} onChange={(event) => saveCompletedTimestamp(event.target.value)} />
              </div>
              <p className="timestamp-instructions">Enter (or choose) the date the test was administered, not the date you are entering data.</p>
              <br />
              {subtestEntryMode ?
              <Table bordered>
                <thead>
                  <tr>
                    <th>Subtest</th>
                    <th>Score</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.map((category: any) => 
                    <>
                      {showSubtestForSubtestEntry(category.name) ?
                      <tr>
                        <td>{category.name}</td>
                        <td><Form.Control type="number" placeholder="Enter Score Here" className="test-answer-numeric-inline" defaultValue={scoreForSubtest(category.name)} onChange={(event) => updateSubtestScore(category.name, event.target.value)} /></td>
                      </tr> : null }
                    </>
                  )}
                </tbody>
              </Table> : 
              <Table bordered>
                <thead>
                  <tr>
                    <th>Subtest</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.map((category: any) => 
                    <>
                      {showSubtest(category.name) ?
                      <tr>
                        <td><Button variant="link" className="btn-link" onClick={() => setSelectedSubtest(category.name)}>{category.name}</Button></td>
                        <td>{statusForSubtest(category.name)}</td>
                      </tr> : null }
                    </>
                  )}
                </tbody>
              </Table> }
              <br />
              { errors.length > 0 ?
              <div role="alert" className="ventris-form-error">
                The following validation errors must be resolved before you can complete this test:
                <br /><br />
                {errors.map((error: any) => 
                  <div>{error}</div>
                )}
              </div> : null }
              <br />
              <Button onClick={() => completeTest()}>Compute Scores</Button>
              <br /><br />
            </Card> : null }
            {test.status !== "Complete" && selectedSubtest ?
            <Card className="content-card" key={cardKey}>
              {categories.map((category: any) => 
                <>
                  {category.name === selectedSubtest ?
                  <>
                    <div className="flex flex-row">
                      <h3 className="test-category flex-grow">{category.name}</h3>
                      {selectedSubtest !== 'Caregiver Questionnaire' ?
                      <Dropdown>
                        <Dropdown.Toggle id="all-active-mode-menu">
                          Mode: {mode}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item as="button" type="button" onClick={() => saveMode('Prompt')}>Prompt</Dropdown.Item>
                          <Dropdown.Item as="button" type="button" onClick={() => saveMode('Record Form')}>Record Form</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown> : null}
                    </div>
                    {category.subcategories?.map((subcategory: any, subcategoryIndex: number) =>
                      <>
                        {showSection(category.name, subcategoryIndex) ?
                        <>
                          {subcategory.name != '' ? <h4 className="test-subcategory">{subcategory.name}</h4> : null }
                          {subcategory.questions?.map((question: any, questionIndex: number) => 
                            <>
                              {mode === 'Prompt' || selectedSubtest === 'Caregiver Questionnaire' ?
                              <div className={(discontinueNumberForSection(category.name, subcategoryIndex, category.subcategories) <= questionIndex) ? 'test-answer-disabled' : ''}>
                                <div className="test-question">{(startingNumberForSection(category.name, subcategoryIndex, subcategory.questions, true) == questionIndex && (category.name != 'Elision' || subcategoryIndex != 1)) ? <span className="start-indicator">START &#8680;</span> : null} {(questionIndex + questionCountFromPreviousSubcategories(category, subcategoryIndex) + 1)}. <span dangerouslySetInnerHTML={{__html: question.question}}></span></div>
                                <Form.Control as="textarea" rows={1} placeholder={selectedSubtest != 'Caregiver Questionnaire' ? 'Enter Examiner Notes Here' : 'Enter Answer Here'} className="test-answer-textarea" defaultValue={textAnswers[question.id]} onChange={(event) => updateTextAnswer(question, event.target.value)} />
                                {question.answers?.map((answer: any) => 
                                  <button className={answers[question.id] == answer.id ? "test-answer-selected": "test-answer"} onClick={() => answerQuestion(question, answer, answers[question.id] == answer.id)}>
                                    {(answer.answer == "A" || answer.answer == "B" || answer.answer == "C" || answer.answer == "NR") ?
                                    <>
                                      <div className={answer.correct ? 'test-answer-correct' : 'test-answer-incorrect'}><span dangerouslySetInnerHTML={{__html: answer.answer}}></span></div>
                                      <div className="test-answer-caption" dangerouslySetInnerHTML={{__html: answer.caption}}></div>
                                    </> :
                                    <>
                                      <div className={answer.correct ? 'test-answer-correct' : 'test-answer-incorrect'}>{answerLetterForOrderNumber(answer.order_num)}. <span dangerouslySetInnerHTML={{__html: answer.answer}}></span></div>
                                      <div className="test-answer-caption" dangerouslySetInnerHTML={{__html: answer.caption}}></div>
                                    </> }
                                  </button>
                                )}
                                {question.answers?.length == 0 && selectedSubtest != 'Caregiver Questionnaire' ? <Form.Control type="number" placeholder="Enter Answer Here" className="test-answer-numeric" defaultValue={numericAnswers[question.id]} onChange={(event) => updateNumericAnswer(question, event.target.value)} /> : null}
                              </div> :
                              <div className={(discontinueNumberForSection(category.name, subcategoryIndex, category.subcategories) <= questionIndex) ? 'test-answer-disabled' : ''}>
                                {(startingNumberForSection(category.name, subcategoryIndex, subcategory.questions, true) == questionIndex && (category.name != 'Elision' || subcategoryIndex != 1)) ? <span className="start-indicator">START &#8681;</span> : null}
                                <div className="record-form-answer-group">
                                  <div className="record-form-test-question">
                                    {(questionIndex + questionCountFromPreviousSubcategories(category, subcategoryIndex) + 1)}.
                                  </div>
                                  {question.answers?.map((answer: any) => 
                                    <button className={answers[question.id] == answer.id ? "test-answer-selected": "test-answer"} onClick={() => answerQuestion(question, answer, answers[question.id] == answer.id)}>
                                      {(answer.answer == "A" || answer.answer == "B" || answer.answer == "C" || answer.answer == "NR") ?
                                      <>
                                        <div className={answer.correct ? 'test-answer-correct' : 'test-answer-incorrect'}><span dangerouslySetInnerHTML={{__html: answer.answer}}></span></div>
                                      </> :
                                      <>
                                        <div className={answer.correct ? 'test-answer-correct' : 'test-answer-incorrect'}>{answerLetterForOrderNumber(answer.order_num)}. <span dangerouslySetInnerHTML={{__html: answer.answer}}></span></div>
                                      </> }
                                    </button>
                                  )}
                                  {question.answers?.length == 0 && selectedSubtest != 'Caregiver Questionnaire' ? <Form.Control type="number" placeholder="Enter Answer Here" className="test-answer-numeric-inline" defaultValue={numericAnswers[question.id]} onChange={(event) => updateNumericAnswer(question, event.target.value)} /> : null}
                                </div>
                              </div> }
                            </>
                          )}
                        </> : null }
                      </>
                    )}
                  </> : null }
                </>
              )}
              <br /><br />
              <Button onClick={() => setSelectedSubtest(null)}>Close Subtest</Button>
              <br /><br />
            </Card> : null }
            {test.status === "Complete" && !selectedSubtest ?
            <Card className="content-card" key={cardKey}>
              <div className="flex flex-row">
                <h5 className="flex-grow">Student: {studentName} (Grade: {studentGrade})</h5>
                <h5>Current Season: {season}</h5>
              </div>
              <br />
              This test has been completed! Completion Date: {test.completed_timestamp?.split(' ')[0]}
              <br /><br />
              {!subtestEntryMode ?
              <Table bordered>
                <thead>
                  <tr>
                    <th className="td-center">Correct Answers</th>
                    <th className="td-center">Incorrect Answers</th>
                    <th className="td-center">Blank Answers</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="td-center">{correctAnswers}</td>
                    <td className="td-center">{incorrectAnswers}</td>
                    <td className="td-center">{blankAnswers}</td>
                  </tr>
                </tbody>
              </Table> : null}
              {!subtestEntryMode ? <><br /><Button variant="link" className="btn-link" onClick={() => setSelectedSubtest("Caregiver Questionnaire")}>Caregiver Questionnaire</Button><br /></> : null}
              {subtestEntryMode ?
              <Table bordered>
                <thead>
                  <tr>
                    <th>Subtest</th>
                    <th>Raw Score</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.map((category: any) => 
                    <>
                      {scoreForSubtest(category.name) !== null ?
                      <tr>
                        <td>{category.name}</td>
                        <td>{scoreForSubtest(category.name)}</td>
                      </tr> : null}
                    </>
                  )}
                </tbody>
              </Table> :
              <Table bordered>
                <thead>
                  <tr>
                    <th>Subtest</th>
                    <th>Raw Score</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.map((category: any) => 
                    <tr>
                      <td><Button variant="link" className="btn-link" onClick={() => setSelectedSubtest(category.name)}>{category.name}</Button></td>
                      <td>{domains[category.name] ? domains[category.name].score : 0}</td>
                    </tr>
                  )}
                </tbody>
              </Table> }
              <br />
              <h5>Subtest Report</h5>
              <br />
              <Table bordered>
                <thead>
                  <tr>
                    <th>Subtest</th>
                    <th>Raw Score</th>
                    <th>Scaled Score</th>
                    <th>Scaled Score +/-</th>
                    <th>Confidence Interval 95% Level</th>
                    <th>Percentile Rank</th>
                    <th>Percentile Rank Confidence Interval</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.map((category: any) => 
                    <>
                      {domains[category.name] && domains[category.name].scaledScore != '' && !domains[category.name].isCriterion && (studentGrade != '1st' || category.name != 'Letter Knowledge') ?
                      <tr>
                        {subtestEntryMode ?
                        <td>{category.name}</td> :
                        <td><Button variant="link" className="btn-link" onClick={() => setSelectedSubtest(category.name)}>{category.name}</Button></td>}
                        <td>{domains[category.name] ? domains[category.name].score : 0}</td>
                        <td>{domains[category.name] ? domains[category.name].scaledScore : 0}</td>
                        <td>{domains[category.name] ? domains[category.name].scaledScorePointsPlusMinus : 0}</td>
                        <td>{domains[category.name] ? (domains[category.name].confidenceIntervalLow + " to " + domains[category.name].confidenceIntervalHigh) : 0}</td>
                        <td>{domains[category.name] ? domains[category.name].percentileRank : 0}</td>
                        <td>{domains[category.name] ? (domains[category.name].percentileRankConfidenceIntervalLow + " to " + domains[category.name].percentileRankConfidenceIntervalHigh) : 0}</td>
                      </tr> : null}
                    </>
                  )}
                </tbody>
              </Table>
              <br />
              <h5>Criterion-Referenced Score Chart</h5>
              <br />
              <Table bordered>
                <thead>
                  <tr>
                    <th>Subtest</th>
                    <th>Raw Score</th>
                    <th>Criterion</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.map((category: any) => 
                    <>
                      {domains[category.name] && (domains[category.name].isCriterion || (studentGrade == '1st' && category.name == 'Letter Knowledge')) ?
                      <tr>
                        {subtestEntryMode ?
                        <td>{category.name}</td> :
                        <td><Button variant="link" className="btn-link" onClick={() => setSelectedSubtest(category.name)}>{category.name}</Button></td>}
                        <td>{domains[category.name] ? domains[category.name].score : 0}</td>
                        <td>{domains[category.name] ? domains[category.name].criterion : ""}</td>
                      </tr> : null}
                    </>
                  )}
                </tbody>
              </Table>
              <br />
              <h5>Composite Score Report</h5>
              <br />
              <Table bordered>
                <thead>
                  <tr>
                    <th></th>
                    <th colSpan={4}>Emergent Literacy</th>
                    <th colSpan={4}>Language</th>
                    <th colSpan={4}>Phonological</th>
                    <th colSpan={4}>Phonological - Orthographic</th>
                  </tr>
                  <tr>
                    <th>Subtest Scaled Score</th>
                    <th>PK</th>
                    <th>K-Fall</th>
                    <th>K-Spr</th>
                    <th>1st</th>
                    <th>PK</th>
                    <th>K-Fall</th>
                    <th>K-Spr</th>
                    <th>1st</th>
                    <th>PK</th>
                    <th>K-Fall</th>
                    <th>K-Spr</th>
                    <th>1st</th>
                    <th>PK</th>
                    <th>K-Fall</th>
                    <th>K-Spr</th>
                    <th>1st</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Letter Knowledge</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Letter Knowledge', 'PK', '')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Letter Knowledge', 'K', 'Fall')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Letter Knowledge', 'K', 'Spring')}</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Letter Knowledge', 'K', 'Spring')}</td>
                    <td className="composite-score-report-disabled"></td>
                  </tr>
                  <tr>
                    <td>Rhyme Knowledge</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Rhyme Knowledge', 'PK', '')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Rhyme Knowledge', 'K', 'Fall')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Rhyme Knowledge', 'K', 'Spring')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Rhyme Knowledge', '1st', '')}</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Rhyme Knowledge', 'K', 'Fall')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Rhyme Knowledge', 'K', 'Spring')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Rhyme Knowledge', '1st', '')}</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                  </tr>
                  <tr>
                    <td>Basic Concepts</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Basic Concepts', 'PK', '')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Basic Concepts', 'K', 'Fall')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Basic Concepts', 'K', 'Spring')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Basic Concepts', '1st', '')}</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                  </tr>
                  <tr>
                    <td>Receptive Vocabulary</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Receptive Vocabulary', 'PK', '')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Receptive Vocabulary', 'K', 'Fall')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Receptive Vocabulary', 'K', 'Spring')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Receptive Vocabulary', '1st', '')}</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                  </tr>
                  <tr>
                    <td>Parallel Sentence Production</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Parallel Sentence Production', 'PK', '')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Parallel Sentence Production', 'K', 'Fall')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Parallel Sentence Production', 'K', 'Spring')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Parallel Sentence Production', '1st', '')}</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                  </tr>
                  <tr>
                    <td>Elision</td>
                    <td className="composite-score-report-disabled"></td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Elision', 'K', 'Fall')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Elision', 'K', 'Spring')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Elision', '1st', '')}</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Elision', 'K', 'Fall')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Elision', 'K', 'Spring')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Elision', '1st', '')}</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                  </tr>
                  <tr>
                    <td>Word Relationships</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Word Relationships', 'K', 'Fall')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Word Relationships', 'K', 'Spring')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Word Relationships', '1st', '')}</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                  </tr>
                  <tr>
                    <td>Phonics Knowledge</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Phonics Knowledge', 'K', 'Spring')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Phonics Knowledge', '1st', '')}</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Phonics Knowledge', 'K', 'Spring')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Phonics Knowledge', '1st', '')}</td>
                  </tr>
                  <tr>
                    <td>Sound Categorization</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Sound Categorization', 'K', 'Spring')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Sound Categorization', '1st', '')}</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Sound Categorization', 'K', 'Spring')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Sound Categorization', '1st', '')}</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                  </tr>
                  <tr>
                    <td>Sight Word Recognition</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Sight Word Recognition', 'K', 'Spring')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Sight Word Recognition', '1st', '')}</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Sight Word Recognition', 'K', 'Spring')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Sight Word Recognition', '1st', '')}</td>
                  </tr>
                  <tr>
                    <td>Listening Comprehension</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Listening Comprehension', 'PK', '')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Listening Comprehension', 'K', 'Fall')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Listening Comprehension', 'K', 'Spring')}</td>
                    <td>{subtestScaledScoreForCompositeScoreReport('Listening Comprehension', '1st', '')}</td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                    <td className="composite-score-report-disabled"></td>
                  </tr>
                  <tr>
                    <th>Index Score</th>
                    <th colSpan={4}></th>
                    <th colSpan={4}></th>
                    <th colSpan={4}></th>
                    <th colSpan={4}></th>
                  </tr>
                  <tr>
                    <td>Sum of Subtest Scaled Scores</td>
                    <td>{sumOfSubtestScaledScoreForCompositeScoreReport('Emergent Literacy', 'PK', '')}</td>
                    <td>{sumOfSubtestScaledScoreForCompositeScoreReport('Emergent Literacy', 'K', 'Fall')}</td>
                    <td>{sumOfSubtestScaledScoreForCompositeScoreReport('Emergent Literacy', 'K', 'Spring')}</td>
                    <td>{sumOfSubtestScaledScoreForCompositeScoreReport('Emergent Literacy', '1st', '')}</td>
                    <td>{sumOfSubtestScaledScoreForCompositeScoreReport('Language', 'PK', '')}</td>
                    <td>{sumOfSubtestScaledScoreForCompositeScoreReport('Language', 'K', 'Fall')}</td>
                    <td>{sumOfSubtestScaledScoreForCompositeScoreReport('Language', 'K', 'Spring')}</td>
                    <td>{sumOfSubtestScaledScoreForCompositeScoreReport('Language', '1st', '')}</td>
                    <td></td>
                    <td>{sumOfSubtestScaledScoreForCompositeScoreReport('Phonological', 'K', 'Fall')}</td>
                    <td>{sumOfSubtestScaledScoreForCompositeScoreReport('Phonological', 'K', 'Spring')}</td>
                    <td>{sumOfSubtestScaledScoreForCompositeScoreReport('Phonological', '1st', '')}</td>
                    <td></td>
                    <td></td>
                    <td>{sumOfSubtestScaledScoreForCompositeScoreReport('Phonological - Orthographic', 'K', 'Spring')}</td>
                    <td>{sumOfSubtestScaledScoreForCompositeScoreReport('Phonological - Orthographic', '1st', '')}</td>
                  </tr>
                  <tr>
                    <td>Index Score</td>
                    <td>{indexScoreForCompositeScoreReport('Emergent Literacy', 'PK', '')}</td>
                    <td>{indexScoreForCompositeScoreReport('Emergent Literacy', 'K', 'Fall')}</td>
                    <td>{indexScoreForCompositeScoreReport('Emergent Literacy', 'K', 'Spring')}</td>
                    <td>{indexScoreForCompositeScoreReport('Emergent Literacy', '1st', '')}</td>
                    <td>{indexScoreForCompositeScoreReport('Language', 'PK', '')}</td>
                    <td>{indexScoreForCompositeScoreReport('Language', 'K', 'Fall')}</td>
                    <td>{indexScoreForCompositeScoreReport('Language', 'K', 'Spring')}</td>
                    <td>{indexScoreForCompositeScoreReport('Language', '1st', '')}</td>
                    <td></td>
                    <td>{indexScoreForCompositeScoreReport('Phonological', 'K', 'Fall')}</td>
                    <td>{indexScoreForCompositeScoreReport('Phonological', 'K', 'Spring')}</td>
                    <td>{indexScoreForCompositeScoreReport('Phonological', '1st', '')}</td>
                    <td></td>
                    <td></td>
                    <td>{indexScoreForCompositeScoreReport('Phonological - Orthographic', 'K', 'Spring')}</td>
                    <td>{indexScoreForCompositeScoreReport('Phonological - Orthographic', '1st', '')}</td>
                  </tr>
                  <tr>
                    <td>Index Score Points +/-</td>
                    <td>{indexScoreSpreadForCompositeScoreReport('Emergent Literacy', 'PK', '')}</td>
                    <td>{indexScoreSpreadForCompositeScoreReport('Emergent Literacy', 'K', 'Fall')}</td>
                    <td>{indexScoreSpreadForCompositeScoreReport('Emergent Literacy', 'K', 'Spring')}</td>
                    <td>{indexScoreSpreadForCompositeScoreReport('Emergent Literacy', '1st', '')}</td>
                    <td>{indexScoreSpreadForCompositeScoreReport('Language', 'PK', '')}</td>
                    <td>{indexScoreSpreadForCompositeScoreReport('Language', 'K', 'Fall')}</td>
                    <td>{indexScoreSpreadForCompositeScoreReport('Language', 'K', 'Spring')}</td>
                    <td>{indexScoreSpreadForCompositeScoreReport('Language', '1st', '')}</td>
                    <td></td>
                    <td>{indexScoreSpreadForCompositeScoreReport('Phonological', 'K', 'Fall')}</td>
                    <td>{indexScoreSpreadForCompositeScoreReport('Phonological', 'K', 'Spring')}</td>
                    <td>{indexScoreSpreadForCompositeScoreReport('Phonological', '1st', '')}</td>
                    <td></td>
                    <td></td>
                    <td>{indexScoreSpreadForCompositeScoreReport('Phonological - Orthographic', 'K', 'Spring')}</td>
                    <td>{indexScoreSpreadForCompositeScoreReport('Phonological - Orthographic', '1st', '')}</td>
                  </tr>
                  <tr>
                    <td>Confidence Interval (95% Level)</td>
                    <td>{confidenceIntervalForCompositeScoreReport('Emergent Literacy', 'PK', '')}</td>
                    <td>{confidenceIntervalForCompositeScoreReport('Emergent Literacy', 'K', 'Fall')}</td>
                    <td>{confidenceIntervalForCompositeScoreReport('Emergent Literacy', 'K', 'Spring')}</td>
                    <td>{confidenceIntervalForCompositeScoreReport('Emergent Literacy', '1st', '')}</td>
                    <td>{confidenceIntervalForCompositeScoreReport('Language', 'PK', '')}</td>
                    <td>{confidenceIntervalForCompositeScoreReport('Language', 'K', 'Fall')}</td>
                    <td>{confidenceIntervalForCompositeScoreReport('Language', 'K', 'Spring')}</td>
                    <td>{confidenceIntervalForCompositeScoreReport('Language', '1st', '')}</td>
                    <td></td>
                    <td>{confidenceIntervalForCompositeScoreReport('Phonological', 'K', 'Fall')}</td>
                    <td>{confidenceIntervalForCompositeScoreReport('Phonological', 'K', 'Spring')}</td>
                    <td>{confidenceIntervalForCompositeScoreReport('Phonological', '1st', '')}</td>
                    <td></td>
                    <td></td>
                    <td>{confidenceIntervalForCompositeScoreReport('Phonological - Orthographic', 'K', 'Spring')}</td>
                    <td>{confidenceIntervalForCompositeScoreReport('Phonological - Orthographic', '1st', '')}</td>
                  </tr>
                  <tr>
                    <td>Percentile Rank</td>
                    <td>{percentileRankForCompositeScoreReport('Emergent Literacy', 'PK', '')}</td>
                    <td>{percentileRankForCompositeScoreReport('Emergent Literacy', 'K', 'Fall')}</td>
                    <td>{percentileRankForCompositeScoreReport('Emergent Literacy', 'K', 'Spring')}</td>
                    <td>{percentileRankForCompositeScoreReport('Emergent Literacy', '1st', '')}</td>
                    <td>{percentileRankForCompositeScoreReport('Language', 'PK', '')}</td>
                    <td>{percentileRankForCompositeScoreReport('Language', 'K', 'Fall')}</td>
                    <td>{percentileRankForCompositeScoreReport('Language', 'K', 'Spring')}</td>
                    <td>{percentileRankForCompositeScoreReport('Language', '1st', '')}</td>
                    <td></td>
                    <td>{percentileRankForCompositeScoreReport('Phonological', 'K', 'Fall')}</td>
                    <td>{percentileRankForCompositeScoreReport('Phonological', 'K', 'Spring')}</td>
                    <td>{percentileRankForCompositeScoreReport('Phonological', '1st', '')}</td>
                    <td></td>
                    <td></td>
                    <td>{percentileRankForCompositeScoreReport('Phonological - Orthographic', 'K', 'Spring')}</td>
                    <td>{percentileRankForCompositeScoreReport('Phonological - Orthographic', '1st', '')}</td>
                  </tr>
                  <tr>
                    <td>Percentile Rank Confidence Interval</td>
                    <td>{percentileRankConfidenceIntervalForCompositeScoreReport('Emergent Literacy', 'PK', '')}</td>
                    <td>{percentileRankConfidenceIntervalForCompositeScoreReport('Emergent Literacy', 'K', 'Fall')}</td>
                    <td>{percentileRankConfidenceIntervalForCompositeScoreReport('Emergent Literacy', 'K', 'Spring')}</td>
                    <td>{percentileRankConfidenceIntervalForCompositeScoreReport('Emergent Literacy', '1st', '')}</td>
                    <td>{percentileRankConfidenceIntervalForCompositeScoreReport('Language', 'PK', '')}</td>
                    <td>{percentileRankConfidenceIntervalForCompositeScoreReport('Language', 'K', 'Fall')}</td>
                    <td>{percentileRankConfidenceIntervalForCompositeScoreReport('Language', 'K', 'Spring')}</td>
                    <td>{percentileRankConfidenceIntervalForCompositeScoreReport('Language', '1st', '')}</td>
                    <td></td>
                    <td>{percentileRankConfidenceIntervalForCompositeScoreReport('Phonological', 'K', 'Fall')}</td>
                    <td>{percentileRankConfidenceIntervalForCompositeScoreReport('Phonological', 'K', 'Spring')}</td>
                    <td>{percentileRankConfidenceIntervalForCompositeScoreReport('Phonological', '1st', '')}</td>
                    <td></td>
                    <td></td>
                    <td>{percentileRankConfidenceIntervalForCompositeScoreReport('Phonological - Orthographic', 'K', 'Spring')}</td>
                    <td>{percentileRankConfidenceIntervalForCompositeScoreReport('Phonological - Orthographic', '1st', '')}</td>
                  </tr>
                </tbody>
              </Table>
            </Card> : null }
            {test.status === "Complete" && selectedSubtest ?
            <Card className="content-card" key={cardKey}>
              {categories.map((category: any) => 
                <>
                  {category.name === selectedSubtest ?
                  <>
                    <div className="flex flex-row">
                      <h3 className="test-category flex-grow">{category.name}</h3>
                      {selectedSubtest !== 'Caregiver Questionnaire' ?
                      <Dropdown>
                        <Dropdown.Toggle id="all-results-mode-menu">
                          Mode: {mode}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item as="button" type="button" onClick={() => saveMode('Prompt')}>Prompt</Dropdown.Item>
                          <Dropdown.Item as="button" type="button" onClick={() => saveMode('Record Form')}>Record Form</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown> : null}
                    </div>
                    {category.subcategories?.map((subcategory: any, subcategoryIndex: number) =>
                      <>
                        {showSection(category.name, subcategoryIndex) ?
                        <>
                          {subcategory.name != '' ? <h4 className="test-subcategory">{subcategory.name}</h4> : null }
                          {subcategory.questions?.map((question: any, questionIndex: number) => 
                            <>
                              {mode === 'Prompt' || selectedSubtest === 'Caregiver Questionnaire' ?
                              <div className={(discontinueNumberForSection(category.name, subcategoryIndex, category.subcategories) <= questionIndex) ? 'test-answer-disabled' : ''}>
                                <div className="test-question">{(startingNumberForSection(category.name, subcategoryIndex, subcategory.questions, true) == questionIndex && (category.name != 'Elision' || subcategoryIndex != 1)) ? <span className="start-indicator">START &#8680;</span> : null} {(questionIndex + questionCountFromPreviousSubcategories(category, subcategoryIndex) + 1)}. <span dangerouslySetInnerHTML={{__html: question.question}}></span></div>
                                <Form.Control as="textarea" rows={1} placeholder={selectedSubtest != 'Caregiver Questionnaire' ? 'Enter Examiner Notes Here' : 'Enter Answer Here'} className="test-answer-textarea" readOnly={true} defaultValue={textAnswers[question.id]} />
                                {question.answers?.map((answer: any) => 
                                  <button className={answers[question.id] == answer.id ? "test-answer-selected": "test-answer"}>
                                    {(answer.answer == "A" || answer.answer == "B" || answer.answer == "C" || answer.answer == "NR") ?
                                    <>
                                      <div className={answer.correct ? 'test-answer-correct' : 'test-answer-incorrect'}><span dangerouslySetInnerHTML={{__html: answer.answer}}></span></div>
                                      <div className="test-answer-caption" dangerouslySetInnerHTML={{__html: answer.caption}}></div>
                                    </> :
                                    <>
                                      <div className={answer.correct ? 'test-answer-correct' : 'test-answer-incorrect'}>{answerLetterForOrderNumber(answer.order_num)}. <span dangerouslySetInnerHTML={{__html: answer.answer}}></span></div>
                                      <div className="test-answer-caption" dangerouslySetInnerHTML={{__html: answer.caption}}></div>
                                    </> }
                                  </button>
                                )}
                                {question.answers?.length == 0 && selectedSubtest != 'Caregiver Questionnaire' ? <Form.Control type="number" placeholder="Enter Answer Here" className="test-answer-numeric" readOnly={true} defaultValue={numericAnswers[question.id]} /> : null}
                              </div> :
                              <div className={(discontinueNumberForSection(category.name, subcategoryIndex, category.subcategories) <= questionIndex) ? 'test-answer-disabled' : ''}>
                                {(startingNumberForSection(category.name, subcategoryIndex, subcategory.questions, true) == questionIndex && (category.name != 'Elision' || subcategoryIndex != 1)) ? <span className="start-indicator">START &#8681;</span> : null}
                                <div className="record-form-answer-group">
                                  <div className="record-form-test-question">
                                    {(questionIndex + questionCountFromPreviousSubcategories(category, subcategoryIndex) + 1)}.
                                  </div>
                                  {question.answers?.map((answer: any) => 
                                    <button className={answers[question.id] == answer.id ? "test-answer-selected": "test-answer"}>
                                      {(answer.answer == "A" || answer.answer == "B" || answer.answer == "C" || answer.answer == "NR") ?
                                      <>
                                        <div className={answer.correct ? 'test-answer-correct' : 'test-answer-incorrect'}><span dangerouslySetInnerHTML={{__html: answer.answer}}></span></div>
                                      </> :
                                      <>
                                        <div className={answer.correct ? 'test-answer-correct' : 'test-answer-incorrect'}>{answerLetterForOrderNumber(answer.order_num)}. <span dangerouslySetInnerHTML={{__html: answer.answer}}></span></div>
                                      </> }
                                    </button>
                                  )}
                                  {question.answers?.length == 0 && selectedSubtest != 'Caregiver Questionnaire' ? <Form.Control type="number" placeholder="Enter Answer Here" className="test-answer-numeric-inline" readOnly={true} defaultValue={numericAnswers[question.id]} /> : null}
                                </div>
                              </div> }
                            </>
                          )}
                        </> : null }
                      </>
                    )}
                  </> : null }
                </>
              )}
              <br /><br />
              <Button onClick={() => setSelectedSubtest(null)}>Close Subtest</Button>
              <br /><br />
            </Card> : null }
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default TestALL;
